$(document).ready(function () {
    if ($(location).attr('href').indexOf('#q4') > 0) {
        $('#q4').addClass('in');
        $('html, body').animate({
            scrollTop: $('#q4').offset().top - 203
        }, 1500);
    }

    $(document).on('click', '.mobile-menu-close', function () {
        $('.mobile-menu-toggle').click();
    });

    if ($(location).attr('href').indexOf('listafinalizaros') > 0) {
        verificaFinalizacaoOs();
    }

    if ($('#frmDocumento, #frmCampanha').length == 1) {
        var $htmlEditor = b64DecodeUnicode($('#descricao').val());
        $('.note-editable').html($htmlEditor);
    }

    if ($('#frmMaterial').length == 1) {
        var $htmlEditorObservacao = b64DecodeUnicode($('#observacao').val());
        $('.observacao-input .note-editable').html($htmlEditorObservacao);
    }

    if ($('#frmModelo').length == 1) {
        var $htmlEditorObservacao = b64DecodeUnicode($('#observacao').val());
        $('.observacao-input .note-editable').html($htmlEditorObservacao);

        var $htmlEditorCaracteristicas = b64DecodeUnicode($('#caracteristicas').val());
        $('.caracteristica-input .note-editable').html($htmlEditorCaracteristicas);

        var $htmlEditorEspecificacoes = b64DecodeUnicode($('#especificacoes').val());
        $('.especificacoes-input .note-editable').html($htmlEditorEspecificacoes);
    }

    if ($('#frmContato, #formEditarContato').length == 1) {
        makeVertenteProblema();
        configuraSelect2Contato();

        $('#frmContato, #formEditarContato').validate({
            rules: {
                empresa: {
                    required: true
                },
                tipo: {
                    required: true
                },
                problemas: {
                    required: true
                },
                material: {
                    required: true
                },
                descricao: {
                    required: true
                },
                lote_fabricacao: {
                    required: true
                }
            },
            messages: {
                material: {
                    required: "Informe um material para o chamado."
                },
                tipo: {
                    required: "Informe o tipo de informação para o chamado."
                },
                canal: {
                    required: "Informe um canal para o chamado."
                },
                empresa: {
                    required: "Informe qual canal de vendas."
                },
                problemas: {
                    required: "Informe qual problema do produto."
                },
                descricao: {
                    required: "Informe uma descrição."
                },
                lote_fabricacao: {
                    required: "Informe o lote de fabricação."
                }
            },
            ignore: ':hidden:not(.summernote),.note-editable.card-block',
            errorPlacement: function (error, element) {
                // Add the `help-block` class to the error element
                //error.addClass("invalid-feedback");
                console.log(element);
                if (element.prop("type") === "checkbox") {
                    error.insertAfter(element.siblings("label"));
                } else if (element.hasClass("summernote")) {
                    error.insertAfter(element.siblings(".note-editor"));
                } else if (element.hasClass("select2-hidden-accessible")) {
                    error.insertAfter(element.siblings(".select2-container"));
                } else {
                    error.insertAfter(element);
                }
            },
            submitHandler: function (form) {
                var $errorNote = false;
                var $errorProblema = false;
                if ($('.text-editor-simples, .text-editor-simples-cliente').summernote('isEmpty')) {
                    $('.note-editor').after('<label id="descricao-error" class="error hidden" for="descricao">Informe a descrição.</label>');
                    $('.note-editor').css({"border-color": "#e74c3c", "border-width": "1px", "border-style": "solid"});
                    $('#descricao-error').removeClass("hidden");
                    $errorNote = true;
                } else {
                    $('.note-editor').css({"border-color": "#eaeaea", "border-width": "1px", "border-style": "solid"});
                    $('#descricao-error').addClass("hidden");
                    $errorNote = false;
                }

                if ($('#problemas').val() == '') {
                    $('#problemas').after('<label id="problemas-error" class="error hidden" for="problemas">Informe o problema do material.</label>');
                    $('#problemas').addClass('error');
                    $('#problemas-error').removeClass("hidden");
                    $errorProblema = true;
                } else {
                    $('#problemas').removeClass('error');
                    $('#problemas-error').addClass("hidden");
                    $errorProblema = false;
                }


                if (!$errorNote && !$errorProblema) {
                    var $formValidate = form.validate().form();

                    if ($formValidate) {
                        form.submit();
                    }
                }

            }
        });

        if (window.location.pathname.indexOf('contato/gerenciador/inserir') != -1 || window.location.pathname.indexOf('contato/gerenciador/editar') != -1) {
            $("#canal").rules('add', {required: true, messages: {required: "Informe um canal para o chamado."}});

            $("#onde_comprou").rules('add', {required: true, messages: {required: "Informe Onde Comprou para o chamado."}});
            $("#cnpj_comprou").rules('add', {required: true, messages: {required: "Informe o CNPJ da Onde Comprou para o chamado."}});

            /*$("#onde_comprou").rules('remove', 'required');
            $("#onde_comprou").removeAttr('required');

            $("#cnpj_comprou").rules('remove', 'required');
            $("#cnpj_comprou").removeAttr('required');*/
        }

        if (window.location.pathname.indexOf('distribuidor/contato/inserir') != -1) {
            $("#lote_fabricacao").rules('remove', 'required');
            $("#lote_fabricacao").removeAttr('required');
        }

        if (window.location.pathname.indexOf('areadocliente/contato/inserir') != -1 || window.location.pathname.indexOf('areadocliente/contato/editar') != -1) {
            $("#marca").rules('add', {required: true, messages: {required: "Informe uma Marca para o chamado."}});
            $("#onde_comprou").rules('add', {required: true, messages: {required: "Informe Onde Comprou para o chamado."}});
            $("#cnpj_comprou").rules('add', {required: true, messages: {required: "Informe o CNPJ da Onde Comprou para o chamado."}});

            $("#lote_fabricacao").rules('remove', 'required');
            $("#lote_fabricacao").removeAttr('required');
        }
    }

    if ($('#form-regra-bonus').length == 1) {
        var $configMixMaterial = {
            attrElement: 'name',
            nameElement: 'material_mix',
            elementDropDownParent: $('.form-group-material-mix'),
            url: "/cadastro/material/materialautocomplete"
        };

        configureSelect2WithAutocomplete($configMixMaterial, false);

        var $configItemMaterial = {
            attrElement: 'name',
            nameElement: 'material_item',
            elementDropDownParent: $('.form-group-familia-item'),
            url: "/cadastro/material/materialautocomplete"
        }
        configureSelect2WithAutocomplete($configItemMaterial, false);
    }

    if ($('#form-avaliacao-regra').length == 1) {
        var $param = $('select[name="regra"]').val().split('|');
        var $apuracao = $param[1];

        loadDatePickerRegra($apuracao);
    }

    if ($('#frmOrdemServico').length == 1) {
        configuraSelect2Os();

        $("#frmOrdemServico").validate({
            rules: {
                material: {
                    required: true
                },
                'defeito[]': {
                    required: true
                },
                tipo: {
                    required: true
                },
                material_identificacao: {
                    required: true
                },
                material_compra_nota: {
                    required: true
                },
                material_compra_data: {
                    required: true
                }
            },
            messages: {
                material: {
                    required: "Informe um material para a OS."
                },
                'defeito[]': {
                    required: "Informe um defeito para a OS."
                },
                tipo: {
                    required: "Informe qual o tipo da ordem de serviço."
                },
                material_identificacao: {
                    required: "Informe qual o lote do material."
                },
                material_compra_nota: {
                    required: "Informe qual a numero da nota fiscal de compra do material."
                },
                material_compra_data: {
                    required: "Informe qual a data de compra do material."
                }
            },
            submitHandler: function (form) {
                var $url = window.url;

                if ($url.indexOf('finalizar') > -1) {
                    var formData = new FormData(form);

                    $.ajax({
                        url: $url,
                        type: 'POST',
                        data: formData,
                        success: function (data) {
                            if (data.status) {
                                swal({
                                    title: "Transaçao realizada com sucesso!",
                                    text: "A ordem de serviço foi enviada para aprovação da fabrica, aguarde os próximos passos!",
                                    type: "success"
                                }, function () {
                                    window.url = undefined;
                                    if (data.url != undefined && data.url != '') {
                                        window.location.href = data.url;
                                    } else {
                                        window.location.reload(true);
                                    }
                                });
                            } else {
                                swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema na finalização da Ordem!", type: "error"});

                                $.each(data.mensagem, function ($key, $message) {
                                    toastr.error($message, 'Transação não pode ser realizada!');
                                });
                            }
                        },
                        error: function (error) {
                            console.log(error);
                            toastr.error('Ocorreu uma falha ao tentar finalizar a Ordem de Serviço!');
                        },
                        cache: false,
                        contentType: false,
                        processData: false,
                        xhr: function () {  // Custom XMLHttpRequest
                            var myXhr = $.ajaxSettings.xhr();
                            if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                                myXhr.upload.addEventListener('progress', function () {
                                    /!* faz alguma coisa durante o progresso do upload *!/
                                }, false);
                            }
                            return myXhr;
                        }
                    });
                } else {
                    var $formValidate = form.validate().form();

                    if ($formValidate) {
                        form.submit();
                    }
                }
            }
        });

        if ($(".nothing-to-show").length == 1) {
            modalEditMaterialRemessa();
        }

        $('.select-defeito').select2({
            dropdownParent: $('.form-group-defeito'),
            lang: 'pt-BR',
            width: '100%'
        });
    }

    if ($('#frmPesquisaDocumentos').length == 1) {
        var $categoria = $('input[name="categoria"]').val();
        if ($categoria !== '') {
            $('#listMenuDocumentos > li[class="active"]').removeClass('active');
            $('#listMenuDocumentos > li').each(function (key, element) {
                if (element.firstChild.attributes['id-categoria'].value == $categoria) {
                    element.classList.add('active');
                }
            });
        }
    }
    
    $(document).on('change', "#categoria", function () {
        var categoria = parseInt($(this).val());
        if(categoria == 1){
            $('.form-group-notificacao').show();
        }else{
            $('.form-group-notificacao').hide();
        }
    });
    
    if ($('#categoria').length == 1) {
        $('#categoria').change();
    }

    if ($('#divEstatisticaPainel').length) {
        var d = new Date();
        var $data = (d.getFullYear()) + '-' + (((d.getMonth() + 1) < 10) ? ('0' + (d.getMonth() + 1)) : (d.getMonth() + 1));
        var $paramsSetor = $('input[name="divisao"]:checked').val();
        var $paramsTipo = $('input[name="mesTrimestre"]:checked').val();
        var $paramsCliente = $('select[id="cliente"]').val();

        if ($paramsCliente !== undefined) {
            getPainel($data, $data, $paramsSetor, $paramsTipo, $paramsCliente);
        }
    }

    if ($('form[id="formPesquisaSeparacaoPecas"]').length == 1) {
        var $config = {
            attrElement: 'id',
            nameElement: 'cliente',
            elementDropDownParent: $('.divSelectCliente'),
            url: "/cadastro/cliente/clienteautocomplete"
        }
        configureSelect2WithAutocomplete($config, false);
    }

    if (window.location.pathname == '/distribuidor/pedido/lista') {
        $.get('/relacionamento/campanha/campanhaspopupcliente', function (data) {
            if (!(data instanceof Object)) {
                console.log(data);
                return false;
            }

            if (data.status) {
                var $keys = Object.keys(data.campanhas);
                showAlertCampanhaPedido(($keys.length - 1), $keys, data.campanhas);
            }
        }).fail(function (error) {
            console.log(error);
        });
    }

    if (window.location.pathname.indexOf('/distribuidor/produto/detalhes') != -1 || window.location.pathname.indexOf('/distribuidor/bonus/detalhes') != -1) {
        $('.table-detalhes-produto').find(".material-quantidade")
            .each(function (index) {
                if (_.isInteger(_.toNumber($(this).attr('p1')))) {
                    $(this).TouchSpin({
                        min: 0,
                        max: _.toNumber($(this).attr('max')),
                        step: _.toNumber($(this).attr('p1')),
                        forcestepdivisibility: 'none'
                    });
                } else {
                    $(this).TouchSpin({step: $(this).attr('p1'), decimals: 2});
                }
            });
    }

    if ($('select[id="identificacao"]').length == 1) {

        var $tipo = $('select[id="identificacao"]').val();
        if ($tipo == 0 || $tipo == 1 || $tipo == 5) {
            $('.consumidor').attr('disabled', 'true');
        } else {
            $('.consumidor').removeAttr('disabled');
        }
    }

    $(document).on('click', ".limpar", function () {
        //classe que limpa o formulario e reenvia o post
        $(':input', '.form-pesquisa').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
        $('#limpar').val(1);
        $('#form-pesquisa').submit();
    });

    $(document).on('click', ".btn-excluir", function () {
        if (confirm("Deseja realmente excluir?") === false) {
            return false;
        }

        window.sessionStorage.removeItem('pedido_recalculado');
    });

    $(document).on('change', ".checkPermissao", function () {
        var xClass = $(this).attr('pai');
        var xLog = JSON.parse($('input[name="log"]').val());

        for (var $i = 0; $i < xLog.length; $i++) {
            if ($(this).val() == xLog[$i].menu) {
                xLog.splice($i, 1);
            }
        }

        $('.' + xClass).each(function (key, element) {
            for (var $j = 0; $j < xLog.length; $j++) {
                if (element.value == xLog[$j].menu) {
                    xLog.splice($j, 1);
                }
            }
        });

        if ($(this).is(':checked')) {
            xLog.push({
                'menu': $(this).val(),
                'enabled': true
            });

            $('.' + xClass).each(function (key, element) {
                xLog.push({
                    'menu': element.value,
                    'enabled': true
                });

                this.checked = true;
            });
        } else {
            xLog.push({
                'menu': $(this).val(),
                'enabled': false
            });

            $('.' + xClass).each(function (key, element) {
                xLog.push({
                    'menu': element.value,
                    'enabled': false
                });

                this.checked = false;
            });
        }

        $('input[name="log"]').val(JSON.stringify(xLog));
    });

    $(document).on('click', '.btn-trocar-cliente', function () {
        $('#modalEscolhaCliente').modal({show: true, backdrop: 'static'}).on('shown.bs.modal', function () {
            $('#form-change-cliente select[id="cliente"]').select2({
                lang: 'pt-BR',
                width: '100%',
                dropdownParent: $('.form-group-trocar-cliente')
            });

            var $url = window.location.pathname;
            $('#form-change-cliente input[name="url"]').val($url)
        });
    });

    $(document).on('click', ".btn-relacao-pai-filho", function (e) {
        e.preventDefault();

        var $materialPai = $(this).attr('material-pai');

        $.post('/cadastro/material/listarelacionamento', {materialPai: $materialPai}, function (dataRelacionamento) {
            $('#selectFilhoRelacionamento').html('');

            $('#selectFilhoRelacionamento').select2({
                language: "pt-BR",
                allowClear: true,
                width: 'resolve',
                data: dataRelacionamento.data,
                multiple: true
            });

            $('#modalRelacionamentoPaiFilho')
                .modal({backdrop: 'static', show: true})
                .on('shown.bs.modal', function () {
                    $('.select2-search__field').css('width', '100%');
                })
                .on('hidden.bs.modal', function () {
                    $(this).data('bs.modal', null);
                });

            $('#materialPaiText').html('Material Pai: ' + dataRelacionamento.materialPai.descricao)
            $('#inputPai').val(dataRelacionamento.materialPai.id);
        }).done(function () {

        }).fail(function (error) {

        });
    });

    $(document).on('click', '.btn-campanha-item', function () {
        var $bonificacao = $(this).attr('bonificacao');

        $('#campanhaItem').modal('show').on('shown.bs.modal', function () {
            var $config = {
                attrElement: 'name',
                nameElement: 'material',
                elementDropDownParent: $('.form-group-material'),
                url: "/cadastro/material/materialautocomplete"
            }
            configureSelect2WithAutocomplete($config, false);

            $('input[name="bonificacao"]').val($bonificacao);
        });
    });

    $(document).on('submit', '#frmDocumento, #frmCampanha', function () {
        var $htmlDescricao = $('.note-editable').html();
        $('#descricao').val(b64EncodeUnicode($htmlDescricao));
    });

    $(document).on('change', ".image-resumo", function () {
        readURL(this);
    });

    $(document).on('submit', '#frmModelo', function (e) {
        try {
            var $htmlObservacao = $('.observacao-input .note-editable').html();
            $('#observacao').val(b64EncodeUnicode($htmlObservacao));

            var $htmlCaracteristica = $('.caracteristica-input .note-editable').html();
            $('#caracteristicas').val(b64EncodeUnicode($htmlCaracteristica));

            var $htmlEspecificacoes = $('.especificacoes-input .note-editable').html();
            $('#especificacoes').val(b64EncodeUnicode($htmlEspecificacoes));
        } catch (error) {
            e.preventDefault();
            toastr.error('Ocorreu um problema ao codificar as informações de caracteristica e especificações!<br>Error: ' + error, 'Transação não realizada!')
            console.log(error);
        }
    });

    $(document).on('click', ".btn-relacionamento-campanha-cliente", function (e) {
        e.preventDefault();

        var $campanha = $(this).attr('campanha');

        $.post('/relacionamento/campanha/listarelacionamentocampanhacliente', {campanha: $campanha}, function (dataRelacionamento) {
            var $eventSelect = $("#selectCampanhaCliente");

            if (dataRelacionamento.data.length > 0) {
                var $optionSelect = '';
                $.each(dataRelacionamento.data, function (key, valueItem) {
                    $optionSelect += '<option value="' + valueItem.id + '" selected>' + valueItem.text + '</option>'
                });

                $eventSelect.html($optionSelect);
            } else {
                $eventSelect.html('');
            }

            var $config = {
                attrElement: 'id',
                nameElement: 'selectCampanhaCliente',
                elementDropDownParent: $('.group-select-cliente'),
                url: "/cadastro/cliente/clienteautocomplete"
            }
            configureSelect2WithAutocomplete($config, false);

            $('#modalRelacionamentoCampanhaCliente')
                .modal({backdrop: 'static', show: true})
                .on('shown.bs.modal', function () {
                    $('.select2-search__field').css('width', '100%');
                })
                .on('hidden.bs.modal', function () {
                    $(this).data('bs.modal', null);
                });

            $('#campanhaText').html(dataRelacionamento.campanha.descricao)
            $('#inputCampanha').val(dataRelacionamento.campanha.id);
        }).done(function () {

        }).fail(function (error) {

        });
    });

    $(document).on('click', ".add-anexo", function () {
        var $obj = $(this);

        var $id1 = parseInt($obj.attr('itemscope'));
        var $id2 = $id1 + 1;

        var $print = '';
        var $div = $obj.parent().parent();
        var $divCol = $div.attr('col');
        if ($divCol != undefined && $divCol != null) {
            $print += '<div class="col-' + $divCol + '">';
        }

        $print += $div.attr('class') == 'stats-row m' ? '<div class="stats-row m" col="' + $divCol + '">' + $div.html() + '</div>' : '<div class="form-group">' + $div.html() + '</div>';

        if ($divCol != undefined && $divCol != null) {
            $print += '</div>';
        }
        $print = replaceAll($print, 'anexo' + $id1, 'anexo' + $id2);
        $print = replaceAll($print, 'itemscope="' + $id1 + '"', 'itemscope="' + $id2 + '"');
        $print = replaceAll($print, '+1 Arquivo Adicionado', 'Adicionar Arquivo');
        $print = replaceAll($print, '+1 Imagem Adicionada', 'Adicionar Imagem');

        $obj.remove();
        $div.after($print);
    });

    $(document).on('click', ".add-contato-condominio", function () {
        var $obj = $(this);

        var $id1 = parseInt($obj.attr('itemscope'));
        var $id2 = $id1 + 1;

        var $print = '';
        var $div = $obj.parent().parent().parent();
        var $divCol = $div.attr('col');
        if ($divCol != undefined && $divCol != null) {
            $print += '<div class="col-' + $divCol + '">';
        }

        $print += $div.attr('class') == 'stats-row-condominio m' ? '<div class="stats-row-condominio m" col="' + $divCol + '">' + $div.html() + '</div>' : '<div class="form-group">' + $div.html() + '</div>';

        if ($divCol != undefined && $divCol != null) {
            $print += '</div>';
        }
        $print = replaceAll($print, 'contato' + $id1, 'contato' + $id2);
        $print = replaceAll($print, 'itemscope="' + $id1 + '"', 'itemscope="' + $id2 + '"');
        $print = replaceAll($print, '+1 Arquivo Adicionado', 'Adicionar Arquivo');
        $print = replaceAll($print, '+1 Imagem Adicionada', 'Adicionar Imagem');

        $obj.remove();
        $div.after($print);
    });

    $(document).on('change', 'input[type="file"]', function (e) {
        if ($(this).prop('files').length > 0) {
            var $id = $(this).attr('id');
            if ($('label[for="' + $id + '"]').html().indexOf('image') > -1) {
                $('label[for="' + $id + '"]').html('').html('<i class="fa fa-image"></i> +1 Imagem Adicionada')
            } else {
                $('label[for="' + $id + '"]').html('').html('<i class="fa fa-paperclip"></i> +1 Arquivo Adicionado')
            }
        }
    });

    $(document).on('blur', ".busca-cep", function () {

        var $cep = $(this).val().replace(/\D/g, '');
        var $load = $('.loading-cep');

        if ($cep != "") {
            var validacep = /^[0-9]{8}$/;
            if (validacep.test($cep)) {
                console.log($cep);
                $load.toggle();

                $.getScript('https://cep.onclick.com.br/?encode=utf8&sigla=1&cep=' + $cep, function () {
                    console.log(resultadoCEP);
                    if (resultadoCEP["resultado"]) {
                        $("input[name='logradouro']").val(resultadoCEP["logradouro"]);
                        $("input[name='bairro']").val(resultadoCEP["bairro"]);
                        $("input[name='cidade']").val(resultadoCEP["cidade"]);
                        $("input[name='estado']").val(resultadoCEP["uf"]);
                        $("select[name='estado']").val(resultadoCEP["uf"]);
                        $("input[name='pais']").val('BRASIL');
                        $("input[name='numero']").focus();

                        $load.toggle();
                    } else {
                        $load.attr('style','display:none')
                        // $load.toggle();
                        $("input[name='logradouro']").focus();
                        toastr.error('CEP não encontrado.');
                        toastr.error('Digite o enderço por completo');
                    }
                }).fail(function (error) {
                    console.log(error);

                    $load.toggle(); 
                    $("input[name='cep']").focus();
                    toastr.error('Não foi possível buscar o CEP no momento.');
                });
            } else {
                $load.toggle();
                $("input[name='cep']").focus();
                toastr.error('Formato de CEP inválido.');
            }
        }
    });

    $(document).on('keyup', ".buscaMateriaDescricao", function () {
        var $descricao = $(this).val();

        console.log($descricao.length);
        if ($descricao.length > 5) {
            $('#material-pesquisa-cd').submit();
        }
    });

    $(document).on('keyup', ".buscaMateriaCodigo", function () {
        var $codigo = $(this).val();

        if ($codigo.length == 8) {
            $('#material-pesquisa-cd').submit();
        }
    });

    $(document).on('keyup', ".buscaPorCodigoKeyup", function () {

        var $codigo = $(this).val().replace(/\D/g, '');
        if ($codigo.length == 8) {
            $('#material-pesquisa-cd').submit();
        }
    });

    $(document).on("click", ".cadastro-cliente-usuario-incluir", function ($e) {
        $e.preventDefault();

        $(".c-status").hide();
        $('#cadastro-cliente-usuario input').not("input[name='cliente']").val('');
        $(".c-permissao").removeAttr('checked').parent().removeClass('checked');

        $('#inclusaoDeUsuario').modal('show').on('shown.bs.modal', function () {
            var $config = {
                attrElement: 'id',
                nameElement: 'selectUsuario',
                elementDropDownParent: $('.form-group-usuario'),
                url: "/acesso/usuario/distribuidorautocomplete"
            }
            configureSelect2WithAutocomplete($config, false);
        });
    });

    $(document).on("click", ".cadastro-cliente-usuario-editar", function () {

        var $cliente = $(this).attr('data-cliente');
        var $id = $(this).attr('data-id');
        var $bt = '#btn' + $id;
        $($bt).ladda();
        $($bt).ladda('start');

        var $c1 = $("input[name='nome']").val('');
        var $c2 = $("input[name='telefone']").val('');
        var $c3 = $("input[name='celular']").val('');
        var $c4 = $("input[name='email']").val('');
        var $c5 = $("input[name='usuario']").val('');
        var $c6 = $("select[name='status']").removeAttr('selected');
        var $c7 = $("input[name='cargo']").val('');
        var $c8 = $("input[name='aniversario']").val('');
        var $c9 = $("select[name='usuario_padrao']").removeAttr('selected');

        $(".c-status").show();
        $(".c-permissao").removeAttr('checked').parent().removeClass('checked');
        $(".tab-usuario-existente").addClass('disabled');


        $.get("/acesso/usuario/usuarioalteracao/" + $id + '/' + $cliente, function (resp) {

            $('#inclusaoDeUsuario').modal('show');

            if (resp['count'] == 1) {
                $c1.val(resp["nome"]);
                $c2.val(resp["telefone"]);
                $c3.val(resp["celular"]);
                $c4.val(resp["email"]);
                $c5.val($id);
                $c6.val(resp["status"]);
                $c7.val(resp["cargo"]);
                $c8.val(resp["aniversario"]);
                $c9.val(resp["usuario_padrao"]);

                $.each(resp['permissao'], function (i, item) {

                    if (item['pedido'] == 1) {
                        $("#pe" + i).prop("checked", true).parent().addClass('checked');
                    }

                    if (item['os'] == 1) {
                        $("#os" + i).prop("checked", true).parent().addClass('checked');
                    }

                    if (item['bonus'] == 1) {
                        $("#bo" + i).prop("checked", true).parent().addClass('checked');
                    }

                    if (item['meta'] == 1) {
                        $("#me" + i).prop("checked", true).parent().addClass('checked');
                    }
                });
            }

            $($bt).ladda('stop');
        }, "JSON");

    });

    $(document).on("click", ".cadastro-cliente-usuario-close-modal", function () {

        $(".tab-usuario-existente").removeClass('disabled');
    });

    $(document).on("click", ".tab-100", function () {

        $("input[name='nome'], input[name='celular'], input[name='cargo'], input[name='aniversario'], input[name='email']").removeAttr('required');
    });

    $(document).on("click", ".tab-200", function () {

        $("input[name='nome'], input[name='celular'], input[name='cargo'], input[name='aniversario'], input[name='email']").removeAttr('required');
    });

    $(document).on("click", ".toRecover", function ($e) {
        $e.preventDefault();

        $('.email-recover').val($("input[name='username']").val());
        $('#toRecover').modal('show');
    });

    $(document).on('submit', '#form-recover', function ($e) {
        $e.preventDefault();

        var $bt = '.button-recover';

        $($bt).ladda();
        $($bt).ladda('start');

        var $email = $('.email-recover').val();
        var $url = '/recovery/' + $email;

        $.get($url, function (data) {
            if (data['status']) {
                toastr.success('Sucesso!', data['message']);
                $('#toRecover').modal('hide');

            } else {
                toastr.error('Falha', data['message']);
            }

            $($bt).ladda('stop');

        }, "JSON");

        $($bt).disable();
    });

    $(document).on("click", ".process-recover", function ($e) {
        $e.preventDefault();

        var $bt = $(this);

        $bt.ladda();
        $bt.ladda('start');

        var $email = $bt.attr('data-email');
        var $url = '/recovery/' + $email;

        $.get($url, function (data) {
            if (data['status']) {
                toastr.success('Sucesso!', data['message']);
            } else {
                toastr.error('Falha', data['message']);
            }

            $bt.ladda('stop');

        }, "JSON");

        $bt.disable();
    });

    $(document).on("click", ".toRegister", function ($e) {
        $e.preventDefault();

        $('#toRegister').modal('show');
    });

    $(document).on('submit', '#form-register', function ($e) {
        $e.preventDefault();

        var $bt = '.button-register';

        $($bt).ladda();
        $($bt).ladda('start');

        $.post("/acesso/cliente", $("#form-register").serialize())
            .done(function (data) {

                if (data['status']) {
                    toastr.success('Sucesso!', data['message']);
                    $('#toRegister').modal('hide');
                    setTimeout(function () {
                        window.location = data['login']['url'];
                    }, 3000);

                } else {
                    $($bt).ladda('stop');
                    toastr.error('Falha', "Houve uma falha ao acessar como cliente. Erro: " + data['message']);
                }
            })
            .fail(function () {

                $($bt).ladda('stop');
            }, "JSON");

        $($bt).disable();
    });

    $(document).on('submit', '#material-pesquisa-cd', function ($e) {
        $e.preventDefault();
        var $bt = '.btn-pesquisa';
        var $form = $(this);
        $($bt).ladda();
        $($bt).ladda('start');

        $('#buscaMateriaDescricao').removeClass('buscaMateriaKeyup');
        $('#buscaMateriaDescricao').addClass('disabled');

        $.ajax({type: $form.attr('method'), url: $form.attr('action'), data: $form.serialize(), datatype: 'json'})
            .done(function (data) {
                if (data['status']) {

                    $('#retorno-busca-cd')
                        .html('')
                        .html(data['html'])
                        .find(".material-quantidade")
                        .each(function (index) {
                            if (_.isInteger(_.toNumber($(this).attr('p1')))) {
                                $(this).TouchSpin({
                                    min: 0,
                                    max: _.toNumber($(this).attr('max')),
                                    step: _.toNumber($(this).attr('p1')),
                                    forcestepdivisibility: 'none'
                                });
                            } else {
                                $(this).TouchSpin({step: $(this).attr('p1'), decimals: 2});
                            }
                        });
                } else {
                    toastr.info('Nada para mostrar!');
                }
            })
            .complete(function () {
                $($bt).ladda('stop');

                $('#buscaMateriaDescricao').addClass('buscaMateriaKeyup');
                $('#buscaMateriaDescricao').removeClass('disabled');
            });
    });

    $(document).on('touchspin.on.startupspin', '.material-quantidade', function (e) {
        var $mult = _.toNumber($(this).attr('multiplo'));
        var $min = _.toNumber($(this).attr('minimo'));
        var $val = _.toNumber($(this).val());

        if ($val == $mult) {
            $(this).val($min);
        }
    });

    $(document).on('touchspin.on.startdownspin', '.material-quantidade', function (e) {
        var $mult = _.toNumber($(this).attr('multiplo'));
        var $min = _.toNumber($(this).attr('minimo'));
        var $val = _.toNumber($(this).val());

        if ($val <= $min) {
            $(this).val($min);
        }
    })

    $(document).on('click', '.link-shop', function ($e) {
        var $aUrl = window.location.href.split('/');
        var $tipo = $(this).attr('tipo');
        var $id = (($(this).attr('id') == undefined || $(this).attr('id') == null) ? 0 : $(this).attr('id'));

        if ($tipo == 'direto') {
            if (!$(this).hasClass('check')) {
                $(this).addClass('check');
                $(this).children('.header-btns-icon').html('').html('<i class="fa fa-check fa-2x m-t-xs text-success"></i>');

                $id = 1;
            } else {
                $(this).removeClass('check');
                $(this).html('').html('<i class="fa fa-exchange text-success"></i>');
            }
        }

        if ($tipo == 'marketing') {
            if (!$(this).hasClass('check')) {
                $(this).addClass('check');
                $(this).children('.header-btns-icon').html('').html('<i class="fa fa-check fa-2x m-t-xs text-success"></i>');

                $id = 1;
            } else {
                $(this).removeClass('check');
                $(this).html('').html('<i class="fa fa-gift text-success"></i>');
            }
        }

        var $url = '/' + $aUrl[3] + '/' + $aUrl[4] + '/addfiltros/' + $tipo + '/' + $id;
        $.get($url, function (data) {
            if (data.status) {
                window.location.href = '/' + $aUrl[3] + '/' + $aUrl[4] + '/lista';
            } else {
                $.each(data.mensagens, function ($key, $item) {
                    toastr.warning($item, 'ATENÇÃO!');
                });
            }
        }).fail(function (error) {
            console.log(error);
            toastr.error('Não foi possível adicionar o filtro da pesquisa!', 'Transação não realizada!');
        });
    });

    $(document).on('keydown', 'form[name="frmPesquisaDocumentos"] > input[name="nome"]', function ($e) {
        if ($e.keyCode == 13) {
            $('.btn-pesquisar-documentos').trigger('click');
        }
    });

    $(document).on('click', '.btn-remove-pesquisa-produto', function () {
        var $aUrl = window.location.href.split('/');
        var $url = '/' + $aUrl[3] + '/' + $aUrl[4] + '/removefiltropesquisa';
        $.get($url, function (data) {
            if (data.status) {
                window.location.href = '/' + $aUrl[3] + '/' + $aUrl[4] + '/lista';
            } else {
                $.each(data.mensagens, function ($key, $item) {
                    toastr.warning($item, 'ATENÇÃO!');
                });
            }
        }).fail(function (error) {
            console.log(error);
            toastr.error('Não foi possível remover o filtro da pesquisa!', 'Transação não realizada!');
        });
    });

    $(document).on('click', '.view-details', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $hasTipo = $(this).attr('has-tipo');
        var $url = $(this).attr('href');
        var $saldoDireto = $('#saldoDireto').html();
        var $saldoMarketing = $('#saldoMarketing').html();


        if ($hasTipo == 'false') {
            swal({title: "ATENÇÃO!", text: "Para iniciar a compra clique sobre um dos saldos diponíveis Direto ou Marketing!", type: "warning"});

            return false;
        }

        if ($saldoDireto == 'R$ 0,00' && $saldoMarketing == 'R$ 0,00') {
            swal({title: "ATENÇÃO!", text: "Saldo insuficiente para adquirir itens de bonificação", type: "warning"});

            return false;
        }

        window.location.href = $url;
    });

    $(document).on("click", ".btn-add-material", function ($e) {
        $e.preventDefault();
        window.sessionStorage.removeItem('pedido_recalculado');
        var $form = $('#material-inclusao-cd');

        $.ajax({type: 'POST', url: '/distribuidor/pedido/quantidademultiplo', data: $form.serialize(), datatype: 'json'})
            .done(function (data) {
                if (data.status) {
                    console.log(data);
                    $form.submit();
                    $("input[name='isupdateitem']").val('');
                } else {
                    $.each(data.mensagem, function (key, item) {
                        toastr.warning(item, 'Verifique as quantidades!');
                    });
                    $("input[name='isupdateitem']").val('');
                }
            })
            .fail(function (error) {
                console.log(error);
                toastr.error("Houve um problema ao validar as quantidades dos itens!", "Não foi possível realizar a transação!");
            });
    });

    $(document).on("click", ".btn-edi-material", function ($e) {
        $e.preventDefault();
        window.sessionStorage.removeItem('pedido_recalculado');
        $('#addItem').modal('show');

        $e.preventDefault();
        var $bt = '.btn-pesquisa';
        var $id = $(this).attr('itemid');
        var $url = '/cadastro/material/buscacd/' + $id;

        $($bt).ladda();
        $($bt).ladda('start');
        $("input[name='isupdateitem']").val($id);

        $.ajax({type: 'get', url: $url, datatype: 'json'})
            .done(function (data) {
                if (data['status']) {

                    $('#retorno-busca-cd')
                        .html('')
                        .html(data['html'])
                        .find(".material-quantidade")
                        .each(function (index) {
                            if (_.isInteger(_.toNumber($(this).attr('p1')))) {
                                $(this).TouchSpin({
                                    min: 0,
                                    max: _.toNumber($(this).attr('max')),
                                    step: _.toNumber($(this).attr('p1')),
                                    forcestepdivisibility: 'none'
                                });
                                //$(this).TouchSpin({step: _.toNumber($(this).attr('p1')), forcestepdivisibility: 'none'});
                            } else {
                                $(this).TouchSpin({step: $(this).attr('p1'), decimals: 2});
                            }
                        });
                } else {
                    toastr.info('Nada para mostrar!');
                }
            })
            .complete(function () {
                $($bt).ladda('stop');
            });
    });

    $(document).on('click', '.btn-excluir-imagem-produto', function () {
        var $id = $(this).attr('id');

        swal({
                html: true,
                title: "Deseja continuar mesmo assim?",
                text: "A imagem do produto será excluída permanentemente!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.get('/cadastro/material/excluirimagemproduto/' + $id, function (data) {
                        if (data.status) {
                            toastr.success('Imagem excluida com sucesso!', 'Transação realizada com sucesso!');
                            swal({title: "Transaçao realizada com sucesso!", text: "O arquivo anexado foi excluído com sucesso!", type: "success"}, function () {
                                window.location.href = data.url;
                            });
                        }
                    }).fail(function (error) {
                        swal("Ops... :(", "Ocorreu um problema ao tentar excluir a imagem do produto. Erro: " + error.statusText, "error");
                    });
                }
            }
        );
    });

    $(document).on('change', 'select[id="identificacao"]', function () {
        var $tipo = $(this).val();
        if ($tipo == 0 || $tipo == 1 || $tipo == 5) {
            $('.consumidor').attr('disabled', 'true');
            $('.visualiza-condominio').addClass('hidden');
        } else if ($tipo == 6) {
            $('.visualiza-condominio').removeClass('hidden');
            $('.consumidor').removeAttr('disabled');
        } else {
            $('.visualiza-condominio').addClass('hidden');
            $('.consumidor').removeAttr('disabled');
        }
    });

    $(document).on('change', '.select-marca-cliente', function () {
        var $marca = $(this).val();
        var $url = '/areadocliente/contato/getlinha/' + $marca;

        $.ajax({type: 'get', url: $url, datatype: 'json'})
            .done(function (data) {
                if (data.status) {
                    $('.group-linha').removeClass('hidden');
                    $(".select-linha-cliente").prop('disabled', false);
                    $(".select-linha-cliente").html(data['html']);

                    $(".select-linha-cliente").rules('add', {required: true, messages: {required: "Informe uma Linha para o chamado."}});
                }
            });
    });

    $(document).on('change', '.select-marca-problema', function () {
        var $marca = $(this).val();
        var $url = '/contato/problema/getlinha/' + $marca;
        $(".select-linha-problema").html('<option value=""></option>');
        $.ajax({type: 'get', url: $url, datatype: 'json'})
            .done(function (data) {
                if (data.status) {
                    $(".select-linha-problema").removeAttr('disabled').html(data['html']);
                }
            });
    });

    $(document).on('change', '.select-linha-cliente', function () {
        var $marca = $('.select-marca-cliente').val();
        var $linha = $(this).val();
        var $url = '/areadocliente/contato/getmodelo/' + $marca + '/' + $linha;

        $.ajax({type: 'get', url: $url, datatype: 'json'})
            .done(function (data) {
                if (data.status) {
                    $('.group-modelo').removeClass('hidden');
                    $(".select-modelo-cliente").prop('disabled', false);
                    $(".select-modelo-cliente").html(data['html']);

                    $(".select-modelo-cliente").rules('add', {required: true, messages: {required: "Informe uma Modelo para o chamado."}});
                }
            });
    });

    $(document).on('change', '.select-marca-relatorio', function () {
        var $marca = $(this).val();
        var $url = '/relatorios/assistencia/getlinha/' + $marca;

        $.ajax({type: 'get', url: $url, datatype: 'json'})
            .done(function (data) {
                if (data.status) {
                    $('.group-linha').removeClass('hidden');
                    $(".select-linha-relatorio").prop('disabled', false);
                    $(".select-linha-relatorio").html(data['html']);

                    $(".select-linha-relatorio").rules('add', {required: true, messages: {required: "Informe uma Linha para o chamado."}});
                }
            });
    });

    $(document).on('change', '.select-linha-relatorio', function () {
        var $marca = $('.select-marca-relatorio').val();
        var $linha = $(this).val();
        var $url = '/relatorios/assistencia/getmodelo/' + $marca + '/' + $linha;

        $.ajax({type: 'get', url: $url, datatype: 'json'})
            .done(function (data) {
                if (data.status) {
                    $('.group-modelo').removeClass('hidden');
                    $(".select-modelo-relatorio").prop('disabled', false);
                    $(".select-modelo-relatorio").html(data['html']);

                    $(".select-modelo-relatorio").rules('add', {required: true, messages: {required: "Informe uma Modelo para o chamado."}});
                }
            });
    });

    $(document).on('blur', ".busca-consumidor", function () {

        var $cpf = $(this).val().replace(/\D/g, '');
        var $load = $('.loading-consumidor');

        if ($cpf != "") {

            $load.toggle();
            var $url = '/cadastro/consumidor/cpf/' + $cpf;
            $.ajax({type: 'get', url: $url, datatype: 'json'})
                .done(function (data) {
                    if (data['status']) {
                        var $contato = data['contato'];
                        if($contato !== null){
                            $('.visualiza-condominio-existentes').removeClass('hidden').html('').html($contato)
                        }

                        var $d = data['dados'];
                        function logArrayElements(element) {
                            var $input = element;
                            var $value = $d[element];

                            if (element == 'id') {
                                $input = 'consumidor';
                            }
                            if (element == 'cep') {
                                $value = $value.substr(0, 5) + '-' + $value.substr(5, 3);
                            }
                            if (element == 'aniversario') {
                                var data = new Date($d[$input]);
                                $value = ("0" + data.getDate()).substr(-2) + "/" + ("0" + (data.getMonth() + 1)).substr(-2) + "/" + data.getFullYear();
                            }

                            $("[name='" + $input + "']").val($value);
                        }

                        var $c = ['id', 'nome', 'celular', 'telefone', 'email', 'aniversario', 'cep', 'logradouro', 'numero', 'complemento', 'bairro', 'cidade', 'estado', 'identificacao', 'contato_nome_1', 'contato_funcao_1', 'contato_telefone_1', 'contato_id_1', 'contato_nome_2', 'contato_funcao_2', 'contato_telefone_2', 'contato_id_2', 'contato_nome_3', 'contato_funcao_3', 'contato_telefone_3', 'contato_id_3',];
                        $c.forEach(logArrayElements);

                    } else {
                        toastr.info('Consumidor não localizado, por favor realize o cadastro.');
                    }
                })
                .complete(function () {
                    $load.toggle();
                });
        }
    });

    $(document).on('shown.bs.collapse', '#mobile-collapse', function (e) {
        var $divToogle = $('#mobile-collapse');
        $divToogle.css({'overflow:': 'scroll', 'height': '500px'});

    });

    $(document).on("click", ".btn-contato-add-interacao", function ($e) {
        $e.preventDefault();

        var $f = $('#form-contato-interacao'),
            $d = $f.serializeArray(),
            $r = true;

        $.each($d, function (i, field) {
            //console.log(field.name + ":" + field.value + " ");
            if (field.name == 'descricao' && !field.value.replace(/\s/g, '').length) {
                toastr.error('O campo descrição é obrigatório.');
                $r = false;
            }
            if (field.name == 'id' && field.value <= 0) {
                toastr.error('Não foi possível localizar o código do contato, atualize a pagina e tente novamete.');
                $r = false;
            }
        });

        if ($r === true) {

            $f.submit();
        }
    });

    $(document).on("click", ".btn-contato-add-transferir", function ($e) {
        $e.preventDefault();

        var $f = $('#form-contato-transferir'),
            $d = $f.serializeArray(),
            $r = true;

        $.each($d, function (i, field) {
            if (field.name == 'id' && field.value <= 0) {
                toastr.error('Não foi possível localizar o código do contato, atualize a pagina e tente novamete.')
                $r = false;
            }

            if (field.name == 'responsavel' && field.value <= 0) {
                toastr.error('Escolha um novo responsável!')
                $r = false;
            }
        });

        if ($r === true) {

            $f.submit();
        }
    });

    $(document).on("click", ".btn-contato-add-encerrar", function ($e) {
        $e.preventDefault();

        var $f = $('#form-contato-encerrar'),
            $d = $f.serializeArray(),
            $r = true,
            $bt = '.btn-contato-add-encerrar';
        $text = '';

        $($bt).ladda();
        $($bt).ladda('start');
        $.each($d, function (i, field) {
            if (field.name == 'descricao' && !field.value.replace(/\s/g, '').length) {
                toastr.error('O campo descrição é obrigatório.');
                $r = false;
                $($bt).ladda('stop');
            }
            if (field.name == 'id' && field.value <= 0) {
                toastr.error('Não foi possível localizar o código do contato, atualize a pagina e tente novamete.');
                $r = false;
                $($bt).ladda('stop');
            }

            if (field.name == 'solucao' && field.value <= 0) {
                toastr.error('Escolha a Solução aplicavél!');
                $r = false;
                $($bt).ladda('stop');
            }

            if (field.name == 'reposicao_pecas' && field.value.length > 0) {
                $text = (field.value == 't' ? 'O encerramento do chamado <b>IRÝ GERAR</b> uma ordem de reposição de peças!' : 'O encerramento do chamado <b>NÃO IRÝ GERAR</b> uma reposição de peças!');
            }
        });

        if ($r === true) {

            swal({
                    html: true,
                    title: "Deseja continuar mesmo assim?",
                    text: $text,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Sim, desejo!",
                    cancelButtonText: "Não, cancele!",
                    closeOnConfirm: false,
                    closeOnCancel: true,
                    showLoaderOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        $f.submit();
                    } else {
                        $($bt).ladda('stop');
                    }
                }
            );
        }
    });

    $(document).on('submit', '#distribuidor-assistencia-defeito', function ($e) {
        $e.preventDefault();
        var $bt = '.btn-distribuidor-assistencia-defeito';
        var $form = $(this);
        $($bt).ladda();
        $($bt).ladda('start');

        $.ajax({type: $form.attr('method'), url: $form.attr('action'), data: $form.serialize(), datatype: 'json'})
            .done(function (data) {
                if (data['status']) {

                    $('#retorno-distribuidor-assistencia-defeito')
                        .html('')
                        .html(data['html']);
                } else {

                }
            })
            .complete(function () {
                $($bt).ladda('stop');
                $('#addDefeito').modal('hide');
            });
    });

    $(document).on('submit', '#form-pesquisa-painel', function (e) {
        e.preventDefault();

        var $typeData = $('.divMes').hasClass('hidden') ? 'trimestre' : 'mesAno';
        var $dataIni = '';
        var $dataFim = '';
        var $paramsSetor = $('input[name="divisao"]:checked').val();
        var $paramsTipo = $('input[name="mesTrimestre"]:checked').val();
        var $paramsClientes = $('select[id="distribuidor"]').select2("val");
        var $paramDataIni = '';
        var $paramDataFim = '';

        if ($typeData == 'mesAno') {
            $paramDataIni = $('input[name="inicio_mes"]').val();
            $paramDataFim = $('input[name="final_mes"]').val();

            if ($paramDataIni == '' || $paramDataFim == '') {
                toastr.error('Informe os paramêtros de data inicio e fim para continuar!', 'Transação não pode ser realizada!');
                return false;
            }

            var $dataInputIni = $('input[name="inicio_mes"]').val().split('/');
            var $dataInputFim = $('input[name="final_mes"]').val().split('/');
            $dataIni = $dataInputIni[1] + '-' + $dataInputIni[0];
            $dataFim = $dataInputFim[1] + '-' + $dataInputFim[0];
        } else {
            $paramDataIni = $('input[name="inicio_trimestre"]').val();
            $paramDataFim = $('input[name="final_trimestre"]').val();

            if ($paramDataIni == '' || $paramDataFim == '') {
                toastr.error('Informe os paramêtros de semestre inicio e fim para continuar!', 'Transação não pode ser realizada!');
                return false;
            }

            var $dataInputIni = $('input[name="inicio_trimestre"]').val().split('/');
            var $dataInputFim = $('input[name="final_trimestre"]').val().split('/');
            $dataIni = $dataInputIni[0].replace('º', '') + '/' + $dataInputIni[1];
            $dataFim = $dataInputFim[0].replace('º', '') + '/' + $dataInputFim[1];
        }

        getPainel($dataIni, $dataFim, $paramsSetor, $paramsTipo, $paramsClientes);
        $('#modalPesquisa').modal('hide');
        $('.divFiltrosPainel').html('').html('<h3>Filtros:</h3><p><strong>Empresa: </strong>' + $('input[name="divisao"]:checked').next('label').text() + '</p><p><strong>Mês/Trimestre: </strong>' + $('input[name="mesTrimestre"]:checked').next('label').text() + '</p><p><strong>De: </strong>' + $paramDataIni + '<strong> Até </strong>' + $paramDataFim + '</p>');
        $('#divParentGraficoPedidosFaturados').css({
            position: 'relative',
            height: '67vh'
        });
    });

    $(document).on('submit', '#distribuidor-assistencia-peca', function ($e) {
        $e.preventDefault();
        var $bt = '.btn-distribuidor-assistencia-peca';
        var $form = $(this);
        $($bt).ladda();
        $($bt).ladda('start');

        $.ajax({type: $form.attr('method'), url: $form.attr('action'), data: $form.serialize(), datatype: 'json'})
            .done(function (data) {
                if (data['status']) {

                    $('#retorno-distribuidor-assistencia-peca').html('').html(data['html']);
                } else {

                    data['mensagem'].forEach(function (name) {
                        toastr.error(name)
                    });
                }
            })
            .complete(function () {
                $($bt).ladda('stop');
                $('#addPecaEstrutura').modal('hide');
            });
    });

    $(document).on('submit', '#form-relacao-problema-linha', function ($e) {
        $e.preventDefault();
        var $bt = '.btn-relacao-problema-linha';
        var $lista = $('#lista-relacao-problema');
        var $form = $(this);
        $($bt).ladda();
        $($bt).ladda('start');
        $lista.addClass('whirl double-up');

        $.ajax({type: $form.attr('method'), url: $form.attr('action'), data: $form.serialize(), datatype: 'json'})
            .done(function (data) {
                if (data['status']) {

                    $lista.html('').html(data['html']);
                    $('#marca option:first').prop('selected', true);
                    $('#linha').html('<option value=""></option>').attr('disabled', 'disabled');
                } else {
                    data['mensagem'].forEach(function (name) {
                        toastr.error(name)
                    });
                }
            })
            .complete(function () {
                $($bt).ladda('stop');
                $lista.removeClass('whirl double-up');
            });
    });

    $(document).on('click', ".btn-remove-relacao-problema-linha", function ($e) {
        $e.preventDefault();
        if (confirm("Deseja realmente excluir?") === false) {
            return false;
        }

        var $bt = $(this);
        var $id = $bt.attr('itemid');
        var $lista = $('#lista-relacao-problema');
        $bt.ladda();
        $bt.ladda('start');
        $lista.addClass('whirl double-up');

        $.get({url: '/contato/problema/ralacao/' + $id, datatype: 'json'})
            .done(function (data) {
                if (data['status']) {

                    $lista.html('').html(data['html']);
                    toastr.success(data['mensagem']);

                } else {

                    data['mensagem'].forEach(function (name) {
                        toastr.error(name)
                    });
                }
            })
            .complete(function () {
                $lista.removeClass('whirl double-up');
            });
    });

    $(document).on('show.bs.modal', '#addPecaEstrutura', function (e) {
        var $material_id = $('#material').select2('val');
        var $posVendas = $(this).attr('posvendas');
        var $validatePreco = $(this).attr('validapreco');
        $.post('/cadastro/material/estrutura', {id: $material_id, preco: $validatePreco, posvendas: $posVendas}, function (data) {
            if (!(data instanceof Object)) {
                toastr.error("Não foi possível buscar a estrutura do material!", "Não foi possível realizar a transação!");
                return false;
            }
            $('#listEstrutura').html('').html(data.html);
            $('#listEstrutura > li')
                .find(".quantidade-spin")
                .each(function (index) {
                    if (_.isInteger(_.toNumber($(this).attr('p1')))) {

                        $(this).TouchSpin({
                            min: 0,
                            max: _.toNumber($(this).attr('max')),
                            step: _.toNumber($(this).attr('p1')),
                            forcestepdivisibility: 'none'
                        });
                    } else {
                        //alert($(this).attr('p1'));
                        $(this).TouchSpin({step: $(this).attr('p1'), decimals: 2});
                    }
                });
        }).fail(function (error) {
            console.log(error);
            toastr.error("Não foi possível buscar a estrutura do material!", "Não foi possível realizar a transação!");
        });
    });

    $(document).on('click', '.btn-expand-filho', function (e) {
        var $buttonExpand = $(this);
        var $material_id = $buttonExpand.attr('material-filho');
        var $preco = (window.location.pathname.indexOf('pedido') != -1);
        var $posVendas = $(this).attr('posvendas');
        var $exibePreco = (window.location.pathname.indexOf('visualizarremessa') != -1 && $('input[name="tipo_manutencao"]:checked').val() == '0');
        var $cliente = $('input[name="cliente"]').val();

        if ($buttonExpand.attr('expand') == 'false') {
            var $data = {id: $material_id, preco: $preco, isFilho: true, posvendas: false};

            if ($cliente != undefined && $cliente != null) {
                $data.cliente = $cliente;
            } else {
                var $cliente3 = $('select[name="cliente"] option:selected').val();
                $data.cliente = $cliente3;
                $data.preco = true;
            }
            $data.posvendas = ($posVendas == 'true' ? true : false);

            $.post('/cadastro/material/estrutura', $data, function (data) {
                if (!(data instanceof Object)) {
                    toastr.error("Não foi possível buscar a estrutura do material!", "Não foi possível realizar a transação!");
                    return false;
                }

                $('#materiaisFilhos' + $material_id).html('').html(data.html);
                $('#materiaisFilhos' + $material_id + '> ol > li')
                    .find(".quantidade-spin")
                    .each(function (index, value) {
                        var $initValue = '',
                            $material = value.name.match(/(\d+)/)[0],
                            $pecas = [], $servicos = [];

                        $pecas = JSON.parse(window.sessionStorage.getItem('pecas_assistencia'));
                        $servicos = JSON.parse(window.sessionStorage.getItem('servicos_assistencia'));

                        if ($pecas !== undefined && $pecas !== null && $pecas.length > 0){
                            for (var $p = 0; $p < $pecas.length; $p++){
                                if ($pecas[$p].material === $material){
                                    $initValue = $pecas[$p].quantidade;
                                    break;
                                }
                            }
                        }

                        if ($servicos !== undefined && $servicos !== null && $servicos.length > 0){
                            for(var $s = 0; $s < $servicos.length; $s++){
                                if ($servicos[$s].material === $material){
                                    $initValue = $servicos[$s].quantidade;
                                    break;
                                }
                            }
                        }

                        if (_.isInteger(_.toNumber($(this).attr('p1')))) {
                            $(this).TouchSpin({
                                initval: $initValue,
                                min: 0,
                                max: _.toNumber($(this).attr('max')),
                                step: _.toNumber($(this).attr('p1')),
                                forcestepdivisibility: 'none'
                            });
                        } else {
                            $(this).TouchSpin({step: $(this).attr('p1'), decimals: 2});
                        }
                    });
                $buttonExpand.attr('expand', 'true');
                $('#materiaisFilhos' + $material_id).fadeIn('slow');
                $buttonExpand.html('').html('<i class="fa fa-minus"></i>');

                if ($exibePreco) {
                    $('.valor-pecas').removeClass('hidden');
                } else {
                    $('.valor-pecas').addClass('hidden');
                }
            }).fail(function (error) {
                console.log(error);
                toastr.error("Não foi possível buscar a estrutura do material!", "Não foi possível realizar a transação!");
            });
        } else {
            $('#materiaisFilhos' + $material_id).fadeOut('slow');
            $buttonExpand.attr('expand', 'false');
            $buttonExpand.html('').html('<i class="fa fa-plus"></i>');

            if ($exibePreco) {
                $('.valor-pecas').removeClass('hidden');
            } else {
                $('.valor-pecas').addClass('hidden');
            }
        }
    });

    $(document).on('click', '.view-estrutura-peca', function () {
        var $material_id = $(this).attr('material_id');
        var $cliente_selecionado = $("#cliente_selecionado").val();

        $.post('/cadastro/material/estrutura', {id: $material_id, preco: true, cliente: $cliente_selecionado, posvendas: false}, function (data) {
            if (!(data instanceof Object)) {
                toastr.error("Não foi possível buscar a estrutura do material!", "Não foi possível realizar a transação!");
                return false;
            }

            $('tr[id="' + $material_id + '"]').removeClass('hidden');
            $('td[id="' + $material_id + '"] > ol').html('').html(data.html);

            $('td[id="' + $material_id + '"] > ol')
                .find(".quantidade-spin")
                .each(function (index) {
                    if (_.isInteger(_.toNumber($(this).attr('p1')))) {
                        $(this).TouchSpin({
                            min: 0,
                            max: _.toNumber($(this).attr('max')),
                            step: _.toNumber($(this).attr('p1')),
                            forcestepdivisibility: 'none'
                        });
                    } else {
                        $(this).TouchSpin({step: $(this).attr('p1'), decimals: 2});
                    }
                });
        }).fail(function (error) {
            console.log(error);
            toastr.error("Não foi possível buscar a estrutura do material!", "Não foi possível realizar a transação!");
        });
    });

    $(document).on("dp.change", "#ano", function (e) {
        $('#form-pesquisa').submit();
    });

    $(document).on('click', '.pesquisaLoadAno', function () {
        var $typeEvent = $(this).attr('type-button');

        if ($typeEvent == 'next') {
            var $dataAno = $('#ano').val();
            var $ano = (parseInt($dataAno) + 1);

            $('#ano').val($ano);
        } else {
            var $dataAno = $('#ano').val();
            var $ano = (parseInt($dataAno) - 1);

            $('#ano').val($ano);
        }

        $('#form-pesquisa').submit();
    });

    $(document).on('change', '#pais', function () {
        $('#form-pesquisa').submit();
    });

    $(document).on('click', '.relatorioLoadAno', function () {
        var $typeEvent = $(this).attr('type-button');

        if ($typeEvent == 'next') {
            var $dataAno = $('#ano').val();
            var $ano = (parseInt($dataAno) + 1);

            $('#ano').val($ano);
        } else {
            var $dataAno = $('#ano').val();
            var $ano = (parseInt($dataAno) - 1);

            $('#ano').val($ano);
        }
    });

    $(document).on('click', '.btn-atualizar-feriado', function () {
        var $bt = $(this);

        $($bt).ladda();
        $($bt).ladda('start');

        $.ajax({type: 'get', url: '/cadastro/feriado/sincronizacao', datatype: 'json'})
            .complete(function () {
                $($bt).ladda('stop');

                toastr.success('Atualização finalizada com sucesso!');

                setTimeout(function () {
                    location.reload();
                }, 2000);
            });
    });

    $(document).on('click', '.btn-meta-grupo-cliente', function () {
        var $grupo = $(this).attr('grupo');
        var $date = new Date();
        var $bt = '.btn-meta-grupo-cliente[grupo="' + $grupo + '"]';

        $($bt).ladda();
        $($bt).ladda('start');

        $.ajax({type: 'get', url: '/cadastro/grupo-empresarial-cliente/viewmeta/' + $grupo + '/' + $date.getFullYear() + '/BR', data: {}, datatype: 'json'})
            .done(function (data) {
                if (data['status']) {
                    $('#bodyTableMeta').html('').html(data['htmlMeta']);
                    $('#bodyTableMetaTotal').html('').html(data['htmlTotal']);

                    $('#bodyTableMetaOmegasat').html('').html(data['htmlMetaOmegasat']);
                    $('#bodyTableMetaTotalOmegasat').html('').html(data['htmlTotalOmegasat']);

                    $('#grupo').val($grupo);

                    $('#modalMetaGrupoCliente').modal({backdrop: 'static', show: true});
                    $('#modalMetaGrupoCliente').on('shown.bs.modal', function (e) {
                        $(".moeda").maskMoney({thousands: '.', decimal: ',', allowZero: true});
                        $(".moeda_decimal_none").maskMoney({thousands: '.', decimal: ',', allowZero: true, precision: 0});
                        $('form[name="formMetaCliente"]').prop('action', data['action']);

                        $('#formMetaCliente').keypress(function (e) {
                            var code = null;
                            code = (e.keyCode ? e.keyCode : e.which);                
                            return (code == 13) ? false : true;
                        });
                    });
                } else {
                    toastr.error(data.mensagem, "Falha ao buscar os dados do grupo de cliente!");
                }
            })
            .complete(function () {
                $($bt).ladda('stop');
            });
    });

    $(document).on('click', '.modalMetaLoadAno', function () {
        var $typeEvent = $(this).attr('type-button');
        var $typeMeta = $(this).attr('type-meta');
        var $grupo = $('#grupo').val();
        var $pais = $('#pais').val();

        if ($typeEvent == 'next') {
            var $dataAno = $('#ano').val();
            var $ano = (parseInt($dataAno) + 1);

            $('#ano').val($ano);
        } else {
            var $dataAno = $('#ano').val();
            var $ano = (parseInt($dataAno) - 1);

            $('#ano').val($ano);
        }


        switch ($typeMeta) {
            case 'cliente':
                getMetaCliente($grupo, $ano, $pais);
                break;
            case 'macro':
                getMetaMacro($ano, $pais);
                break;
        }
    });

    $(document).on('change', 'select[name="pais"]', function () {
        var $cliente = $('#cliente').val();
        var $typeMeta = $(this).attr('type-meta');
        var $pais = $('#pais').val();
        var $ano = $('#ano').val();

        switch ($typeMeta) {
            case 'cliente':
                getMetaCliente($cliente, $ano, $pais);
                break;
            case 'macro':
                getMetaMacro($ano, $pais);
                break;
        }
    });

    $(document).on('change', 'input[name="mesTrimestre"]', function () {
        switch ($(this).val()) {
            case 'mes_ano':
                $('.divTrimestre').addClass('hidden');
                $('.divMes').removeClass('hidden');
                break;
            case 'trimestre':
                $('.divMes').addClass('hidden');
                $('.divTrimestre').removeClass('hidden');
                break;
        }
    });

    $(document).on('click', '.btn-pesquisa-painel', function () {
        $('#modalPesquisa').modal({show: true, backdrop: 'static'}).on('shown.bs.modal', function () {
            $('#cliente').select2({
                lang: 'pt-BR',
                width: '100%',
                dropdownParent: $('.form-group-pesq-cliente')
            });
        });
    });

    $(document).on('submit', 'form[name="formMetaCliente"]', function () {
        var $bt = '.btn-salvar';
        $($bt).ladda();
        $($bt).ladda('start');
    });

    $(document).on('blur', '.input-meta', function (e) {
        var $mesEmpresa = $(this).attr('name').split('_');
        var $mes = $mesEmpresa[0].match(/\d+/)[0];
        var $emp = $mesEmpresa[1].match(/\d+/)[0];
        var $elementsColumn = $('input[name^="mes' + $mes + '_"]');
        var $elementsLine = $('input[name$="_emp' + $emp + '"]');
        var $elementTotalGeralEmp = $('input[name^="empresa_total"]');
        var $inputTotalMes = $('input[name="mes' + $mes + '"]');
        var $inputTotalEmp = $('input[name="empresa_total' + $emp + '"]');
        var $totalMes = 0;
        var $totalEmp = 0;
        var $totalGeral = 0;

        $.each($elementsColumn, function ($keyInputCol, $inputCol) {
            if ($inputCol.value == '') {
                $inputCol.value = '0';
            }

            var $valor = $inputCol.value.replace(/\./g, '');
            $valor = $valor.replace(/\,/g, '.');

            $totalMes += parseFloat($valor);
        });

        $.each($elementsLine, function ($keyInputLine, $inputLine) {
            if ($inputLine.value == '') {
                $inputLine.value = '0';
            }
            var $valor = $inputLine.value.replace(/\./g, '');
            $valor = $valor.replace(/\,/g, '.');

            $totalEmp += parseFloat($valor);
        });

        $inputTotalMes.val(numberToReal($totalMes, 0));
        $inputTotalEmp.val(numberToReal($totalEmp, 0));

        $.each($elementTotalGeralEmp, function ($keyInputTotalGeralEmp, $inputTotalGeralEmp) {
            if ($inputTotalGeralEmp.value == '') {
                $inputTotalGeralEmp.value = '0';
            }

            var $valor = $inputTotalGeralEmp.value.replace(/\./g, '');
            $valor = $valor.replace(/\,/g, '.');

            $totalGeral += parseFloat($valor);
        });

        $('#total_geral').val(numberToReal($totalGeral, 0));
    });

    $(document).on('blur', '.input-meta-omega', function (e) {
        var $mesEmpresa = $(this).attr('name').split('_');
        var $mes = $mesEmpresa[1].match(/\d+/)[0];
        var $emp = $mesEmpresa[2].match(/\d+/)[0];
        var $elementsColumn = $('input[name^="o_mes' + $mes + '_"]');
        var $elementsLine = $('input[name$="_emp' + $emp + '_o"]');
        var $elementTotalGeralEmp = $('input[name^="o_empresa_total"]');
        var $inputTotalMes = $('input[name="o_mes' + $mes + '"]');
        var $inputTotalEmp = $('input[name="o_empresa_total' + $emp + '"]');
        var $totalMes = 0;
        var $totalEmp = 0;
        var $totalGeral = 0;

        $.each($elementsColumn, function ($keyInputCol, $inputCol) {
            if ($inputCol.value == '') {
                $inputCol.value = '0';
            }

            var $valor = $inputCol.value.replace(/\./g, '');
            $valor = $valor.replace(/\,/g, '.');

            $totalMes += parseFloat($valor);
        });

        $.each($elementsLine, function ($keyInputLine, $inputLine) {
            if ($inputLine.value == '') {
                $inputLine.value = '0';
            }
            var $valor = $inputLine.value.replace(/\./g, '');
            $valor = $valor.replace(/\,/g, '.');

            $totalEmp += parseFloat($valor);
        });

        $inputTotalMes.val(numberToReal($totalMes, 0));
        $inputTotalEmp.val(numberToReal($totalEmp, 0));

        $.each($elementTotalGeralEmp, function ($keyInputTotalGeralEmp, $inputTotalGeralEmp) {
            if ($inputTotalGeralEmp.value == '') {
                $inputTotalGeralEmp.value = '0';
            }

            var $valor = $inputTotalGeralEmp.value.replace(/\./g, '');
            $valor = $valor.replace(/\,/g, '.');

            $totalGeral += parseFloat($valor);
        });

        $('#o_total_geral').val(numberToReal($totalGeral, 0));
    });

    $(document).on('keypress', '#form-login-distribuidor input[name="username"], #form-login-distribuidor input[name="password"]', function (e) {
        var code = e.keyCode || e.which;
        if (code == 13) {
            $('.btn-login-distribuidor').click();
        }
    });

    $(document).on('click', '.btn-login-distribuidor', function () {
        var d = new Date();
        var $data = (d.getFullYear()) + '-' + (((d.getMonth() + 1) < 10) ? ('0' + (d.getMonth() + 1)) : (d.getMonth() + 1)) + '-' + ((d.getDay() < 10) ? ('0' + d.getDay()) : d.getDay()) + ' ' + (d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds());
        var $type = ($(this).hasClass('cliente') ? 'acesso/cliente' : ($(this).hasClass('distribuidor') ? 'acesso/distribuidor' : ''));
        $('input[name="key"]').val(b64EncodeUnicode($type + '|' + $data));
        $('#form-login-distribuidor').submit();
    });

    $(document).on('click', ".btn-excluir-anexo-administrador", function ($e) {
        $e.preventDefault();
        var $bt = $(this),
            $id = $(this).attr('itemid');

        $($bt).ladda();
        $($bt).ladda('start');

        if (confirm("Deseja realmente excluir?") === false) {
            return false;
        } else {
            $.get({url: '/contato/gerenciador/excluiranexo/' + $id, datatype: 'json'})
                .done(function (data) {
                    if (data['status']) {
                        toastr.success(data['message']);
                        $('#linha-' + $id).remove();
                    } else {
                        toastr.error(data['message']);
                    }
                })
                .complete(function () {
                    $($bt).ladda('stop');
                });
        }
    });

    $(document).on('click', ".btn-excluir-anexo-cliente", function ($e) {
        $e.preventDefault();
        if (confirm("Deseja realmente excluir?") === false) {
            return false;
        } else {

            var $bt = $(this),
                $id = $(this).attr('itemid');

            $($bt).ladda();
            $($bt).ladda('start');

            $.get({url: '/areadocliente/contato/apagaranexo/' + $id, datatype: 'json'})
                .done(function (data) {
                    if (data['status']) {
                        toastr.success(data['mensagem']);
                        $('#linha-' + $id).remove();
                    } else {
                        toastr.error(data['mensagem']);
                    }
                })
                .complete(function () {
                    $($bt).ladda('stop');
                });
        }
    });

    $(document).on('click', ".btn-excluir-anexo-bonus-distribuidor", function ($e) {
        $e.preventDefault();
        var $bt = $(this),
            $id = $(this).attr('itemid');

        $($bt).ladda();
        $($bt).ladda('start');

        if (confirm("Deseja realmente excluir?") === false) {
            return false;
        } else {
            $.get({url: '/distribuidor/bonus/excluiranexo/' + $id, datatype: 'json'})
                .done(function (data) {
                    if (data['status']) {
                        toastr.success(data['message']);
                        $('#linha-' + $id).remove();
                    } else {
                        toastr.error(data['message']);
                    }
                })
                .complete(function () {
                    $($bt).ladda('stop');
                });
        }
    });

    $(document).on('change', '#modalAprovacaoItem #status, #modalAprovacao #status', function () {
        var $status = $(this).val();

        if ($status == 9 || $status == 10) {
            $('.data-nf').removeClass('hidden').prop('disabled', false);
        } else {
            $('.data-nf').addClass('hidden').prop('disabled', true);
        }
    });

    $(document).on('click', '.addMaterial', function () {
        modalEditMaterialRemessa();
    });

    $(document).on('click', '.btn-duplicar-os-material', function () {
        var $id = $(this).attr('os-id');
        $('#id-os').html('<input type="hidden" id="numero_os" name="numero_os" value='+$(this).attr('os-id')+'>')
        $('#numero_os').value = $id
        modalDuplica();
    });

    $(document).on('click', '.btn-close-remessa', function () {
        $('#addMaterial,#modalAprovacaoItem,#modalAprovacao').modal('hide');
        window.location.reload();
    });

    $(document).on('submit', 'form[id="distribuidor-assistencia-remessa"]', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        var $bt = $('.btn-concluir');
        $bt.ladda();
        $bt.ladda('start');
        var formData = new FormData(this);

        $.ajax({
            url: '/distribuidor/assistencia-remessa/remessa',
            type: 'POST',
            data: formData,
            success: function (data) {
                if (data.status) {
                    $('#addMaterial').modal('hide');

                    swal({
                        title: "Material cadastrado com sucesso!",
                        text: "Material incluido na remessa de peças com sucesso!",
                        type: "success"
                    }, function (isConfirm) {
                        if (isConfirm) {
                            window.location.reload(true);
                        }
                    });
                } else {
                    swal({title: "Transaçao não pode ser realizada!", text: "Problema ao tentar incluir um material, tente mais tarde!", type: "error"});
                    $.each(data.mensagem, function ($key, $message) {
                        toastr.error($message, 'Não foi possível realizar esta transação!');
                    });
                }

                $bt.ladda('stop');
            },
            error: function (error) {
                console.log(error);
                toastr.error(error.statusText, 'Não foi possível realizar esta transação!');

                $bt.ladda('stop');
            },
            cache: false,
            contentType: false,
            processData: false,
            xhr: function () {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                    myXhr.upload.addEventListener('progress', function () {
                        /!* faz alguma coisa durante o progresso do upload *!/
                    }, false);
                }
                return myXhr;
            }
        });
    });

    $(document).on('click', '.btn-edit-os-material', function ($e) {
        var $id = $(this).attr('os-id');

        $.get('/distribuidor/assistencia-remessa/editarmodal/' + $id, function (data) {
            modalEditMaterialRemessa(data);
        }).fail(function (error) {
            console.log(error);
            toastr.error('Não foi possível abrir a edição do item!', 'Transação não realizada!');
        });
    });

    $(document).on('click', '.btn-anexos-os-material', function () {
        var $id = $(this).attr('os-id');

        $.get('/distribuidor/assistencia-remessa/anexos/' + $id, function (data) {
            $('.tbody-anexos-os').html('').html(data.html);
            $('#modalAnexosRemessa').modal('show');
        }).fail(function (error) {
            console.log(error);
            toastr.error('Não foi possível abrir a tela de anexos!', 'Transação não realizada!');
        });
    });

    $(document).on('click', '.btn-aprovar-os-material', function ($e) {
        var $id = $(this).attr('os-id');
        var $grupo = $(this).attr('os-grupo');

        $.get('/ordemservico/gerenciador/modalremessaaprovacao/' + $id + '/' + $grupo, function (data) {
            $('#modalAprovacaoRemessa').html('').html(data);

            $('#modalAprovacaoItem').modal({show: true, backdrop: 'static'}).on('shown.bs.modal', function () {
                $("#administrador-assistencia-remessa").validate({
                    rules: {
                        status: {
                            required: true
                        }
                    },
                    messages: {
                        status: {
                            required: "Informe um status para aprovar a OS."
                        }
                    }
                });
            });
        }).fail(function (error) {
            console.log(error);
            toastr.error('Falha ao carregar a tela de aprovação.', 'Não foi possível realizar a transação!');
        });
    });

    $(document).on('submit', 'form[id="administrador-assistencia-remessa"]', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();

        if ($('#status').val() == '5' && !$('#motivo').val().replace(/\s/g, '').length) {
            toastr.warning('O campo motivo é obrigatório quando é feito a reprova da OS!', 'Campo obrigatório sem preencher!');
            return false;
        }

        var $bt = $('.btn-concluir');
        $bt.ladda();
        $bt.ladda('start');

        var formData = new FormData(this);

        $.ajax({
            url: '/ordemservico/gerenciador/aprovarremessa',
            type: 'POST',
            data: formData,
            success: function (data) {
                if (data.status) {
                    $('#modalAprovacao').modal('hide');

                    swal({
                        title: "Material atualizado com sucesso!",
                        text: "O status do material foi atualizado com sucesso!",
                        type: "success"
                    }, function (isConfirm) {
                        if (isConfirm) {
                            window.location.reload(true);
                        }
                    });
                } else {
                    swal({title: "Transaçao não pode ser realizada!", text: "Problema ao tentar atualizar o material, tente mais tarde!", type: "error"});
                    $.each(data.mensagem, function ($key, $message) {
                        toastr.error($message, 'Não foi possível realizar esta transação!');
                    });
                }

                $bt.ladda('stop');
            },
            error: function (error) {
                console.log(error);
                toastr.error(error.statusText, 'Não foi possível realizar esta transação!');

                $bt.ladda('stop');
            },
            cache: false,
            contentType: false,
            processData: false,
            xhr: function () {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                    myXhr.upload.addEventListener('progress', function () {
                        /!* faz alguma coisa durante o progresso do upload *!/
                    }, false);
                }
                return myXhr;
            }
        });
    });

    $(document).on('click', '.btn-conferir-os-material', function ($e) {
        var $id = $(this).attr('os-id');
        var $grupo = $(this).attr('os-grupo');
        var $filtro = $(this).attr('filtro');

        $.get('/ordemservico/gerenciador/modalremessaconferencia/' + $id + '/' + $grupo + '/'+ $filtro, function (data) {
            console.log(data)
            $('#divConferenciaRemessa').html('').html(data);

            $('#modalConferenciaRemessa').modal({show: true, backdrop: 'static'}).on('shown.bs.modal', function () {
                $("#administrador-assistencia-conferencia").validate({
                    rules: {
                        status: {
                            required: true
                        }
                    },
                    messages: {
                        status: {
                            required: "Informe um status para a OS."
                        }
                    }
                });
            });
        }).fail(function (error) {
            console.log(error);
            toastr.error('Falha ao carregar a tela de aprovação.', 'Não foi possível realizar a transação!');
        });
    });

    $(document).on('submit', 'form[id="administrador-assistencia-conferencia"]', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();

        if ($('#status').val() == '15' && !$('#motivo').val().replace(/\s/g, '').length) {
            toastr.warning('O campo motivo é obrigatório quando é feito a reprova da OS!', 'Campo obrigatório sem preencher!');
            return false;
        }

        var $bt = $('.btn-concluir');
        $bt.ladda();
        $bt.ladda('start');

        var formData = new FormData(this);

        $.ajax({
            url: '/ordemservico/gerenciador/conferenciaremessa',
            type: 'POST',
            data: formData,
            success: function (data) {
                if (data.status) {
                    $('#modalConferenciaRemessa').modal('hide');

                    var message = "O status do material foi atualizado com sucesso!";
                    var type = "success";
                    if (data.mensagem !== undefined){
                        type = "warning";
                        $.each(data.mensagem, function ($key, $message) {
                            message += "<br><br>" + $message;
                        });
                    }

                    swal({
                        html: true,
                        title: "Material conferido com sucesso!",
                        text: message,
                        type: type
                    }, function (isConfirm) {
                        if (isConfirm) {
                            window.location.reload(true);
                        }
                    });
                } else {
                    swal({title: "Transaçao não pode ser realizada!", text: "Problema ao tentar atualizar o material, tente mais tarde!", type: "error"});
                    $.each(data.mensagem, function ($key, $message) {
                        toastr.error($message, 'Não foi possível realizar esta transação!');
                    });
                }

                $bt.ladda('stop');
            },
            error: function (error) {
                console.log(error);
                toastr.error(error.statusText, 'Não foi possível realizar esta transação!');

                $bt.ladda('stop');
            },
            cache: false,
            contentType: false,
            processData: false,
            xhr: function () {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                    myXhr.upload.addEventListener('progress', function () {
                        /!* faz alguma coisa durante o progresso do upload *!/
                    }, false);
                }
                return myXhr;
            }
        });
    });

    $(document).on('click', '.btn-aprovar-reposicao', function (e) {
        if ($('#administrador-assistencia-aprovacao #status').val() == '5' && !$('#administrador-assistencia-aprovacao #motivo').val().replace(/\s/g, '').length) {
            toastr.warning('O campo motivo é obrigatório quando é feito a reprova da OS!', 'Campo obrigatório sem preencher!');
            return false;
        }

        var $bt = $(this);
        $bt.ladda();
        $bt.ladda('start');

        $('#administrador-assistencia-aprovacao').submit();
    });

    $(document).on('click', '.btn-edit-material', function ($e) {
        var $id = $(this).attr('os-id');

        $('.panel-load').addClass('whirl standard');
        $.get('/ordemservico/gerenciador/modaleditar/' + $id, function (data) {
            $('#modalEdicaoItem').modal({show: true, backdrop: 'static'}).on('shown.bs.modal', function () {
                $('#modalEdicaoRemessa').html('').html(data);

                $("#gerenciador-assistencia-remessa").validate({
                    rules: {
                        material: {
                            required: true
                        },
                        'defeito[]': {
                            required: true
                        },
                        material_identificacao: {
                            required: true
                        },
                        material_compra_nota: {
                            required: true
                        },
                        material_compra_data: {
                            required: true
                        }
                    },
                    messages: {
                        material: {
                            required: "Informe um material para a OS."
                        },
                        'defeito[]': {
                            required: "Informe um defeito para o material."
                        },
                        material_identificacao: {
                            required: "Informe qual o lote do material."
                        },
                        material_compra_nota: {
                            required: "Informe qual a numero da nota fiscal de compra do material."
                        },
                        material_compra_data: {
                            required: "Informe qual a data de compra do material."
                        }
                    }
                });

                setTimeout(function () {
                    var $config = {
                        attrElement: 'name',
                        nameElement: 'material',
                        elementDropDownParent: $('#modalEdicaoItem .form-group-material'),
                        url: "/cadastro/material/materialautocomplete"
                    }
                    configureSelect2WithAutocomplete($config, false);

                    $('.select-defeito').select2({
                        dropdownParent: $('#modalEdicaoItem .form-group-defeito'),
                        lang: 'pt-BR',
                        width: '100%'
                    });

                    $('.panel-load').removeClass('whirl standard');
                }, 500);
            });
        }).fail(function (error) {
            console.log(error);
            toastr.error('Falha ao carregar a tela de aprovação.', 'Não foi possível realizar a transação!');
            $('.panel-load').removeClass('whirl standard');
        });
    });

    $(document).on('submit', 'form[id="gerenciador-assistencia-remessa"]', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();

        var $bt = $('.btn-concluir');
        $bt.ladda();
        $bt.ladda('start');

        var formData = new FormData(this);

        $.ajax({
            url: '/ordemservico/gerenciador/editarmaterial',
            type: 'POST',
            data: formData,
            success: function (data) {
                if (data.status) {
                    $('#modalEdicaoItem').modal('hide');

                    swal({
                        title: "Material atualizado com sucesso!",
                        text: "O material foi atualizado com sucesso!",
                        type: "success"
                    }, function (isConfirm) {
                        if (isConfirm) {
                            window.location.reload(true);
                        }
                    });
                } else {
                    swal({title: "Transaçao não pode ser realizada!", text: "Problema ao tentar atualizar o material, tente mais tarde!", type: "error"});
                    $.each(data.mensagem, function ($key, $message) {
                        toastr.error($message, 'Não foi possível realizar esta transação!');
                    });
                }

                $bt.ladda('stop');
            },
            error: function (error) {
                console.log(error);
                toastr.error(error.statusText, 'Não foi possível realizar esta transação!');

                $bt.ladda('stop');
            },
            cache: false,
            contentType: false,
            processData: false,
            xhr: function () {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                    myXhr.upload.addEventListener('progress', function () {
                        /!* faz alguma coisa durante o progresso do upload *!/
                    }, false);
                }
                return myXhr;
            }
        });
    });

    $(document).on('submit', 'form[id="aprovar-remessa-all"]', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();

        if ($('#status').val() == '5' && !$('#motivo').val().replace(/\s/g, '').length) {
            toastr.warning('O campo motivo é obrigatório quando é feito a reprova da OS!', 'Campo obrigatório sem preencher!');
            return false;
        }

        var $bt = $('.btn-aprovacao-all');
        $bt.ladda();
        $bt.ladda('start');

        var formData = new FormData(this);

        $.ajax({
            url: '/ordemservico/gerenciador/aprovarremessaall',
            type: 'POST',
            data: formData,
            success: function (data) {
                if (data.status) {
                    $('#modalAprovacao').modal('hide');

                    swal({
                        title: "A Ordem de Serviço foi atualizada com sucesso!",
                        text: "Ordem de Serviço com status atualizada com sucesso!",
                        type: "success"
                    }, function (isConfirm) {
                        if (isConfirm) {
                            window.location.reload(true);
                        }
                    });
                } else {
                    swal({title: "Transaçao não pode ser realizada!", text: "Problema ao tentar atualizar o status da ordem de serviço, tente mais tarde!", type: "error"});
                    $.each(data.mensagem, function ($key, $message) {
                        toastr.error($message, 'Não foi possível realizar esta transação!');
                    });
                }

                $bt.ladda('stop');
            },
            error: function (error) {
                console.log(error);
                toastr.error(error.statusText, 'Não foi possível realizar esta transação!');

                $bt.ladda('stop');
            },
            cache: false,
            contentType: false,
            processData: false,
            xhr: function () {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                    myXhr.upload.addEventListener('progress', function () {
                        /!* faz alguma coisa durante o progresso do upload *!/
                    }, false);
                }
                return myXhr;
            }
        });
    });

    $(document).on('click', '.btn-laudo-tecnico-material', function () {
        var $idOs = $(this).attr('os-id');
        var $filtros = $(this).attr('filtro');

        $('input[name="ordem_servico"]').val($idOs);

        $('.panel-load').addClass('whirl standard');
        $.get('/ordemservico/gerenciador/estrutura/' + $idOs +'/'+ $filtros, function (data) {
            if (data.status) {
                $('#filtros').val($filtros)
                $('#divEstruturaMaterial').html('').html(data.estrutura.replace('style="margin-top: 13%;"', '')).find(".quantidade-spin")
                    .each(function (index) {
                        if (_.isInteger(_.toNumber($(this).attr('p1')))) {
                            $(this).TouchSpin({
                                min: 0,
                                max: _.toNumber($(this).attr('max')),
                                step: _.toNumber($(this).attr('p1')),
                                forcestepdivisibility: 'none'
                            });
                        } else {
                            $(this).TouchSpin({step: $(this).attr('p1'), decimals: 2});
                        }
                    });

                if (data.consumidor == 1){
                    $('#divEmailConsumidor').removeClass('hidden');
                    $('#divEmailConsumidor').html('').html('<small class="font-bold">E-mail Consumidor</small> <div class="form-group"><input type="email" class="form-control" name="email_consumidor"></div>');
                }

                if (data.estrutura.indexOf("removeitem") !== -1) {
                    $('#divEstruturaMaterial').removeClass('hidden');
                    $('#divEstruturaPecasRemessa').addClass('hidden');
                    $('#divEstruturaServicosRemessa').addClass('hidden');
                    $('.btn-pecas-remessas').addClass('hidden');
                    $('.btn-servicos-remessas').addClass('hidden');
                    $('#divEstruturaPecasRemessa').fadeToggle();
                    $('#divTablePecas').fadeToggle();
                    $('#divTableServicos').fadeToggle();

                    $('#divEstruturaMaterial').find('.btn-excluir').each(function (index) {
                        $(this).addClass('hidden');
                    });
                }

                if (data.options_defeito) {
                    $('select[name="defeito_origem"]').html('').html(data.options_defeito);
                }

                if (data.options_defeito_tecnico) {
                    $('select[name="defeito_tecnico"]').html('').html(data.options_defeito_tecnico);
                    if (data.options_defeito_tecnico.indexOf('selected') != -1) {
                        $('select[name="defeito_tecnico"]').prop('disabled', true);
                    }
                }

                if (data.laudo != undefined && data.laudo.laudo_aprovado) {
                    $('#divTipoManutencao').addClass('disabled');
                    $('#divManutencaoTroca').addClass('disabled');
                    $('#divCobrancaPecas').removeClass('hidden');
                    $('#divCobrancaPecas').addClass('disabled');
                    $('#divCaixa').addClass('hidden');

                    if (!data.laudo.garantia) {
                        var $valManutencao = $('#valor_manutencao');
                        $('#tipoManutencaoForaGarantia').prop('checked', true);

                        $valManutencao.prop('readonly', true);
                        $valManutencao.val(data.laudo.valor_manutencao);
                        $('.valor-orcamento').fadeIn();

                        $('.btn-aprovacao-tecnico[status="finalizar"]').fadeIn();
                    }

                    if (data.cobrar_pecas) {
                        $('#cobrarPecasSim').iCheck('check');
                        $('#cobrarPecasNao').iCheck('uncheck');
                        $('#cobrarPecasNao').iCheck('update');
                    }
                }

                $('#modalTecnico').modal({
                    show: true,
                    backdrop: 'static'
                }).on('shown.bs.modal', function () {
                    $("#divAnexoTecnico").html();

                    var $foraGarantia = ($('input[name="tipo_manutencao"]:checked').val() == '0');
                    if (!$foraGarantia) {
                        $('.valor-pecas').addClass('hidden');
                    } else {
                        $('.material-troca').addClass('hidden');
                        $('#divManutencaoTroca').addClass('hidden');
                    }

                    $('.select-tecnico').select2({dropdownParent: $('.form-group-tecnico'), lang: 'pt-BR', width: '100%'});
                    $('#observacao_distribuidor').html('').html(data.observacao_distribuidor);
                    $('#lote_fabricacao_os').html('').html(data.lote_fabricacao);

                    var $configMaterial = {
                        attrElement: 'name',
                        nameElement: 'material_troca',
                        elementDropDownParent: $('.form-group-materia-troca'),
                        url: "/cadastro/material/componenteautocomplete"
                    };

                    var $configCaixa = {
                        attrElement: 'id',
                        nameElement: 'material_caixa',
                        elementDropDownParent: $('.form-group-material-caixa'),
                        url: "/cadastro/material/caixaautocomplete"
                    };

                    configureSelect2WithAutocomplete($configMaterial, false);
                    configureSelect2WithAutocomplete($configCaixa, true, 'getPrecoCaixa', 'removeSelectionPrecoCaixa');

                    if (data.material_troca instanceof Object) {
                        var $options = new Option(data.material_troca.text, data.material_troca.id, true, true);

                        $('select[name="material_troca"]').append($options).trigger('change');
                        $('select[name="material_troca"]').prop('disabled', true);
                    }

                    $('.panel-load').removeClass('whirl standard');
                });
            } else {
                toastr.error(data.mensagem);
                $('.panel-load').removeClass('whirl standard');
            }
        }).fail(function (error) {
            toastr.error('Ocorreu um problema ao tentar obter o registro.<br>Error: ' + error.statusText);
            $('.panel-load').removeClass('whirl standard');
        });
    });

    $(document).on('submit', 'form[id="remessa-tecnico"]', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();

        var $bt = $('.btn-aprovacao-tecnico');
        var $bt2 = e.delegateTarget.activeElement;
        var $status = $bt2.attributes.status.value;
        $('#remessa-tecnico input[name="status"]').val(($status == 'aberto' ? 9 : 10));

        $bt.ladda();
        $bt.ladda('start');

        var formData = new FormData(this);

        var $url = null;
        var $filtros = $('#filtros').val();
        console.log($filtros);
        if($filtros == '000'){
            $url = '/ordemservico/gerenciador/tecnico';
        }else{ 
            $url = '/ordemservico/gerenciador/tecnicofiltro';
        }

        $.ajax({
            url: $url,
            type: 'POST',
            data: formData,
            success: function (data) {
                if (data.status) {
                    $('#modalTecnico').modal('hide');

                    swal({
                        title: "Laudo do técnico salvo com sucesso!",
                        text: "Laudo do técnico salvo com sucesso!",
                        type: "success"
                    }, function (isConfirm) {
                        if (isConfirm) {
                            window.location.reload(true);
                        }
                    });
                } else {
                    swal({title: "Transaçao não pode ser realizada!", text: "Problema ao tentar atualizar o status da ordem de serviço, tente mais tarde!", type: "error"});
                    $.each(data.mensagem, function ($key, $message) {
                        toastr.error($message, 'Não foi possível realizar esta transação!');
                    });
                }

                $bt.ladda('stop');
            },
            error: function (error) {
                console.log(error);
                toastr.error(error.statusText, 'Não foi possível realizar esta transação!');

                $bt.ladda('stop');
            },
            cache: false,
            contentType: false,
            processData: false,
            xhr: function () {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                    myXhr.upload.addEventListener('progress', function () {
                        /!* faz alguma coisa durante o progresso do upload *!/
                    }, false);
                }
                return myXhr;
            }
        });
    });

    $(document).on('click', '.btn-recebimento', function () {
        var $id = $(this).attr('os-id');
        var $url = $(this).attr('url');
        var $status = $(this).attr('status');

        swal({
                html: true,
                title: "Deseja continuar mesmo assim?",
                text: "Realizar o recebimento dos materiais pela fábrica!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.post($url, {id: $id, status: $status}, function (data) {
                        if (data.status) {
                            swal({
                                title: "Transaçao realizada com sucesso!",
                                text: "Ordem de Serviço recebida com sucesso!",
                                type: "success"
                            }, function () {
                                window.location.reload(true);
                            });
                        } else {
                            swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema no recebimento da OS!", type: "error"});

                            $.each(data.mensagem, function ($key, $message) {
                                toastr.error($message, 'Transação não pode ser realizada!');
                            });
                        }
                    }).fail(function (error) {
                        console.log(error);
                        swal.close();
                        toastr.error('Ocorreu uma falha ao tentar receber a Ordem de Serviço!');
                    });
                }
            }
        );
    });

    $(document).on('click', '.btn-modal-envia-fabrica', function () {
        $('#modalEnviaFabrica').modal({
            show: true,
            backdrop: 'static'
        }).on('shown.bs.modal', function ($e) {
            $('.dateCalendarHour').datetimepicker({
                locale: 'pt-BR',
                format: 'DD/MM/YYYY HH:mm',
                timeZone: 'America/Sao_Paulo',
                defaultDate: (new Date()),
                useCurrent: true
            });

            $("#distribuidor-remessa-envio").validate({
                rules: {
                    nota_fiscal: {
                        required: true
                    },
                    data_envio: {
                        required: true
                    },
                },
                messages: {
                    nota_fiscal: {
                        required: "Informe um número de nota fiscal para enviar a OS para a fábrica."
                    },
                    data_envio: {
                        required: "Informe a data de envio da OS para a fábrica."
                    }
                }
            });
        });
    });

    $(document).on('submit', 'form[id="distribuidor-remessa-envio"]', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        var $bt = $('.btn-enviar-fabrica');
        var formData = new FormData(this);
        var $error = '';
        $bt.ladda();
        $bt.ladda('start');

        $.ajax({
            url: $(this).attr('action'),
            type: 'POST',
            data: formData,
            success: function (data) {
                if (data.status) {
                    $('#modalEnviaFabrica').modal('hide');
                    var $obSwal = {};
                    if ($bt.attr('edit') == 'nao') {
                        $obSwal = {
                            title: "Ordem de Serviço enviado para a fábrica!",
                            text: "Ordem de Serviço enviado para a fábrica com sucesso!",
                            type: "success"
                        }

                        $error = "Problema ao tentar enviar a OS para a fábrica, tente mais tarde!";
                    } else {
                        $obSwal = {
                            title: "Dados fiscais editado com sucesso!",
                            text: "Dados fiscais da ordem de serviço editado com sucesso!",
                            type: "success"
                        }

                        $error = "Problema ao tentar editar os dados fiscais de envio da ordem de serviço, tente mais tarde!";
                    }

                    swal($obSwal, function (isConfirm) {
                        if (isConfirm) {
                            window.location.reload(true);
                        }
                    });
                } else {
                    if (data.mensagem) {
                        $.each(data.mensagem, function ($key, $message) {
                            toastr.error($message, 'Não foi possível realizar esta transação!');
                        });
                    } else {
                        toastr.error($error, 'Não foi possível realizar esta transação!');
                    }
                }

                $bt.ladda('stop');
            },
            error: function (error) {
                console.log(error);
                toastr.error(error.statusText, 'Não foi possível realizar esta transação!');

                $bt.ladda('stop');
            },
            cache: false,
            contentType: false,
            processData: false,
            xhr: function () {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                    myXhr.upload.addEventListener('progress', function () {
                        /!* faz alguma coisa durante o progresso do upload *!/
                    }, false);
                }
                return myXhr;
            }
        });
    });

    $(document).on('submit', 'form[id="distribuidor-remessa-envio"], form[id="distribuidor-reposicao-envio"]', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();

        var $bt = $('.btn-enviar-fabrica');
        $bt.ladda();
        $bt.ladda('start');

        var formData = new FormData(this);

        $.ajax({
            url: $(this).attr('action'),
            type: $(this).attr('method'),
            data: formData,
            success: function (data) {
                if (data.status) {
                    $('#modalEnviaFabrica').modal('hide');

                    swal({
                        title: "A Ordem de Serviço foi atualizada com sucesso!",
                        text: "Ordem de Serviço com status atualizada com sucesso!",
                        type: "success"
                    }, function (isConfirm) {
                        if (isConfirm) {
                            window.location.reload(true);
                        }
                    });
                } else {
                    if (data.mensagem) {
                        $.each(data.mensagem, function ($key, $message) {
                            toastr.error($message, 'Não foi possível realizar esta transação!');
                        });
                    } else {
                        toastr.error('Problema ao tentar atualizar o status da ordem de serviço, tente mais tarde!', 'Não foi possível realizar esta transação!');
                    }
                }

                $bt.ladda('stop');
            },
            error: function (error) {
                console.log(error);
                toastr.error(error.statusText, 'Não foi possível realizar esta transação!');

                $bt.ladda('stop');
            },
            cache: false,
            contentType: false,
            processData: false,
            xhr: function () {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                    myXhr.upload.addEventListener('progress', function () {
                        /!* faz alguma coisa durante o progresso do upload *!/
                    }, false);
                }
                return myXhr;
            }
        });
    });

    $(document).on('click', '.addLogCampanha', function (e) {
        var $campanha = $('.carousel-inner > .item.active > input[name="campanha"]').val();
        $.post('/distribuidor/painel/campanhalog', {campanha: $campanha}, function (data) {
            if (!data.status) {
                console.log(data);
            }
        }).fail(function (error) {
            console.log(error);
        });
    });

    $(document).on('click', '#btnAddItensPedido', function (e) {
        var $campanha = $('.carousel-inner > .item.active > input[name="campanha"]').val();

        $.get('/distribuidor/pedido/obterpedidosabertos/campanha', function (data) {
            $.post('/distribuidor/painel/campanhalog', {campanha: $campanha}, function (dataLog) {
                if (!dataLog.status) {
                    console.log(dataLog);
                }
            }).fail(function (error) {
                console.log(error);
            }).done(function () {
                if (data.status) {
                    $('#tBodyPedidosAbertos').html('').html(data.html);
                    $('input[name="campanha"]').val($campanha);
                    $('#modalPedido').modal('show');
                } else if (!data.status && data.mensagem == 'Nenhum pedido em aberto para esse cliente!') {
                    $.post('/distribuidor/pedido/incluircampanhapedido', {pedido: 0, campanha: $campanha, quantidade: 0}, function (data) {
                        if (data.status) {
                            swal({
                                title: "A campanha foi adicionada ao pedido com sucesso!",
                                text: "Campanha adicionada ao pedido!",
                                type: "success"
                            }, function (isConfirm) {
                                if (isConfirm) {
                                    window.location.href = data.url;
                                }
                            });
                        } else {
                            var $text = "Log de inclusão da campanha no pedido:<br><br><b>";
                            if (data.mensagem) {
                                $.each(data.mensagem, function ($key, $message) {
                                    $text += (("- " + $message) + ((($key + 1) == data.mensagem.length) ? '' : '<br>'));
                                });

                                $text += "</b>";
                            }

                            swal({
                                html: true,
                                title: "Houve um problema ao adicionar a campanha ao pedido!",
                                text: $text,
                                type: "error"
                            });
                        }
                    }).fail(function (error) {
                        console.log(error);
                        toastr.error(error.statusText, 'Não foi possível realizar esta transação!');
                    });
                }
            });
        }).fail(function (error) {
            console.log(error);
        });
    });

    $(document).on('click', '.btn-add-item-pedido', function (e) {
        var $materiais = [];
        var $pedido = ($(this).attr('data-pedido') == undefined ? 0 : $(this).attr('data-pedido'));
        $('.material-quantidade').each(function (index) {
            if ($(this).val() !== undefined && $(this).val() !== '') {
                $materiais.push({
                    'id': $(this).attr('id'),
                    'quantidade': $(this).val()
                })
            }
        });

        $.get('/distribuidor/pedido/obterpedidosabertos/produto', function (data) {
            if (data.status) {
                $('#tBodyPedidosAbertos').html('').html(data.html);
                $('#modalAddPedido').modal('show');
            } else if (!data.status && data.mensagem == 'Nenhum pedido em aberto para esse cliente!') {
                swal({
                        html: true,
                        title: "Não existem pedidos aberto!",
                        text: "Deseja incluir um novo pedido?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Sim, desejo!",
                        cancelButtonText: "Não, cancele!",
                        closeOnConfirm: false,
                        closeOnCancel: true,
                        showLoaderOnConfirm: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            $.post('/distribuidor/pedido/incluiritempedido', {pedido: $pedido, materiais: $materiais}, function (data) {
                                if (data.status) {
                                    swal({
                                        title: "Item foi adicionado ao pedido com sucesso!",
                                        text: "Item foi adicionado ao pedido!",
                                        type: "success"
                                    }, function (isConfirm) {
                                        if (isConfirm) {
                                            window.location.href = data.url;
                                        }
                                    });
                                } else {
                                    var $text = "Não foi possível incluir o item ao pedido:<br><br><b>";
                                    if (data.mensagem) {
                                        $.each(data.mensagem, function ($key, $message) {
                                            $text += (("- " + $message) + ((($key + 1) == data.mensagem.length) ? '' : '<br>'));
                                        });

                                        $text += "</b>";
                                    }

                                    swal({
                                        html: true,
                                        title: "Houve um problema ao adicionar o item ao pedido!",
                                        text: $text,
                                        type: "error"
                                    });
                                }
                            }).fail(function (error) {
                                console.log(error);
                                toastr.error(error.statusText, 'Não foi possível realizar esta transação!');
                            });
                        }
                    }
                );
            }
        }).fail(function (error) {
            console.log(error);
        });
    });

    $(document).on('click', '.btn-add-campanha-pedido', function () {
        var $pedido = ($(this).attr('data-pedido') == undefined ? 0 : $(this).attr('data-pedido'));
        var $campanha = $('input[name="campanha"]').val();
        var $quantidade = $('input[name="quantidade"]').val();

        var $bt = $(this);
        $bt.ladda();
        $bt.ladda('start');

        $.post('/distribuidor/pedido/incluircampanhapedido', {pedido: $pedido, campanha: $campanha, quantidade: $quantidade}, function (data) {
            if (data.status) {
                $('#modalPedido').modal('hide');

                swal({
                    title: "A campanha foi adicionada ao pedido com sucesso!",
                    text: "Campanha adicionada ao pedido!",
                    type: "success"
                }, function (isConfirm) {
                    if (isConfirm) {
                        window.location.href = data.url;
                    }
                });
            } else {
                var $text = "Log de inclusão da campanha no pedido:<br><br><b>";
                if (data.mensagem) {
                    $.each(data.mensagem, function ($key, $message) {
                        $text += (("- " + $message) + ((($key + 1) == data.mensagem.length) ? '' : '<br>'));
                    });

                    $text += "</b>";
                }

                swal({
                    html: true,
                    title: "Houve um problema ao adicionar a campanha ao pedido!",
                    text: $text,
                    type: "error"
                });
            }

            $bt.ladda('stop');
        }).fail(function (error) {
            console.log(error);
            toastr.error(error.statusText, 'Não foi possível realizar esta transação!');

            $bt.ladda('stop');
        });
    });

    $(document).on('click', '.btn-add-material-pedido, .btn-new-pedido-produto', function () {
        var $bt = $(this);
        $bt.ladda();
        $bt.ladda('start');

        var $materiais = [];
        var $pedido = ($(this).attr('data-pedido') == undefined ? 0 : $(this).attr('data-pedido'));
        var $redirect = ($(this).attr('data-redirect') == undefined ? 0 : $(this).attr('data-redirect'));
        $('.material-quantidade').each(function (index) {
            if ($(this).val() !== undefined && $(this).val() !== '') {
                $materiais.push({
                    'id': $(this).attr('id'),
                    'quantidade': $(this).val()
                })
            }
        });

        $.post('/distribuidor/pedido/incluiritempedido', {pedido: $pedido, materiais: $materiais}, function (data) {
            if (data.status) {
                $('#modalAddPedido').modal('hide');

                swal({
                    title: "Item foi adicionado ao pedido com sucesso!",
                    text: "Item foi adicionado ao pedido!",
                    type: "success"
                }, function (isConfirm) {
                    if (isConfirm && $redirect == 1) {
                        window.location.href = data.url;
                    }
                });
            } else {
                var $text = "Não foi possível incluir o item ao pedido:<br><br><b>";
                if (data.mensagem) {
                    $.each(data.mensagem, function ($key, $message) {
                        $text += (("- " + $message) + ((($key + 1) == data.mensagem.length) ? '' : '<br>'));
                    });

                    $text += "</b>";
                }

                swal({
                    html: true,
                    title: "Houve um problema ao adicionar o item ao pedido!",
                    text: $text,
                    type: "error"
                });
            }

            $bt.ladda('stop');
        }).fail(function (error) {
            console.log(error);
            toastr.error(error.statusText, 'Não foi possível realizar esta transação!');

            $bt.ladda('stop');
        });
    });

    $(document).on('click', '.btn-add-bonus-pedido', function (e) {
        var $materiais = [];
        var $pedido = 0;
        var $getUrl = '/distribuidor/pedido/obterpedidosabertos/produto';
        var $tipo = $(this).attr('tipo');
        var $bonificacao = $(this).attr('bonificacao');

        $('.panel-load').addClass('whirl standard');

        if ($tipo == 'direto') {
            $getUrl = '/distribuidor/pedido/obterpedidosabertos/direto';
        }

        if ($tipo == 'marketing') {
            $getUrl = '/distribuidor/pedido/obterpedidosabertos/marketing';
        }

        $('.material-quantidade').each(function (index) {
            if ($(this).val() !== undefined && $(this).val() !== '') {
                $materiais.push({
                    'id': $(this).attr('id'),
                    'quantidade': $(this).val(),
                    'bonificacao': $bonificacao
                });
            }
        });

        $.post('/distribuidor/pedido/checklimitebonificacao', {materiais: $materiais, tipo: $tipo}, function (data) {
            $('.panel-load').removeClass('whirl standard');

            if (!(data instanceof Object)) {
                toastr.error('Ocorreu um problema ao tentar validar as quantidades de itens bonificados!', 'Transação não pode ser realizada!');
                return false;
            }

            if (!data.status) {
                $.each(data.mensagem, function (key, item) {
                    toastr.warning(item, "ATENÇÃO!");
                });

                return false;
            }

            $('.panel-load').addClass('whirl standard');
            $.get($getUrl, function (data) {
                $('.btn-new-bonus-pedido-produto').attr('tipo-conta', $tipo);
                $('.panel-load').removeClass('whirl standard');

                if (data.status) {
                    $('#tBodyPedidosAbertos').html('').html(data.html);
                    $('#modalAddPedido').modal('show');
                } else if (!data.status && data.mensagem == 'Nenhum pedido em aberto para esse cliente!') {
                    swal({
                            html: true,
                            title: "Não existem pedidos aberto!",
                            text: "Deseja incluir um novo pedido?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Sim, desejo!",
                            cancelButtonText: "Não, cancele!",
                            closeOnConfirm: false,
                            closeOnCancel: true,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                $('.panel-load').addClass('whirl standard');

                                $.post('/distribuidor/pedido/incluiritembonuspedido', {pedido: $pedido, materiais: $materiais, tipo: $tipo}, function (data) {
                                    $('.panel-load').removeClass('whirl standard');

                                    if (data.status) {
                                        swal({
                                            title: "Item foi adicionado ao pedido com sucesso!",
                                            text: "Item foi adicionado ao pedido!",
                                            type: "success"
                                        }, function (isConfirm) {
                                            if (isConfirm) {
                                                window.location.href = data.url;
                                            }
                                        });
                                    } else {
                                        var $text = "Não foi possível incluir o item ao pedido:<br><br><b>";
                                        if (data.mensagem) {
                                            $.each(data.mensagem, function ($key, $message) {
                                                $text += (("- " + $message) + ((($key + 1) == data.mensagem.length) ? '' : '<br>'));
                                            });

                                            $text += "</b>";
                                        }

                                        swal({
                                            html: true,
                                            title: "Houve um problema ao adicionar o item ao pedido!",
                                            text: $text,
                                            type: "error"
                                        });
                                    }
                                }).fail(function (error) {
                                    $('.panel-load').removeClass('whirl standard');

                                    console.log(error);
                                    toastr.error(error.statusText, 'Não foi possível realizar esta transação!');
                                });
                            }
                        }
                    );
                }
            }).fail(function (error) {
                $('.panel-load').removeClass('whirl standard');
                console.log(error);
            });
        }).fail(function (error) {
            $('.panel-load').removeClass('whirl standard');
            console.log(error);
            toastr.error("Não foi possível calcular as quantidades e valores de bonificação!", "Transação não pode ser realizada!");
        });
    });

    $(document).on('click', '.btn-add-bonus-material-pedido, .btn-new-bonus-pedido-produto', function () {
        var $bt = $(this);
        $bt.ladda();
        $bt.ladda('start');

        var $materiais = [];
        var $pedido = ($(this).attr('data-pedido') == undefined ? 0 : $(this).attr('data-pedido'));
        var $tipo = $bt.attr('tipo-conta');
        $('.panel-load').addClass('whirl standard');

        $('.material-quantidade').each(function (index) {
            if ($(this).val() !== undefined && $(this).val() !== '') {
                if ($tipo == 'direto' || $tipo == 'marketing') {
                    $materiais.push({
                        'id': $(this).attr('id'),
                        'quantidade': $(this).val(),
                        'bonificacao': 1
                    });
                } else {
                    $materiais.push({
                        'id': $(this).attr('id'),
                        'quantidade': $(this).val()
                    });
                }
            }
        });

        $.post('/distribuidor/pedido/incluiritembonuspedido', {pedido: $pedido, materiais: $materiais, tipo: $tipo}, function (data) {
            $('.panel-load').removeClass('whirl standard');

            if (data.status) {
                $('#modalAddPedido').modal('hide');

                swal({
                    title: "Item foi adicionado ao pedido com sucesso!",
                    text: "Item foi adicionado ao pedido!",
                    type: "success"
                }, function (isConfirm) {
                    if (isConfirm) {
                        window.location.href = data.url;
                    }
                });
            } else {
                var $text = "Não foi possível incluir o item ao pedido:<br><br><b>";
                if (data.mensagem) {
                    $.each(data.mensagem, function ($key, $message) {
                        $text += (("- " + $message) + ((($key + 1) == data.mensagem.length) ? '' : '<br>'));
                    });

                    $text += "</b>";
                }

                swal({
                    html: true,
                    title: "Houve um problema ao adicionar o item ao pedido!",
                    text: $text,
                    type: "error"
                });
            }

            $bt.ladda('stop');
        }).fail(function (error) {
            $('.panel-load').removeClass('whirl standard');

            console.log(error);
            toastr.error(error.statusText, 'Não foi possível realizar esta transação!');

            $bt.ladda('stop');
        });
    });

    $(document).on('click', '.btn-extorno-bonus', function () {
        var $item = $(this).attr('data-id');

        swal({
                html: true,
                title: "O item será removido e estornado o valor utilizado a conta corrente de bônus!",
                text: "Deseja continuar mesmo assim?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.get('/distribuidor/pedido/extornobonus/' + $item, function (data) {
                        if (!(data instanceof Object)) {
                            swal({
                                html: true,
                                title: "Houve um problema ao tentar realizar o estorno!",
                                text: "Não foi possível nesse momento realizar o estorno ",
                                type: "error"
                            });

                            return false;
                        }

                        if (!data.status) {
                            var $text = '';
                            $.each(data.mensagem, function (key, item) {
                                $text += item + "<br>";
                            });

                            swal({
                                html: true,
                                title: "Houve um problema ao tentar realizar o estorno!",
                                text: ("Não foi possível nesse momento realizar o estorno, devido:<br>" + $text),
                                type: "error"
                            });

                            return false;
                        }

                        swal({
                            html: true,
                            title: "Item removido com sucesso!",
                            text: "O item foi removido e gerado o extorno a conta corrente de bônus com sucesso!",
                            type: "success"
                        }, function () {
                            window.location.reload();
                        });
                    }).fail(function (error) {
                        console.log(error);

                        swal({
                            html: true,
                            title: "Houve um problema ao tentar realizar o estorno!",
                            text: "Não foi possível nesse momento realizar o estorno ",
                            type: "error"
                        });
                    });
                }
            }
        );
    });

    $(document).on('click', '.btn-salvar-pedido', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $bt = $(this);
        $bt.ladda();
        $bt.ladda('start');

        var $id = $('input[name="id"]').val();
        window.sessionStorage.removeItem('pedido_recalculado');

        $.get('/distribuidor/pedido/checkcampanha/' + $id, function (data) {
            if (data.status) {
                if (data.alertas != '') {
                    swal({
                        html: true,
                        title: "Ganhe materiais bonificados!!!",
                        text: data.alertas,
                        type: "info"
                    }, function () {
                        if (data.campanhas != '') {
                            setTimeout(function () {
                                swal({
                                        html: true,
                                        title: "Você tem direito a materiais bonificados!",
                                        text: "Deseja incluir os itens bonificados no pedido?<br>" + data.campanhas,
                                        type: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Sim, desejo!",
                                        cancelButtonText: "Não, cancele!",
                                        closeOnConfirm: false,
                                        closeOnCancel: true,
                                        showLoaderOnConfirm: true
                                    },
                                    function (isConfirm) {
                                        if (isConfirm) {
                                            $('input[name="hasCampanha"]').val(1);
                                        } else {
                                            $('input[name="hasCampanha"]').val(0);
                                        }

                                        $('#formPedido').submit();
                                    }
                                );
                            }, 1500);
                        } else {
                            $('#formPedido').submit();
                        }
                    });
                } else {
                    swal({
                            html: true,
                            title: "Você tem direito a materiais bonificados!",
                            text: "Deseja incluir os itens bonificados no pedido?<br>" + data.campanhas,
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Sim, desejo!",
                            cancelButtonText: "Não, cancele!",
                            closeOnConfirm: false,
                            closeOnCancel: true,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                $('input[name="hasCampanha"]').val(1);
                            } else {
                                $('input[name="hasCampanha"]').val(0);
                            }

                            $('#formPedido').submit();
                        }
                    );
                }
            } else {
                $('#formPedido').submit();
            }

            $bt.ladda('stop');
        }).fail(function (error) {
            $bt.ladda('stop');
            console.log(error);
            toastr.error(error.statusText, 'Transação não pode ser realizada!');
        });
    });

    $(document).on('click', '.pedido-faturamento-boletos', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.div-faturas-boletos').removeClass('hidden');
        var $id = $(this).attr('itemid');
        $.get('/distribuidor/pedido/boletos/' + $id, function (data) {
            if (data.status) {
                $('.lista-faturas-boletos').html(data.html);
            } else {
                $('.lista-faturas-boletos').html("<tr><td class='text-center p-md' colspan='15'>Nada para mostrar</td></tr>");
            }
        }).fail(function (error) {
            $('.lista-faturas-boletos').html("<tr><td class='text-center p-md' colspan='15'>Nada para mostrar</td></tr>");
        });
    });

    $(document).on('click', '.pedido-faturamento-boletos-atualizar', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.splash').css('display', 'block');
        let $pedido = $(this).attr('pedido');

        $.post('/cron/buscarboletosporpedido', {pedido_onclick: $pedido}, function (data) {
            $.each(data.faturas, function ($key, $message) {
                if ($message.status) {
                    toastr.success($message.message);
                } else {
                    toastr.error($message.message);
                }
            });

            $('.div-faturas-boletos').addClass('hidden');
            $('.splash').css('display', 'none');
        }).fail(function (error) {
            toastr.error('Ocorreu uma falha ao tentar setar na sessão o modelo escolhido!');
            $('.splash').css('display', 'none');
        });


    });

    $(document).on('click', '.addModeloRelacionamento', function (e) {
        var $modelo_api = $(this).attr('valor');
        var $modelo = $(this).attr('modelo');
        $('.choice-modelo-' + $modelo_api).html('').html('<i class="text-success fa fa-check fa-5x" style="padding-top: 30px;"></i>');

        $.post('/cadastro/modelo/setrelacionamentoapi', {id_api: $modelo_api, modelo: $modelo}, function (data) {
            if (data.status) {
                if ($modelo_api != data.modeloApiAnt) {
                    $('.choice-modelo-' + data.modeloApiAnt).html('');
                    $('.addModeloRelacionamento[valor="' + (data.modeloApiAnt == null ? $modelo : data.modeloApiAnt) + '"]').removeClass('selected');
                }

                $('.addModeloRelacionamento[valor="' + $modelo_api + '"]').addClass('selected');
            } else {
                toastr.warning(data.mensagem, 'Transação não pode ser realizada!');
            }
        }).fail(function (error) {
            toastr.error('Ocorreu uma falha ao tentar setar na sessão o modelo escolhido!');
        });
    });

    $(document).on('click', '.btn-salvar-api', function () {
        var $modeloApi = $('.addModeloRelacionamento.selected').attr('valor');
        var $modelo = $('.addModeloRelacionamento.selected').attr('modelo');

        $.post('/cadastro/modelo/inserirrelacionamentoapi', {modelo_api: $modeloApi, modelo: $modelo}, function (data) {
            if (data.status) {
                window.location.href = data.url;
                toastr.success('Registro incluído com sucesso!');
            } else {
                $.each(data.mensagem, function (key, value) {
                    toastr.error(value, "Transação não pode ser realizada!");
                })
            }
        }).fail(function (error) {
            toastr.error(error.statusText, 'Não foi possível realizar a transação!');
        });
    });

    $(document).on('click', '.btn-atualizar-api', function () {
        $('.splash').css('display', 'block');

        $.get('/cadastro/modelo/atualizar', function (data) {
            if (!data.status) {
                $.each(data.mensagem, function (key, valor) {
                    toastr.error(valor, 'Não foi possível realizar a transação!');
                });
            } else {
                toastr.success('Registros atualizados com sucesso!', 'Transação concluída com sucesso!');
                window.location.reload(true);
            }

            $('.splash').css('display', 'none');
        })
    });

    $(document).on('ifChanged', '#gerarPedido', function (e) {
        var isChecked = e.currentTarget.checked;

        var $session = window.sessionStorage;
        var $listOs = ($session.getItem('listaOs') != null ? JSON.parse($session.getItem('listaOs')) : []);
        if ($listOs.length > 0) {
            var $cliente = '';
            var $clienteDiferente = false;
            $.each($listOs, function ($checkClienteKey, $checkClienteValue) {
                if ($checkClienteValue.cliente !== $cliente && $cliente !== '' && isChecked) {
                    setTimeout(function () {
                        $('#gerarPedido').iCheck('uncheck');
                    }, 1000);
                    toastr.warning('Só é possível gerar pedido comercial das ordens de serviço de um único cliente!', 'Escolha somente ordens de um único cliente!');

                    $clienteDiferente = true;
                    return false;
                }

                $cliente = $checkClienteValue.cliente;
                $checkClienteValue.gerar_pedido = (isChecked ? 't' : 'f');
            });

            if ($clienteDiferente) return false;
            $session.setItem('listaOs', JSON.stringify($listOs));
        }

        $('.form-pesquisa input[name="gerar_pedido"]').val((isChecked ? 't' : 'f'));
        //$('.form-pesquisa').submit();
    });

    $(document).on('ifChanged', '#gerarTransporte', function (e) {
        var isChecked = e.currentTarget.checked;

        var $session = window.sessionStorage;
        var $listOs = ($session.getItem('listaOs') != null ? JSON.parse($session.getItem('listaOs')) : []);
        if ($listOs.length > 0) {
            var $cliente = '';
            $.each($listOs, function ($checkClienteKey, $checkClienteValue) {
                if ($checkClienteValue.cliente !== $cliente && $cliente !== '' && isChecked) {
                    setTimeout(function () {
                        $('#gerarTransporte').iCheck('uncheck');
                    }, 2000);
                    toastr.warning('Só é possível gerar transporte das ordens de serviço de um único cliente!', 'Escolha somente ordens de um único cliente!');
                    return false;
                }

                $cliente = $checkClienteValue.cliente;
                $checkClienteValue.gerar_transporte = (isChecked ? 't' : 'f');
            });

            $session.setItem('listaOs', JSON.stringify($listOs));
        }

        $('.form-pesquisa input[name="gerar_transporte"]').val((isChecked ? 't' : 'f'));
    });

    $(document).on('change', 'select[name="tipo_transporte"]', function () {
        $('.visualizaCamposTransporte').removeClass('hidden');
        if ($(this).val() == 'Frete por conta fábrica') {
            $('.tpc').addClass('hidden');
            $('.tpf').removeClass('hidden');
            $('input[name="valor_transporte"]').attr('required', true);
        } else {

            $('.tpf').addClass('hidden');
            $('.tpc').removeClass('hidden');
            $('input[name="valor_transporte"]').removeAttr('required');
            $('input[name="tipo_de_servico"]').val('');
            $('input[name="rastreio_transporte"]').val('');
        }
    });

    $(document).on('click', '.finalizarOrdemServico', function (e) {
        var $os = $(this).attr('id');
        var $tipo = $(this).attr('type-os');
        var $cliente = $(this).attr('cliente');
        var $clienteId = $(this).attr('cliente_id');
        var $pedido = $(this).attr('pedido');
        var $session = window.sessionStorage;
        var $listOs = ($session.getItem('listaOs') != null ? JSON.parse($session.getItem('listaOs')) : []);
        var $choice = $('.choice-os-' + $os);

        if ($('.form-pesquisa input[name="gerar_pedido"]').val() == 't' || $('.form-pesquisa input[name="gerar_transporte"]').val() == 't') {
            if ($pedido !== '' || $pedido > 0){
                toastr.warning('Esse número de OS já foi gerado um pedido para ela, aguarde o retorno do comercial!', 'Pedido já enviado para faturamento!');
                return false;
            }

            var $clienteDiferente = false;
            var $tipoOsDiferente = false;
            $.each($listOs, function ($checkClienteKey, $checkClienteValue) {
                if ($checkClienteValue.cliente !== $cliente) {
                    $clienteDiferente = true;
                    return false;
                }

                if ($checkClienteValue.tipo !== $tipo) {
                    $tipoOsDiferente = true;
                    return false;
                }
            });

            if ($clienteDiferente && $('.form-pesquisa input[name="gerar_pedido"]').val() == 't') {
                toastr.warning('Só é possível gerar pedido comercial das ordens de serviço de um único cliente!', 'Escolha somente ordens de um único cliente!');
                return false;
            }

            if ($clienteDiferente && $('.form-pesquisa input[name="gerar_transporte"]').val() == 't') {
                toastr.warning('Só é possível gerar transporte das ordens de serviço de um único cliente!', 'Escolha somente ordens de um único cliente!');
                return false;
            }

            if ($tipoOsDiferente && $('.form-pesquisa input[name="gerar_pedido"]').val() == 't') {
                toastr.warning('Só é possível gerar pedido das ordens de serviço de um único tipo Remessa ou Reposição!', 'Escolha somente ordens de um único tipo!');
                return false;
            }
        }

        if (!$choice.hasClass('selected')) {
            $listOs.push({
                'id': $os,
                'tipo': $tipo,
                'cliente': $cliente,
                'cliente_id': $clienteId,
                'gerar_pedido': $('.form-pesquisa input[name="gerar_pedido"]').val(),
                'gerar_transporte': $('.form-pesquisa input[name="gerar_transporte"]').val()
            });
            $session.setItem('listaOs', JSON.stringify($listOs));

            $choice.addClass('selected');

            $('.choice-os-' + $os).html('').html('<i class="text-success fa fa-check fa-5x"></i>');
        } else {
            $.each($listOs, function ($key, $item) {
                if (_.isEqual($os, $item.id)) {
                    $listOs.splice($key, 1);
                    return false;
                }
            });

            $choice.removeClass('selected');
            $session.setItem('listaOs', JSON.stringify($listOs));

            $('.choice-os-' + $os).html('');
        }

        $listOs.length > 0 ? $('.btn-finalizar-os').removeClass('hidden') : $('.btn-finalizar-os').addClass('hidden');
    });

    $(document).on('click', '.btn-finalizar-os', function (e) {
        swal({
                html: true,
                title: "Deseja continuar mesmo assim?",
                text: "Todas as ordens de serviço serão finalizadas!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    var $session = window.sessionStorage;
                    var $listOs = ($session.getItem('listaOs') != null ? JSON.parse($session.getItem('listaOs')) : []);

                    if ($listOs.length > 0) {
                        swal.close();

                        $.post('/ordemservico/gerenciador/getorganizacaocanalclientes', {os: $listOs}, function(data){
                            if (data.status) {
                                if ($('.form-pesquisa input[name="gerar_transporte"]').val() == 't') {
                                    $('#administrador-transporte select[name="organizacao_vendas"]').html(data.html.organizacao);
                                    $('#administrador-transporte select[name="canal_distribuicao"]').html(data.html.canal);
                                    $('#modalTransportadora').modal({show: true, backdrop: 'static'}).on('shown.bs.modal', function () {
                                        $('input[name="ordens"]').val(b64EncodeUnicode($session.getItem('listaOs')));
                                    });
                                } else {
                                    $('#formOrganizacaoCanal select[name="organizacao_vendas"]').html(data.html.organizacao);
                                    $('#formOrganizacaoCanal select[name="canal_distribuicao"]').html(data.html.canal);
                                    $('#modalOrganizacaoCanal').modal({show: true, backdrop: 'static'}).on('shown.bs.modal', function () {
                                        $('input[name="os"]').val(b64EncodeUnicode($session.getItem('listaOs')));
                                    });

                                    /*$.post('/ordemservico/gerenciador/finalizaros', {os: JSON.stringify($session.getItem('listaOs'))}, function (data) {
                                        if (data.status) {
                                            $session.clear();
                                            var $messages = "Ordens de Serviço finalizadas!";

                                            if (data.mensagem.length > 0) {
                                                $messages = '"Ordens de Serviço finalizadas, porém há alguma inconsistência!"'
                                                $.each(data.mensagem, function ($key, $message) {
                                                    $messages += ($message + '<br>');
                                                });
                                            }

                                            swal({
                                                html: true,
                                                title: "Transaçao realizada com sucesso!",
                                                text: $messages,
                                                type: "success"
                                            }, function () {
                                                window.location.reload(true);
                                            });
                                        } else {
                                            var $textError = '';
                                            $.each(data.mensagem, function ($key, $message) {
                                                $textError += ($message + '<br>');
                                            });

                                            swal({
                                                html: true,
                                                title: "Transaçao não pode ser realizada!",
                                                text: "Houve um problema na finalização das Ordens!<br><br>" + $textError,
                                                type: "error"
                                            });
                                        }
                                    }).fail(function (error) {
                                        console.log(error);
                                        toastr.error('Ocorreu uma falha ao tentar finalizar a Ordem de Serviço!');
                                    });*/
                                }
                            }else {

                                var $textError = '';
                                $.each(data.mensagem, function ($key, $message) {
                                    $textError += ($message + '<br>');
                                });

                                toastr.error($textError);
                            }
                        }).fail(function(error){
                            console.log(error);
                            toastr.error('Ocorreu uma falha ao tentar finalizar a Ordem de Serviço!');
                        });
                    }
                }
            }
        );
    });

    $(document).on('submit', 'form[id="administrador-transporte"]', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();

        var $bt = $('.btn-transporte');
        $bt.ladda();
        $bt.ladda('start');

        var formData = new FormData(this);

        $.ajax({
            url: $(this).attr('action'),
            type: $(this).attr('method'),
            data: formData,
            success: function (data) {
                if (data.status) {
                    window.sessionStorage.clear();

                    swal({
                        title: "Transaçao realizada com sucesso!",
                        text: "Ordens de Serviço finalizadas!",
                        type: "success"
                    }, function () {
                        window.location.reload(true);
                    });
                } else {
                    swal({
                        title: "Transaçao não pode ser realizada!",
                        text: "Houve um problema na finalização das Ordens!",
                        type: "error"
                    });

                    $.each(data.mensagem, function ($key, $message) {
                        toastr.error($message, 'Transação não pode ser realizada!');
                    });
                }

                $bt.ladda('stop');
            },
            error: function (error) {
                console.log(error);
                toastr.error(error.statusText, 'Não foi possível realizar esta transação!');

                $bt.ladda('stop');
            },
            cache: false,
            contentType: false,
            processData: false,
            xhr: function () {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                    myXhr.upload.addEventListener('progress', function () {
                        /!* faz alguma coisa durante o progresso do upload *!/
                    }, false);
                }
                return myXhr;
            }
        });
    });

    $(document).on('submit', 'form[id="formOrganizacaoCanal"]', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();

        var $bt = $('.btn-organizacaocanal');
        $bt.ladda();
        $bt.ladda('start');

        var formData = new FormData(this);

        $.ajax({
            url: $(this).attr('action'),
            type: $(this).attr('method'),
            data: formData,
            success: function (data) {
                if (data.status) {
                    window.sessionStorage.clear();

                    swal({
                        title: "Transaçao realizada com sucesso!",
                        text: "Ordens de Serviço finalizadas!",
                        type: "success"
                    }, function () {
                        window.location.reload(true);
                    });
                } else {
                    var $mensagem = "Houve um problema na finalização das Ordens!<br>";
                    $.each(data.mensagem, function ($key, $message) {
                        $mensagem += $message + "<br>";
                    });

                    swal({
                        html: true,
                        title: "Transaçao não pode ser realizada!",
                        text: $mensagem,
                        type: "error"
                    });
                }

                $bt.ladda('stop');
            },
            error: function (error) {
                console.log(error);
                swal({
                    html: true,
                    title: "Transaçao não pode ser realizada!",
                    text: ("Houve um problema na finalização das Ordens!<br>" + error.statusText),
                    type: "error"
                });

                $bt.ladda('stop');
            },
            cache: false,
            contentType: false,
            processData: false,
            xhr: function () {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                    myXhr.upload.addEventListener('progress', function () {
                        /!* faz alguma coisa durante o progresso do upload *!/
                    }, false);
                }
                return myXhr;
            }
        });
    });

    $(document).on('click', '.btn-aguardando-aprovacao', function () {
        var $url = $('.btn-aguardando-aprovacao').attr('url');
        var $id = $('.btn-aguardando-aprovacao').attr('os-id');
        var $text = "";

        $.get('/distribuidor/assistencia-remessa/itemduplicadosemcorrecao/' + $id, function (data) {
            if (data.status && data.itens.length > 0) {
                $text = "A ordem de serviço possui itens que ainda não foram editados depois de duplicados, conforme abaixo:<br><br>";

                var $material = '';
                $.each(data.itens, function ($key, $item) {
                    if ($material == $item.material){
                        return true;
                    }

                    $text += $item.material + "<br>";
                    $material = $item.material;
                });

                $text += "<br>Deseja realmente continuar com o envio para aprovação da fábrica?";
            } else {
                $text = "A ordem de serviço será enviada para aprovação da Fábrica!";
            }

            swal({
                    html: true,
                    title: "Deseja continuar mesmo assim?",
                    text: $text,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Sim, desejo!",
                    cancelButtonText: "Não, cancele!",
                    closeOnConfirm: false,
                    closeOnCancel: true,
                    showLoaderOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        var $formValidate = $('#frmOrdemServico').validate().form();

                        if ($formValidate) {
                            window.url = $url;
                            $('#frmOrdemServico').submit();
                        } else {
                            setTimeout(function () {
                                swal({title: "Transaçao não pode ser realizada!", text: "Formulário inválido, verfiique e tente novamente!", type: "error"});
                            }, 3000);
                        }
                    }
                }
            );
        }).fail(function (error) {
            console.log(error);
            toastr.error("Não foi possível enviar a OS para aprovação da fábrica, contate o administrador!", 'Não foi possível realizar esta transação!');
        });
    });

    $(document).on('click', '.btn-expedicao', function () {
        var $url = $(this).attr('url');
        var $tipo = $(this).attr('tipo');
        var $tipoOs = $(this).attr('tipo-os');
        var $id = $(this).attr('os-id');
        var $text = '';
        var $status = 0;

        switch ($tipo) {
            case 'separacao':
                $text = "A ordem de serviço será enviada para separação na expedição!";
                $status = 11;
                break;
            case 'transporte':
                $text = "A ordem de serviço será enviada para expedição e despacho para o cliente/distribuidor!";
                $status = 10;
                break;
        }

        swal({
                html: true,
                title: "Deseja continuar mesmo assim?",
                text: $text,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.post($url, {id: $id, tipo_ordem: $tipoOs, status: $status}, function (data) {
                        if (data.status) {
                            swal({
                                title: "Transaçao realizada com sucesso!",
                                text: "A ordem de serviço foi enviada para " + ($tipo == "separacao" ? "ser separada na expedição!" : "expedição e despacho ao cliente/distribuidor"),
                                type: "success"
                            }, function () {
                                if ($tipo == 'transporte' && data.url !== undefined && data.url !== '') {
                                    window.location.href = data.url;
                                } else {
                                    window.location.reload(true);
                                }
                            });
                        } else {
                            $textError = '';
                            $.each(data.mensagem, function ($key, $message) {
                                $textError += $message + "<br>";
                            });

                            swal({html: true, title: "Transaçao não pode ser realizada!", text: $textError, type: "error"});
                        }
                    }).fail(function (error) {
                        console.log(error);
                        swal.close();
                        toastr.error('Ocorreu uma falha ao enviar a Ordem de Serviço para ' + ($tipo == "separacao" ? "ser separada na expedição!" : "expedição e despacho ao cliente/distribuidor"));
                    });
                }
            }
        );
    });

    $(document).on('click', '.btn-conferir', function () {
        var $url = $(this).attr('url');
        var $type = $(this).attr('type');
        var $text = '';
        var $textResposta = '';
        var $error = '';

        switch ($type) {
            case 'aguardando':
                $text = "A ordem de serviço adicionada na fila de conferência!";
                $textResposta = "A ordem de serviço foi adicionada a fila de conferência!";
                $error = "Ocorreu uma falha ao enviar a Ordem de Serviço para fila de conferência!"
                break;
            case 'conferencia':
                $text = "A ordem de serviço irá para conferência!";
                $textResposta = "A ordem de serviço foi está sendo conferida!";
                $error = "Ocorreu uma falha conferir a Ordem de Serviço!"
                break;
        }

        swal({
                html: true,
                title: "Deseja continuar mesmo assim?",
                text: $text,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.get($url, function (data) {
                        if (data.status) {
                            swal({
                                title: "Transaçao realizada com sucesso!",
                                text: $textResposta,
                                type: "success"
                            }, function () {
                                window.location.reload(true);
                            });
                        } else {
                            swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema na conferência da Ordem!", type: "error"});

                            $.each(data.mensagem, function ($key, $message) {
                                toastr.error($message, 'Transação não pode ser realizada!');
                            });
                        }
                    }).fail(function (error) {
                        console.log(error);
                        swal.close();
                        toastr.error($error);
                    });
                }
            }
        );
    });

    $(document).on('click', '.btn-manutencao-os', function () {
        var $url = $(this).attr('url');

        swal({
                html: true,
                title: "Deseja continuar mesmo assim?",
                text: "A ordem de serviço será adicionada em manutenção para o usuário logado!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.get($url, function (data) {
                        if (data.status) {
                            swal({
                                title: "Transaçao realizada com sucesso!",
                                text: "A ordem de serviço está com o técnico para manutenção!",
                                type: "success"
                            }, function () {
                                window.location.reload(true);
                            });
                        } else {
                            swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema na manutenção da Ordem!", type: "error"});

                            $.each(data.mensagem, function ($key, $message) {
                                toastr.error($message, 'Transação não pode ser realizada!');
                            });
                        }
                    }).fail(function (error) {
                        console.log(error);
                        swal.close();
                        toastr.error("Ocorreu uma falha ao direcionar a OS para a manutenção!", "Transação não pode ser realizada!");
                    });
                }
            }
        );
    });

    $(document).on('click', '.btn-inicio-manutencao-item', function () {
        var $url = $(this).attr('url');

        swal({
                html: true,
                title: "Deseja continuar mesmo assim?",
                text: "O item da ordem de serviço será adicionada em manutenção para o usuário logado!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.get($url, function (data) {
                        if (data.status) {
                            swal({
                                title: "Transaçao realizada com sucesso!",
                                text: "O item da ordem de serviço está com o técnico para manutenção!",
                                type: "success"
                            }, function () {
                                window.location.reload(true);
                            });
                        } else {
                            swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema na inicialização da manutenção da Ordem!", type: "error"});

                            $.each(data.mensagem, function ($key, $message) {
                                toastr.error($message, 'Transação não pode ser realizada!');
                            });
                        }
                    }).fail(function (error) {
                        console.log(error);
                        swal.close();
                        toastr.error("Ocorreu uma falha ao direcionar o item para a manutenção!", "Transação não pode ser realizada!");
                    });
                }
            }
        );
    });

    $(document).on('click', '.btn-remove-os-material', function () {
        var $url = $(this).attr('url');

        swal({
                html: true,
                title: "Deseja continuar mesmo assim?",
                text: "O item será removido permanentemente!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.get($url, function (data) {
                        if (data.status) {
                            swal({
                                title: "Transaçao realizada com sucesso!",
                                text: "O item removido da ordem de serviço com sucesso!",
                                type: "success"
                            }, function () {
                                window.location.reload(true);
                            });
                        } else {
                            swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema na remoção do item da Ordem!", type: "error"});

                            $.each(data.mensagem, function ($key, $message) {
                                toastr.error($message, 'Transação não pode ser realizada!');
                            });
                        }
                    }).fail(function (error) {
                        console.log(error);
                        swal.close();
                        toastr.error("Ocorreu uma falha tentar remover o item!", "Transação não pode ser realizada!");
                    });
                }
            }
        );
    });

    $(document).on('click', '.btn-duplicar-os-material_salve', function () {
        $('#duplicar_item').modal('hide');
        var $id = $('#numero_os').val()
        var $quantidade = $('#quantidade').val();
    
        swal({
                html: true,
                title: "DESEJA MULTIPLICAR EM "+$quantidade+" VEZES O ITEM SELECIONADO?",
                text: "O item será duplicado contendo as mesmas informações do item pai, caso os dados fiscais e de defeitos sejam diferente após a duplicação edite-o para aplicar os dados novos!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true,
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.get('/distribuidor/assistencia-remessa/clone/' + $id +'/'+ $quantidade , function (data) {
                        if (data.status) {
                            swal({
                                title: "Transaçao realizada com sucesso!",
                                text: "O item da ordem de serviço foi duplicado com sucesso!",
                                type: "success"
                            }, function () {
                                window.location.reload(true);
                            });
                        } else {
                            swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema ao tentar duplicar o item da Ordem!", type: "error"});

                            $.each(data.mensagem, function ($key, $message) {
                                toastr.error($message, 'Transação não pode ser realizada!');
                            });
                        }
                    }).fail(function (error) {
                        console.log(error);
                        swal.close();
                        toastr.error("Ocorreu uma falha tentar duplicar o item!", "Transação não pode ser realizada!");
                    });
                }
            }
        );
    });

    $(document).on('change', '#frmContato, #formEditarContato, #form-relatorio select[name="tipo"]', function (e) {
        makeVertenteProblema();
    });

    $(document).on('click', ".btn-reabertura-contato", function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        var $url = $(this).attr('href');

        swal({
                html: true,
                title: "Deseja continuar mesmo assim?",
                text: "O contato será reaberto e liberado para interações!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    window.location.href = $url;
                }

                swal.close();
                return false;
            });
    });

    $(document).on('change', 'input[name="tipo_manutencao"]', function () {
        if ($(this).val() == '0') {
            $('#tipoManutencaoForaGarantia').attr('checked', 'checked');
            $('#tipoMantencaoEmGarantia').removeAttr('checked');

            $('.valor-orcamento').fadeIn();
            $('.material-troca').fadeOut();
            $('.btn-aprovacao-tecnico[status="finalizar"]').fadeOut();

            $('.valor-servico').removeClass('hidden');
            $('.valor-pecas').removeClass('hidden');
            $('#divCobrancaPecas').removeClass('hidden');
            $('#divTipoManutencao').addClass('border-right');

            $('#divManutencaoTroca').addClass('hidden');
            $('#divEstruturaMaterial').removeClass('hidden');
        } else {
            $('#tipoMantencaoEmGarantia').attr('checked', 'checked');
            $('#tipoManutencaoForaGarantia').removeAttr('checked');

            $('.valor-orcamento').fadeOut();
            $('.material-troca').fadeIn();
            $('.btn-aprovacao-tecnico[status="finalizar"]').fadeIn();

            $('.valor-servico').addClass('hidden');
            $('.valor-pecas').addClass('hidden');
            $('#divCobrancaPecas').addClass('hidden');
            $('#divTipoManutencao').removeClass('border-right');

            $('#divManutencaoTroca').removeClass('hidden');
            $('#divEstruturaMaterial').addClass('hidden');
        }

        $('#cobrarPecasSim').iCheck('uncheck');
        $('#cobrarPecasNao').iCheck('check');
        $('#cobrarPecasNao').iCheck('update');

        $('#divEstruturaMaterial')
            .find(".material-quantidade")
            .each(function (index) {
                $(this).val('');
            });

        var $configMaterial = {
            attrElement: 'name',
            nameElement: 'material_troca',
            elementDropDownParent: $('.form-group-materia-troca'),
            url: "/cadastro/material/componenteautocomplete"
        };

        configureSelect2WithAutocomplete($configMaterial, false);

        $('input[name="valor_manutencao"]').val('');
    });

    $(document).on('change', 'input[name="tipo"]', function (e) {
        switch (e.target.value) {
            case '0':
                $('#divEstruturaMaterial').removeClass('hidden');
                $('.material-troca').addClass('hidden');
                break;
            case '1':
                $('#divEstruturaMaterial').addClass('hidden');
                $('.material-troca').removeClass('hidden');

                $('#divEstruturaMaterial')
                    .find(".material-quantidade")
                    .each(function (index) {
                        $(this).val('');
                    });
                break;
        }
    });

    $(document).on('click', '.btn-modal-apravacao-orcamento', function () {
        var $id = $(this).attr('os-id');
        var $bt = $('.btn-modal-apravacao-orcamento');
        $bt.ladda();
        $bt.ladda('start');

        $.get('/distribuidor/assistencia-remessa/orcamentoestrutura/' + $id, function (data) {
            if (data.status) {
                $('.modal-orcamento').html('').html(data.html);
                $('#modalAprovacaoOrcamento').modal({show: true, backdrop: 'static'}).on('shown.bs.modal', function () {

                });
            } else {
                $.each(data.mensagem, function (keyMessage, message) {
                    toastr.error(message, "Não foi possível realizar a transação!");
                });
            }
        }).done(function () {
            $bt.ladda('stop');
        }).fail(function (error) {
            console.log(error);
            toastr.error("Houve um problema ao buscar os dados de orçamento, tente mais tarde!", "Não foi possível realizar a transação!");
        });
    });

    $(document).on('change', '.select-material', function () {
        var $id = $('.btn-modal-apravacao-orcamento').attr('os-id');
        var $item = $(this).val();

        $('.modal-orcamento').html('<div class="splash-orcamento"><div class="color-line"></div><div class="splash-title"><h1>NICE</h1><p>Estamos processando sua requisição aguarde um momento.</p><div class="spinner"><div class="rect1 m-r-xs"></div><div class="rect2 m-r-xs"></div><div class="rect3 m-r-xs"></div><div class="rect4 m-r-xs"></div><div class="rect5"></div></div></div></div>');
        $.get('/distribuidor/assistencia-remessa/orcamentoestrutura/' + $id + '/' + $item, function (data) {
            if (data.status) {
                $('.modal-orcamento').html('').html(data.html);
                $('#modalAprovacaoOrcamento').modal({show: true, backdrop: 'static'}).on('shown.bs.modal', function () {

                });
            } else {
                $.each(data.mensagem, function (keyMessage, message) {
                    toastr.error(message, "Não foi possível realizar a transação!");
                });
            }
        }).fail(function (error) {
            console.log(error);
            toastr.error("Houve um problema ao buscar os dados de orçamento, tente mais tarde!", "Não foi possível realizar a transação!");
        });
    });

    $(document).on('click', '.btn-orcamento', function (e) {
        e.preventDefault();

        var $f = $('#distribuidor-remessa-orcamento'),
            $d = $f.serializeArray(),
            $r = true,
            $rp = false,
            $ap = false;

        $.each($d, function (i, field) {
            //console.log(field.name + ":" + field.value + " ");
            if (field.name == 'orcamento_aprovacao' && !field.value.replace(/\s/g, '').length) {
                toastr.error('Marque uma das opções para aprovar ou reprovar o orçamento.');
                $r = false;
            }
            if (field.name == 'orcamento_aprovacao') {
                $ap = true;
            }
            if (field.name == 'orcamento_aprovacao' && field.value == '0') {
                $rp = true;
            }
            if (field.name == 'orcamento_observacao' && !field.value.replace(/\s/g, '').length && $rp) {
                toastr.error('O campo Observação deve ser preenchido no caso de reprova.');
                $r = false;
            }
        });

        if (!$ap) {
            toastr.error('Para continuar marque uma das opções para aprovar ou reprovar o orçamento!');
            $r = false;
        }

        if ($r === true) {

            $f.submit();
        }
    });

    $(document).on('blur', '#q3 input, #q3 select', function (e) {
        var validateForm = false;
        $.each($('#q3 input, #q3 select'), function (key, input) {
            if (input.value.replace(/\s/g, '').length) {
                validateForm = true;
                return false;
            }
        });

        if ($('#identificacao').val() == '' || $('#identificacao').val() == 1) {
            validateForm = false;
        }

        if (validateForm) {
            $("#frmOrdemServico").validate();
            $("#frmContato, #formEditarContato").validate();

            $("#cpf").rules('add', {required: true, messages: {required: "Informe um CPF para o consumidor."}});
            $("#identificacao").rules('add', {required: true, messages: {required: "Informe a identificação do consumidor."}});
            $("#nome").rules('add', {required: true, messages: {required: "Informe o nome do consumidor."}});
            $("#celular").rules('add', {required: true, messages: {required: "Informe o telefone do consumidor."}});
            $("#cep").rules('add', {required: true, messages: {required: "Informe o cep do consumidor."}});
            $("#logradouro").rules('add', {required: true, messages: {required: "Informe o endereço do consumidor."}});
            $("#numero").rules('add', {required: true, messages: {required: "Informe o número do endereço para o consumidor."}});
            $("#bairro").rules('add', {required: true, messages: {required: "Informe o bairro do endereço para o consumidor."}});
            $("#cidade").rules('add', {required: true, messages: {required: "Informe a cidade do endereço para o consumidor."}});
            $("#estado").rules('add', {required: true, messages: {required: "Informe o estado do endereço para o consumidor."}});
        } else {
            $("#cpf").rules('remove', 'required');
            $("#identificacao").rules('remove', 'required');
            $("#nome").rules('remove', 'required');
            $("#celular").rules('remove', 'required');
            $("#cep").rules('remove', 'required');
            $("#logradouro").rules('remove', 'required');
            $("#numero").rules('remove', 'required');
            $("#bairro").rules('remove', 'required');
            $("#cidade").rules('remove', 'required');
            $("#estado").rules('remove', 'required');

            $("#cpf").val('');
            //$("#identificacao").val('');
            $("#nome").val('');
            $("#telefone").val('');
            $("#email").val('');
            $("#cep").val('');
            $("#logradouro").val('');
            $("#numero").val('');
            $("#bairro").val('');
            $("#cidade").val('');
            $("#estado").val('');
        }
    });

    $(document).on('change', '#form-relatorio select[name="cliente"]', function () {
        var id = $(this).val();
        var url = ((id != '') ? '/cadastro/cliente/getclienteusuario/' + id : '/acesso/usuario/usuariosall/5');

        $.get(url, function (data) {
            if (data.status) {
                var options = '<option value=""></option>';
                $.each(data.data, function (key, value) {
                    options += '<option value="' + key + '">' + value + '</option>';
                });

                $('#form-relatorio select[name="cliente_usuario"]').html('').html(options);
            }
        }).fail(function (error) {
            console.log(error);
            toastr.error('Ocorreu um problema ao buscar os atendentes do distribuidor.<br>Erro: ' + error.statusText, 'Transação não pode ser realizada!');
        });
    });

    $(document).on('click', '#chart-totais', function (evt) {
        var activePoints = window.myTotais.getElementsAtEvent(evt);
        var firstPoint = activePoints[0];
        var label = window.myTotais.data.labels[firstPoint._index];
        var value = window.myTotais.data.datasets[firstPoint._datasetIndex].data[firstPoint._index];
        var form = $('form[name="form-relatorio"]').serializeObject();
        form.segmento = $('#segmento').val();

        if (label == 'Não Respondidas') {
            $.post('/contato/gerenciador/htmlavaliacao', {tipo: label, form: form}, function (data) {
                if (data.status) {
                    $('#divTableAvaliacaoMacro').removeClass('hidden');

                    $('#divTableAvaliacaoExpand').addClass('hidden');
                    $('#divTableAvaliacaoExpand').html('');

                    $('#divTableAvaliacaoResumo').addClass('hidden');
                    $('#divTableAvaliacaoMacro').html('').html(data.html_nao_respondida);
                }
            }).fail(function (error) {
                alert('Error: ' + error.statusText + '\\n' + label + ': ' + value);
            });
        } else {
            $.post('/contato/gerenciador/resumoavaliacao', {tipo: label, form: form}, function (data) {
                if (data.status) {
                    $('#divTableAvaliacaoMacro').addClass('hidden');
                    $('#divTableAvaliacaoMacro').html('');

                    $('#divTableAvaliacaoExpand').addClass('hidden');
                    $('#divTableAvaliacaoExpand').html('');

                    $('#divTableAvaliacaoResumo').removeClass('hidden');
                    $('#divTableAvaliacaoResumo').removeClass('hidden');
                    $('.resumo-avaliacao').html('').html(data.html_resumo);
                }
            }).fail(function (error) {
                alert('Error: ' + error.statusText + '\\n' + label + ': ' + value);
            });
        }
    });

    $(document).on('click', '#chart-nivel-satisfacao', function (evt) {
        var activePoints = window.myNiveilSatisfacao.getElementsAtEvent(evt);
        var firstPoint = activePoints[0];
        var label = window.myNiveilSatisfacao.data.labels[firstPoint._index];
        var value = window.myNiveilSatisfacao.data.datasets[firstPoint._datasetIndex].data[firstPoint._index];
        var form = $('form[name="form-relatorio"]').serializeObject();

        switch (label) {
            case "Insatisfeito":
                form.nivel = 1;
                break;
            case "Pouco Satisfeito":
                form.nivel = 2;
                break;
            case "Indiferente":
                form.nivel = 3;
                break;
            case "Satisfatório":
                form.nivel = 4;
                break;
            case "Muito Satisfatório":
                form.nivel = 5;
                break;
        }

        $.post('/contato/gerenciador/resumoavaliacao', {form: form}, function (data) {
            if (data.status) {
                if (data.html_detalhe == undefined) {
                    $('#divTableAvaliacaoExpand').addClass('hidden');
                    $('#divTableAvaliacaoExpand').html('');
                } else {
                    $('#divTableAvaliacaoExpand').removeClass('hidden');
                    $('#divTableAvaliacaoExpand').html('').html(data.html_detalhe);
                }

                $('#divTableAvaliacaoMacro').addClass('hidden');
                $('#divTableAvaliacaoMacro').html('');

                $('#divTableAvaliacaoResumo').removeClass('hidden');
                $('.resumo-avaliacao').html('').html(data.html_resumo);
            }
        }).fail(function (error) {
            alert('Error: ' + error.statusText + '\\n' + label + ': ' + value);
        });
    });

    $(document).on('click', '.link-nivel', function () {
        var $form = $('form[name="form-relatorio"]').serializeObject();
        $form.nivel = $(this).attr('nivel');
        $form.expandAll = false;

        $.post('/contato/gerenciador/detalheavaliacao', {form: $form}, function (data) {
            if (data.status) {
                $('#divTableAvaliacaoMacro').addClass('hidden');
                $('#divTableAvaliacaoMacro').html('');

                $('#divTableAvaliacaoExpand').removeClass('hidden');
                $('#divTableAvaliacaoExpand').html('').html(data.html_detalhe);
            } else {
                swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema ao obter o detalhe do relatório!", type: "error"});

                $.each(data.mensagem, function ($key, $message) {
                    toastr.error($message, 'Transação não pode ser realizada!');
                });
            }
        }).fail(function (error) {
            console.log(error);
            toastr.error('Houve um problema ao tentar buscar os detalhes do resumo da avaliação.<br>Erro: '.error.statusText, 'Transação não pode ser realizada!');
        });
    });

    $(document).on('click', '.link-percentual-nivel', function () {
        var $form = $('form[name="form-relatorio"]').serializeObject();
        $form.nivel = $(this).attr('nivel');
        $form.pergunta = $(this).attr('pergunta');
        $form.expandAll = false;

        $.post('/contato/gerenciador/detalheavaliacao', {form: $form}, function (data) {
            if (data.status) {
                $('#divTableAvaliacaoMacro').addClass('hidden');
                $('#divTableAvaliacaoMacro').html('');

                $('#divTableAvaliacaoExpand').removeClass('hidden');
                $('#divTableAvaliacaoExpand').html('').html(data.html_detalhe);
            } else {
                swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema ao obter o detalhe do relatório!", type: "error"});

                $.each(data.mensagem, function ($key, $message) {
                    toastr.error($message, 'Transação não pode ser realizada!');
                });
            }
        }).fail(function (error) {
            console.log(error);
            toastr.error('Houve um problema ao tentar buscar os detalhes do resumo da avaliação.<br>Erro: '.error.statusText, 'Transação não pode ser realizada!');
        });
    });

    $(document).on('click', '.btn-expandir-all', function () {
        var $form = $('form[name="form-relatorio"]').serializeObject();
        $form.expandAll = true;

        $.post('/contato/gerenciador/detalheavaliacao', {form: $form}, function (data) {
            if (data.status) {
                $('#divTableAvaliacaoMacro').addClass('hidden');
                $('#divTableAvaliacaoMacro').html('');

                $('#divTableAvaliacaoExpand').removeClass('hidden');
                $('#divTableAvaliacaoExpand').html('').html(data.html_detalhe);
            } else {
                swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema ao obter o detalhe do relatório!", type: "error"});

                $.each(data.mensagem, function ($key, $message) {
                    toastr.error($message, 'Transação não pode ser realizada!');
                });
            }
        }).fail(function (error) {
            console.log(error);
            toastr.error('Houve um problema ao tentar buscar os detalhes do resumo da avaliação.<br>Erro: '.error.statusText, 'Transação não pode ser realizada!');
        });
    });

    $(document).on('click', '#chart-campanha', function (evt) {
        var activePoints = window.myCampanha.getElementsAtEvent(evt);
        var firstPoint = activePoints[0];
        var label = window.myCampanha.data.labels[firstPoint._index];
        var value = window.myCampanha.data.datasets[firstPoint._datasetIndex].data[firstPoint._index];
        var form = $('form[name="form-relatorio"]').serializeObject();
        form.tipo = label;

        $.post('/relacionamento/log/detalhecampanha', {form: form}, function (data) {
            if (data.status) {
                $('#divTableCampanhaExpand').removeClass('hidden');
                $('#divTableCampanhaExpand').html('').html(data.html);
            } else {
                swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema ao obter o detalhe do relatório!", type: "error"});

                $.each(data.mensagem, function ($key, $message) {
                    toastr.error($message, 'Transação não pode ser realizada!');
                });
            }
        }).fail(function (error) {
            alert('Error: ' + error.statusText + '\\n' + label + ': ' + value);
        });
    });

    $(document).on('click', '.btn-expandir-campanhas-all', function () {
        var form = $('form[name="form-relatorio"]').serializeObject();

        $.post('/relacionamento/log/detalhecampanha', {form: form}, function (data) {
            if (data.status) {
                $('#divTableCampanhaExpand').removeClass('hidden');
                $('#divTableCampanhaExpand').html('').html(data.html);
            } else {
                swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema ao obter o detalhe do relatório!", type: "error"});

                $.each(data.mensagem, function ($key, $message) {
                    toastr.error($message, 'Transação não pode ser realizada!');
                });
            }
        }).fail(function (error) {
            alert('Error: ' + error.statusText + '\\n' + label + ': ' + value);
        });
    });

    $(document).on('click', '#chart-canal', function (evt) {
        var activePoints = window.myCanal.getElementsAtEvent(evt);
        var firstPoint = activePoints[0];
        var label = window.myCanal.data.labels[firstPoint._index];
        var value = window.myCanal.data.datasets[firstPoint._datasetIndex].data[firstPoint._index];
        var formSerialize = $('form[name="form-relatorio"]').serializeObject();
        var form = {};

        $.each(formSerialize, function (key, item) {
            if (key.indexOf('[]') != -1) {
                var keyForm = key.replace('[]', '');

                if (!_.isArray(item)) {
                    form[keyForm] = [];
                    form[keyForm].push(item);
                    return true;
                }

                form[keyForm] = item;
            }

            form[key] = item;
        });

        form.tipo = label;

        $.post('/relatorios/contato/detalhescanais', {form: form}, function (data) {
            if (data.status) {
                $('#divTableContato').removeClass('hidden');
                $('#divTableContato').html('').html(data.html);
            } else {
                swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema ao obter o detalhe do relatório!", type: "error"});

                $.each(data.mensagem, function ($key, $message) {
                    toastr.error($message, 'Transação não pode ser realizada!');
                });
            }
        }).fail(function (error) {
            alert('Error: ' + error.statusText + '\\n' + label + ': ' + value);
        });
    });

    $(document).on('click', '.btn-expandir-canais-all', function () {
        var formSerialize = $('form[name="form-relatorio"]').serializeObject();
        var form = {};

        $.each(formSerialize, function (key, item) {
            if (key.indexOf('[]') != -1) {
                var keyForm = key.replace('[]', '');

                if (!_.isArray(item)) {
                    form[keyForm] = [];
                    form[keyForm].push(item);
                    return true;
                }

                form[keyForm] = item;
            }

            form[key] = item;
        });

        $.post('/relatorios/contato/detalhescanais', {form: form}, function (data) {
            if (data.status) {
                $('#divTableContato').removeClass('hidden');
                $('#divTableContato').html('').html(data.html);
            } else {
                swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema ao obter o detalhe do relatório!", type: "error"});

                $.each(data.mensagem, function ($key, $message) {
                    toastr.error($message, 'Transação não pode ser realizada!');
                });
            }
        }).fail(function (error) {
            alert('Error: ' + error.statusText + '\\n' + label + ': ' + value);
        });
    });

    $(document).on('submit', '#formImportarMaterial', function (e) {
        e.preventDefault();
        var $bt = $('.btn-importar');
        $bt.ladda();
        $bt.ladda('start');

        var formData = new FormData(this);
        var $url = $(this).attr('action');
        var $type = $(this).attr('method')

        swal({
                html: true,
                title: "A Importação pode levar vários minutos dependendo do tamanho do arquivo, deseja continuar?",
                text: "A importação de materiais e família dependendo da quantidade de linhas nos arquivos pode levar até 10 minutos para concluir toda a importação, impossibilitando o uso do sistema nesse período!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.ajax({
                        url: $url,
                        type: $type,
                        data: formData,
                        success: function (data) {
                            if (data.status) {
                                swal({
                                    title: "Importação realizada com sucesso!",
                                    text: "A Importação de Materiais e de Grupo Família foi concluída com sucesso!",
                                    type: "success"
                                }, function () {
                                    window.location.reload(true);
                                });
                            } else {
                                swal({
                                    title: "Transação não pode ser realizada!",
                                    text: "Houve um problema na importação dos arquivos!",
                                    type: "error"
                                });

                                $.each(data.mensagem, function ($key, $message) {
                                    toastr.error($message, 'Transação não pode ser realizada!');
                                });

                                console.log(data);
                            }

                            $bt.ladda('stop');
                        },
                        error: function (error) {
                            console.log(error);
                            toastr.error(error.statusText, 'Não foi possível realizar esta transação!');

                            $bt.ladda('stop');
                        },
                        cache: false,
                        contentType: false,
                        processData: false,
                        xhr: function () {  // Custom XMLHttpRequest
                            var myXhr = $.ajaxSettings.xhr();
                            if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                                myXhr.upload.addEventListener('progress', function () {
                                    /!* faz alguma coisa durante o progresso do upload *!/
                                }, false);
                            }
                            return myXhr;
                        }
                    });
                } else {
                    $bt.ladda('stop');

                    swal.close();
                    return false;
                }
            });
    });

    $(document).on('click', '.add-producao', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();

        var $mesAno = $('#tab-3 input[name="mes_ano"]').val();
        var $quantidade = $('#tab-3 input[name="quantidade"]').val();
        var $id = $('input[name="id"]').val();
        var $valid = true;
        if ($mesAno == undefined || $mesAno == '') {
            $valid = false;
            toastr.error("Mês e ano precisa ser preenchido para continuar!");
        }

        if ($quantidade == undefined || $quantidade == '' || $quantidade == '0,00') {
            $valid = false;
            toastr.error("Informe uma quantidade para continuar!");
        }

        if ($valid) {
            $.post('/cadastro/material/producao', {material: $id, mes_ano: $mesAno, quantidade: $quantidade}, function (data) {
                if (data.status) {
                    swal({
                        title: "Transação realizada com sucesso!",
                        text: "Produção adicionada com sucesos!",
                        type: "success"
                    }, function () {
                        $('.table-producao').html('').html(data.html);
                        $('#tab-5 input[name="mes_ano"]').val('');
                        $('#tab-5 input[name="quantidade"]').val('');
                    });
                } else {
                    swal({
                        title: "Transação não pode ser realizada!",
                        text: "Houve um problema ao adicionar uma produção!",
                        type: "error"
                    });

                    $.each(data.mensagem, function ($key, $message) {
                        toastr.error($message, 'Transação não pode ser realizada!');
                    });
                }
            }).fail(function (error) {
                console.log(error);
                swal.close();
                toastr.error('Ocorreu uma falha ao tentar adicionar a produção!');
            });
        }
    });

    $(document).on('click', '.btn-graficos-distribuidor', function () {
        if ($('#divBanner').hasClass('hidden')) {
            $('#divGraficos').fadeOut('slow');
            $('#divBanner').fadeIn('slow', 'linear', function () {
                $('#divBanner').removeClass('hidden');
                $('#divGraficos').addClass('hidden');
            });
            $(this).find('span').text('Gráficos');
            return false;
        }

        if ($('#divGraficos').hasClass('hidden')) {
            $('#divBanner').fadeOut('slow');
            $('#divGraficos').fadeIn('slow', 'linear', function () {
                $('#divGraficos').removeClass('hidden');
                $('#divBanner').addClass('hidden');
            });
            $(this).find('span').text('Voltar');
            return false;
        }
    });

    $(document).on('click', '.menu-categoria', function () {
        var $categoria = $(this).attr('id-categoria');
        $('#frmPesquisaDocumentos input[name="categoria"]').val($categoria);

        $('#frmPesquisaDocumentos').submit();
    });

    $(document).on('click', '.btn-add-mix', function () {
        if (($('select[name="linha_mix"]').val() == null || $('select[name="linha_mix"]').val() == '') && ($('select[name="modelo_mix"]').val() == null || $('select[name="modelo_mix"]').val() == '')) {
            toastr.error('Informe uma linha ou modelo para incluir!', 'Transação não realizada!');
            return false;
        }

        var $mix = JSON.parse($('input[name="mix"]').val());
        var $linha = $('select[name="linha_mix"] option:selected').val();
        var $linhaText = $('select[name="linha_mix"] option:selected').text();
        var $modelo = $('select[name="modelo_mix"] option:selected').val();
        var $modeloText = $('select[name="modelo_mix"] option:selected').text();
        $mix.push({
            linha: (_.isEmpty($linha) ? null : $linha),
            linha_descricao: (_.isEmpty($linha) ? null : $linhaText),
            modelo: (_.isEmpty($modelo) ? null : $modelo),
            modelo_descricao: (_.isEmpty($modelo) ? null : $modeloText)
        });

        $('input[name="mix"]').val(JSON.stringify($mix));

        $html = '';
        $.each($mix, function (key, item) {
            $html += '<tr>' +
                '   <td>' + (_.isNull(item.linha) ? item.modelo : item.linha) + '</td>' +
                '   <td>' + (_.isNull(item.linha_descricao) ? item.modelo_descricao : item.linha_descricao) + '</td>' +
                '   <td><a class="btn-excluir-mix pull-right m-t-xxs" id="' + (item.id != undefined ? item.id : 0) + '" objeto=\'' + JSON.stringify(item) + '\'><i class="fa fa-trash fa-2x"></i></a></td>' +
                '</tr>';
        });

        $('#tBodyMix').html('').html($html);
        $('select[name="modelo_mix"]').val(null).trigger('change');
        $('select[name="linha_mix"]').val(null).trigger('change');
        $('input[name="obrigatorio_modelo"]').prop('checked', false);
    });

    $(document).on('shown.bs.modal', '#modalMixProdutos', function () {
        $('select[name="linha_mix"]').select2({
            'dropdownParent': $('.form-mix-linha')
        });

        $('select[name="modelo_mix"]').select2({
            'dropdownParent': $('.form-mix-modelo')
        });
    });

    $(document).on('click', '.btn-excluir-mix', function () {
        var $id = $(this).attr('id');
        var $objeto = ($(this).attr('objeto') !== undefined ? JSON.parse($(this).attr('objeto')) : []);
        var $list = ($('input[name="mix"]').val() !== undefined ? JSON.parse($('input[name="mix"]').val()) : []);

        swal({
                html: true,
                title: "Deseja continuar mesmo assim?",
                text: "O Mix inteiro será removido permanentemente!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    if ($id != 0) {
                        $.get('/bonus/regra/excluirmix/' + $id, function (data) {
                            if (data.status) {
                                swal({
                                    title: "Transação realizada com sucesso!",
                                    text: "O mix foi removido com sucesso!",
                                    type: "success"
                                }, function () {
                                    window.location.reload(true);
                                });
                            } else {
                                swal({
                                    title: "Transação não pode ser realizada!",
                                    text: "Houve um problema ao tentar remover o mix!",
                                    type: "error"
                                });

                                $.each(data.mensagem, function ($key, $message) {
                                    toastr.error($message, 'Transação não pode ser realizada!');
                                });
                            }
                        }).fail(function (error) {
                            console.log(error);
                            swal.close();
                            toastr.error("Ocorreu uma falha tentar remover o mix!", "Transação não pode ser realizada!");
                        });
                    } else {
                        $.each($list, function ($key, $item) {
                            if (_.isEqual($objeto, $item)) {
                                $list.splice($key, 1);
                                $('input[name="mix"]').val(JSON.stringify($list));

                                var $html = '';
                                $.each($list, function (key, item) {
                                    $html += '<tr>' +
                                        '   <td>' + (_.isNull(item.linha) ? item.modelo : item.linha) + '</td>' +
                                        '   <td>' + (_.isNull(item.linha_descricao) ? item.modelo_descricao : item.linha_descricao) + '</td>' +
                                        '   <td><a class="btn-excluir-mix pull-right m-t-xxs" id="' + (item.id != undefined ? item.id : 0) + '" objeto=\'' + JSON.stringify(item) + '\'><i class="fa fa-trash fa-2x"></i></a></td>' +
                                        '</tr>';
                                });

                                $('#tBodyMix').html('').html($html);

                                setTimeout(function () {
                                    swal({
                                        title: "Transaçao realizada com sucesso!",
                                        text: "O item do mix foi excluído com sucesso!",
                                        type: "success"
                                    });

                                    return false;
                                }, 2000);
                            }
                        });
                    }
                }
            }
        );
    });

    $(document).on('click', '.btn-add-mix-item', function () {
        var $list = JSON.parse($(this).attr('mix'));
        $('#modalMixProdutos input[name="titulo"]').val($(this).attr('titulo'));
        $('#modalMixProdutos input[name="mix"]').val($(this).attr('mix'));

        $html = '';
        $.each($list, function (key, item) {
            $html += '<tr>' +
                '   <td>' + (_.isNull(item.linha) ? item.modelo : item.linha) + '</td>' +
                '   <td>' + (_.isNull(item.linha_descricao) ? item.modelo_descricao : item.linha_descricao) + '</td>' +
                '   <td><a class="btn-excluir-mix pull-right m-t-xxs" id="' + (item.id != undefined ? item.id : 0) + '" objeto=\'' + JSON.stringify(item) + '\'><i class="fa fa-trash fa-2x"></i></a></td>' +
                '</tr>';
        });

        $('#tBodyMix').html('').html($html);

        $('#modalMixProdutos').modal('show');
    });

    $(document).on('click', '.btn-excluir-item-mix', function () {
        var $id = $(this).attr('id');

        swal({
                html: true,
                title: "Deseja continuar mesmo assim?",
                text: "O item do mix será removido permanentemente!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.get('/bonus/regra/excluiritemmix/' + $id, function (data) {
                        if (data.status) {
                            swal({
                                title: "Transação realizada com sucesso!",
                                text: "O item do mix foi removido com sucesso!",
                                type: "success"
                            }, function () {
                                window.location.reload(true);
                            });
                        } else {
                            swal({
                                title: "Transação não pode ser realizada!",
                                text: "Houve um problema ao tentar remover o mix!",
                                type: "error"
                            });

                            $.each(data.mensagem, function ($key, $message) {
                                toastr.error($message, 'Transação não pode ser realizada!');
                            });
                        }
                    }).fail(function (error) {
                        console.log(error);
                        swal.close();
                        toastr.error("Ocorreu uma falha tentar remover o item do mix!", "Transação não pode ser realizada!");
                    });
                }
            }
        );
    });

    $(document).on('change', 'select[name="linha_mix"]', function () {
        var $value = $(this).val();

        if (_.isEmpty($value)) {
            $('.panel-mix-modelo').removeClass('disabled');
        } else {
            $('.panel-mix-modelo').addClass('disabled');
        }
    });

    $(document).on('change', 'select[name="modelo_mix"]', function () {
        var $value = $(this).val();

        if (_.isEmpty($value)) {
            $('.panel-mix-linha').removeClass('disabled');
        } else {
            $('.panel-mix-linha').addClass('disabled');
        }
    });

    $(document).on('change', 'select[name="linha_item"]', function () {
        var $value = $(this).val();

        if (_.isEmpty($value)) {
            $('.panel-item-modelo').removeClass('disabled');
        } else {
            $('.panel-item-modelo').addClass('disabled');
        }
    });

    $(document).on('change', 'select[name="modelo_item"]', function () {
        var $value = $(this).val();

        if (_.isEmpty($value)) {
            $('.panel-item-linha').removeClass('disabled');
        } else {
            $('.panel-item-linha').addClass('disabled');
        }
    });

    $(document).on('click', '.anexo-comprovacao-solicitacao', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $type = $(this).attr('type');
        var $id = $(this).attr('data-id');

        switch ($type) {
            case 'distribuidor':
                $('input[name="solicitacao"]').val($id);
                $('#modalComprovacao').modal('show');
                break;
            case 'visualiza':
                $.get('/bonus/solicitacao/comprovantes/' + $id, function (data) {
                    if (!(data instanceof Object)) {
                        toastr.error('Houve um problema ao receber os dados da solicitação!', 'Transação não pode ser realizada!');
                        console.log(data);

                        return false;
                    }

                    if (!data.status) {
                        $.each(data.mensagem, function (key, item) {
                            toastr.error(item, 'Transação não pode ser realizada!');
                        });

                        return false;
                    }

                    $('.btn-enviar-comprovante').addClass('hidden');
                    $('.form-group-anexo').html('');
                    $('.form-group-visualiza').html(data.html);
                    $('#modalComprovacao').modal('show');
                }).fail(function (error) {
                    toastr.error('Houve um problema ao buscar os dados da solicitação!', 'Transação não pode ser realizada!');
                    console.log(error);
                });
                break;
        }
    });

    $(document).on('submit', '#form-comprovacao', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $bt = $('.btn-enviar-comprovante');

        $bt.ladda();
        $bt.ladda('start');

        var formData = new FormData(this);
        var $url = $(this).attr('action');

        $.ajax({
            url: $url,
            type: 'POST',
            data: formData,
            success: function (data) {
                if (!(data instanceof Object)) {
                    toastr.error('Houve um problema ao receber os dados da solicitação!', 'Transação não pode ser realizada!');
                    console.log(data);

                    return false;
                }

                if (!data.status) {
                    var $text = "";
                    $.each(data.mensagem, function ($key, $message) {
                        $text += $message + "<br>";
                    });

                    swal({html: true, title: "Transaçao não pode ser realizada!", text: ("Houve um problema ao tentar salvar as comprovações!<br>" + $text), type: "error"});

                    $bt.ladda('stop');
                    return false;
                }

                swal({
                    html: true,
                    title: "Transaçao realizada com sucesso!",
                    text: "Comprovações enviadas com sucesso!",
                    type: "success"
                }, function () {
                    window.location.reload();
                });
            },
            error: function (error) {
                console.log(error);
                $bt.ladda('stop');
                toastr.error('Ocorreu uma falha ao tentar finalizar a Ordem de Serviço!');
            },
            cache: false,
            contentType: false,
            processData: false,
            xhr: function () {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                    myXhr.upload.addEventListener('progress', function () {
                        /!* faz alguma coisa durante o progresso do upload *!/
                    }, false);
                }
                return myXhr;
            }
        });
    });

    $(document).on('click', '.btn-aprovacao-bonus', function (e) {
        var $id = $(this).attr('data-id');
        $('#modalSituacao input[name="id"]').val($id);

        $('#modalSituacao').modal('show');
    });

    $(document).on('change', '#formSolicitacaoBonus select[name="tipo_solicitacao"]', function (e) {
        var $value = $(this).val();
        var $selectTipo = $('#formSolicitacaoBonus select[name="tipo"]');
        switch ($value) {
            case '1':
                var $options = '<option value=""></option>' +
                    '<option value="Fachada Externa">Fachada Externa</option>' +
                    '<option value="Show Room / Painel Interno">Show Room / Painel Interno</option>' +
                    '<option value="Adesivação de Veiculo">Adesivação de Veiculo</option>' +
                    '<option value="Uniforme">Uniforme</option>';
                $selectTipo.html('').html($options);

                $('.publico-alvo').removeClass('hidden');
                $('select[name="publico_alvo"]').html('').html('<option value=""></option><option value="Distribuidora">Distribuidora</option><option value="Revenda">Revenda</option>');
                $('.medidas-local').removeClass('hidden');
                $('.observacao').removeClass('hidden');

                $('.inicio-acao').addClass('hidden');
                $('.fim-acao').addClass('hidden');
                $('.expectativa').addClass('hidden');
                $('.quantidade').addClass('hidden');
                $('input[name="valor_acao"]').prop('required', true);
                break;
            case '2':
                var $options = '<option value=""></option>' +
                    '<option value="Brinde - Camiseta">Brinde - Camiseta</option>' +
                    '<option value="Brinde - Caneta Fenda">Brinde - Caneta Fenda</option>' +
                    '<option value="Catálogo">Catálogo</option>' +
                    '<option value="Banner">Banner</option>' +
                    '<option value="Folder / Flyer">Folder / Flyer</option>';
                $selectTipo.html('').html($options);

                $('.publico-alvo').removeClass('hidden');
                $('select[name="publico_alvo"]').html('').html('<option value=""></option><option value="Distribuidora">Distribuidora</option><option value="Revenda">Revenda</option>');
                $('.quantidade').removeClass('hidden');
                $('.observacao').removeClass('hidden');
                $('.medidas-local').addClass('hidden');
                $('.inicio-acao').addClass('hidden');
                $('.fim-acao').addClass('hidden');
                $('.expectativa').addClass('hidden');
                $('input[name="valor_acao"]').prop('required', false);
                break;
            case '3':
                var $options = '<option value=""></option>' +
                    '<option value="Campanha de Sell-Out">Campanha de Sell-Out</option>' +
                    '<option value="Produção de Brindes">Produção de Brindes</option>' +
                    '<option value="Treinamento na Fábrica">Treinamento na Fábrica</option>' +
                    '<option value="Feira/Evento Externo">Feira/Evento Externo</option>' +
                    '<option value="Publicidade/Outdoor/Mídias Digitais/Patrocínios">Publicidade/Outdoor/Mídias Digitais/Patrocínios</option>' +
                    '<option value="Brindes Nice">Brindes Nice</option>' +
                    '<option value="Material de Merchandising Nice">Material de Merchandising Nice</option>';
                $selectTipo.html('').html($options);

                $('.publico-alvo').removeClass('hidden');
                $('select[name="publico_alvo"]').html('').html('<option value=""></option><option value="Vendedores da Distribuidora">Vendedores da Distribuidora</option><option value="Revendas">Revendas</option><option value="Integradores">Integradores</option><option value="Consumidor Final">Consumidor Final</option>');
                $('.quantidade').removeClass('hidden');
                $('.inicio-acao').removeClass('hidden');
                $('.fim-acao').removeClass('hidden');
                $('.expectativa').removeClass('hidden');
                $('.observacao').removeClass('hidden');
                $('.quantidade').addClass('hidden');
                $('.medidas-local').addClass('hidden');
                $('input[name="valor_acao"]').prop('required', true);
                break;
        }
    });

    $(document).on('change', '#form-avaliacao-regra select[name="regra"]', function () {
        var $param = $(this).val().split('|');
        var $apuracao = $param[1];
        $('#form-avaliacao-regra #inicio').val('');
        $('#form-avaliacao-regra #fim').val('');

        loadDatePickerRegra($apuracao);
    });

    $(document).on('shown.bs.modal', '#inclusaoDeEmpresa', function () {
        var $configMix = {
            attrElement: 'name',
            nameElement: 'grupo_empresa',
            elementDropDownParent: $('.form-group-empresa'),
            url: "/cadastro/empresa/empresaautocomplete"
        }
        configureSelect2WithAutocomplete($configMix, false);
    });


    $(document).on('click', '.btn-pedido-visualiza-documentos', function (e) {

        e.preventDefault();
        var $id = $(this).attr('data-id');
        var $origem = $(this).attr('data-origem');
        $('.lista-faturas').html('');
        $('.splash').css('display', 'block');
        $('#visualizaNotas .lista-faturas-boletos').html('');
        $('#visualizaNotas .div-faturas-boletos').addClass('hidden');

        $.get('/distribuidor/pedido/impostos/' + $id +'/pedido/' + $origem, function (data) {
            if (data.status) {
                $('#visualizaNotas').modal('show');
                $('#visualizaNotas').on('shown.bs.modal', function () {
                    $('#visualizaNotas .lista-faturas').html(data.html);

                    if (data.htmlDevolucao !== '') {
                        $('#visualizaNotas .rowDevolucoes').removeClass('hidden');
                        $('#visualizaNotas .lista-devolucoes').html('');
                        $('#visualizaNotas .lista-devolucoes').html(data.htmlDevolucao);
                    }
                });
                $('.splash').css('display', 'none');
            } else {
                $('.splash').css('display', 'none');
                $.each(data['mensagem'], function (key, item) {
                    toastr.error(item, 'Transação não pode ser realizada!');
                });
            }
        }).fail(function (error) {
            $('.splash').css('display', 'none');
            toastr.error(error.statusText, 'Transação não pode ser realizada!');
        });
    });

    $(document).on('click', '.span-impostos', function (e) {
        e.preventDefault();
        var $id = $(this).attr('data-id');
        var $origem = $(this).attr('data-origem');
        var $url = ('/distribuidor/pedido/impostos/' + $id + '/item/' + $origem);
        $('.lista-faturas').html('');
        $('.splash').css('display', 'block');
        $('#detalhamentoImpostos .lista-faturas-boletos').html('');
        $('#detalhamentoImpostos .div-faturas-boletos').addClass('hidden');

        $.get($url, function (data) {
            if (data.status) {
                $('#detalhamentoImpostos').modal('show');
                $('#detalhamentoImpostos').on('shown.bs.modal', function () {
                    $('#detalhamentoImpostos #materialNome').html('').html(data.material);
                    $('#detalhamentoImpostos .detalhamento_quantidade_pedida').html('').html(data.quantidade_pedida);
                    $('#detalhamentoImpostos .detalhamento_data_criacao').html('').html(data.data_criacao);
                    $('.progress-detalhamento').css('width', data.progresso + '%');
                    $('.lista-faturas').html(data.html);

                    $('#detalhamentoImpostos .lista-devolucoes').html('');
                    $('#detalhamentoImpostos .rowDevolucoes').addClass('hidden');
                    if (data.htmlDevolucao !== '') {
                        $('#detalhamentoImpostos .rowDevolucoes').removeClass('hidden');
                        $('#detalhamentoImpostos .lista-devolucoes').html(data.htmlDevolucao);
                    }
                });
                $('.splash').css('display', 'none');
            } else {
                $('.splash').css('display', 'none');
                $.each(data['mensagem'], function (key, item) {
                    toastr.error(item, 'Transação não pode ser realizada!');
                });
            }
        }).fail(function (error) {
            $('.splash').css('display', 'none');
            toastr.error(error.statusText, 'Transação não pode ser realizada!');
        });
    });

    $(document).on('click', '.btn-recalcular', function (e) {
        e.preventDefault();
        var $id = $(this).attr('data-id');
        var $pedidoProgramado = $('input[name="pedido_programado"]:checked').val();

        $('.splash').css('display', 'block');

        $.get('/distribuidor/pedido/checkcampanha/' + $id, function (data) {

            if (data.status) {
                swal({
                        html: true,
                        title: "Deseja incluir a(s) campanha(s) no pedido antes de recalcular?",
                        text: ("<b>Campanhas:<br>" + data.campanhas + "</b>"),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Sim, desejo!",
                        cancelButtonText: "Não, cancele!",
                        closeOnConfirm: false,
                        closeOnCancel: true,
                        showLoaderOnConfirm: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            recalcularPedido($id, 1, $pedidoProgramado);
                        } else {
                            recalcularPedido($id, 0, $pedidoProgramado);
                        }
                    }
                );
            } else {
                var form = $('#formPedido');
                $.ajax({
                    type: "POST",
                    url: form.attr('action') + '/null/ok',
                    data: form.serialize(),
                    success: function (response) {

                        recalcularPedido($id, 0, $pedidoProgramado);
                        // if (response.status) {
                        //     recalcularPedido($id, 0);
                        // } else {
                        //
                        //     //toastr.error(error.statusText, response.mensagem);
                        // }
                    }
                });

                //recalcularPedido($id, 0);
            }
        }).fail(function (error) {
            $('.splash').css('display', 'none');
            console.log(error);
            toastr.error(error.statusText, 'Transação não pode ser realizada!');
        });
    });

    $(document).on('click', '.btn-transmitir-pedido', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $pedidoProgramado = $('input[name="pedido_programado"]:checked').val();
        var $flagPedidoProgramado = false;

        if ($pedidoProgramado !== undefined && $pedidoProgramado !== '') {
            var $explodeRemessa = $('input[name="data_remessa"]').val().split('/');
            var $dateCreate = new Date();
            var $dateRemessa = new Date(($explodeRemessa[2] + '-' + $explodeRemessa[1] + '-' + $explodeRemessa[0]));
            var $diffTime = Math.abs($dateRemessa.getTime() - $dateCreate.getTime());
            var $diffDays = Math.ceil($diffTime / (1000 * 60 * 60 * 24));

            $.ajax({
                type: 'GET', url: '/pedido/configuracao/getparametros/PEDIDO_PROGRAMADO',
                success: function (config) {
                    if (config.status) {
                        if ($diffDays < parseInt(config.params)) {
                            swal({
                                html: true,
                                title: "Pedido Programado",
                                text: "Pedido programado é necessário alterar a <b>Data da Remessa</b> para mais de " + config.params + " dias contando a partir de hoje!",
                                type: "error"
                            });

                            $flagPedidoProgramado = true;
                            return false;
                        }
                    } else {
                        $.each(data.mensagem, function (key, item) {
                            toastr.warning(item, 'Alerta!');
                        });
                    }
                },
                error: function (error) {
                    toastr.error('Falha ao verificar a data de remessa!', 'Transação não pode ser realizada!');
                    console.log(error);
                },
                async: false
            });
        }

        if ($flagPedidoProgramado) {
            return true;
        }

        var $pedidoRecalculado = (window.sessionStorage.getItem('pedido_recalculado') != null ? JSON.parse(window.sessionStorage.getItem('pedido_recalculado')) : null);
        var $id = $('input[name="id"]').val();
        var $url = $(this).attr('url');

        if ($pedidoRecalculado != null && $pedidoRecalculado.pedido != $id) {
            window.sessionStorage.removeItem('pedido_recalculado');
            $pedidoRecalculado = null;
        }

        if ($pedidoRecalculado == null || !$pedidoRecalculado.calculado) {

            swal({
                    title: "Detectamos alteração no pedido, é necessário recalcular antes de transmitir!",
                    text: "Recomendamos essa ação para atualização de todas as informações do pedido antes de transmitir para faturamento!",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Recalcular",
                    cancelButtonText: "Não, cancele!",
                    closeOnConfirm: false,
                    closeOnCancel: false,
                    showLoaderOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        $.get('/distribuidor/pedido/checkcampanha/' + $id, function (data) {
                            if (data.status) {
                                swal({
                                        html: true,
                                        title: "Antes de transmitir deseja incluir as campanhas no pedido?",
                                        text: ("<b>Campanhas:<br>" + data.campanhas + "</b>"),
                                        type: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Sim, desejo!",
                                        cancelButtonText: "Não, cancele!",
                                        closeOnConfirm: false,
                                        closeOnCancel: true,
                                        showLoaderOnConfirm: true
                                    },
                                    function (isConfirm) {
                                        if (isConfirm) {
                                            recalcularPedido($id, 1, $pedidoProgramado);
                                        } else {
                                            recalcularPedido($id, 0, $pedidoProgramado);
                                        }
                                    }
                                );
                            } else {
                                recalcularPedido($id, 0, $pedidoProgramado);
                            }
                        }).fail(function (error) {
                            swal({
                                type: "error",
                                title: "Ops! Houve um problema ao verificar se o pedido participa de campanhas!",
                                text: "Esse foi o erro encontrado: " + error.statusText
                            });
                        });
                    } else {
                        window.sessionStorage.setItem('pedido_recalculado', JSON.stringify({
                            pedido: $id,
                            calculado: false
                        }));
                        swal({
                            type: "error",
                            title: "Não é possível transmitir o pedido sem recalcular antes!",
                            text: "Para enviar o pedido é necessário clicar em Sim, na janela anterior!"
                        });
                    }
                }
            );
        } else {
            swal({
                    title: "Transmitir o pedido para a fábrica?",
                    text: "Após está ação não será mais possível alterar as quantidades!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Sim, desejo!",
                    cancelButtonText: "Não, cancele!",
                    closeOnConfirm: false,
                    closeOnCancel: true,
                    showLoaderOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {

                        var form = $('#formPedido');
                        $.ajax({
                            type: "POST",
                            url: form.attr('action') + '/null/ok',
                            data: form.serialize(),
                            success: function (response) {
                                $.get($url, function (data) {

                                    if (data.status) {
                                        sendemailpedido($id, true);

                                        swal({
                                            type: "success",
                                            title: "Pedido transmitido com sucesso!",
                                            text: "Pedido foi recebido com sucesso!"
                                        }, function () {
                                            window.location.href = $url.replace('processar', 'editar');
                                        });
                                    } else {

                                        var mm = data.mensagem.join('<br>');
                                        swal({
                                            html: true,
                                            type: "error",
                                            title: "Ops! Houve um problema ao transmitir o pedido!",
                                            text: "Log de erro: <br>" + mm
                                        });
                                    }
                                }).fail(function (error) {
                                    swal({
                                        html: true,
                                        type: "error",
                                        title: "Ops! Houve um problema ao transmitir o pedido!",
                                        text: "Log de erro: <br>" + error.statusText
                                    });
                                });

                            }
                        });
                    }
                }
            );
        }
    });

    $(document).on('click', '.btn-add-transportadora', function (e) {
        e.preventDefault();

        var $bt = $(this);

        $bt.ladda();
        $bt.ladda('start');

        var $form = $('#form-transportadora').serializeObject();
        var $url = $('#form-transportadora').attr('action');

        $.post($url, {post: $form}, function (data) {
            if (data.status) {
                toastr.success(data.mensagem);

                window.location.reload(true);
            } else {
                $.each(data['mensagem'], function (key, item) {
                    toastr.error(item, 'Transação não pode ser realizada!');
                });
            }
        }).fail(function (error) {
            $bt.ladda('stop');
            toastr.error(error.statusText, 'Não foi possível realizar a transação!');
        });
    });

    $(document).on('click', '.btn-pedido-cancelar', function (e) {
        e.preventDefault();

        var $bt = $(this);

        $bt.ladda();
        $bt.ladda('start');
        var $url = $('#form-pedido-cancelar').attr('action');

        $.post($url, $("#form-pedido-cancelar").serialize())
            .done(function (data) {

                if (data.status) {
                    toastr.success(data.mensagem);
                    window.location.href = data.url;
                    setTimeout(function () {
                        window.location.href = data.url;
                    }, 3000);
                } else {
                    $.each(data['mensagem'], function (key, item) {
                        toastr.error(item, 'Transação não pode ser realizada!');
                    });
                }
                $($bt).ladda('stop');
            })
            .fail(function () {
                toastr.error(error.statusText, 'Não foi possível realizar a transação!');
                $($bt).ladda('stop');
            }, "JSON");
    });

    $(document).on('click', '.btn-view-transportadora', function () {
        var $objeto = JSON.parse($(this).attr('data-object'));

        $('#viewTransportadora').modal('show').on('shown.bs.modal', function () {
            $('#form-transportadora input[name="razao_transportadora"]').val($objeto.razao_social);
            $('#form-transportadora input[name="cnpj_transportadora"]').val($objeto.cnpj);
            $('#form-transportadora input[name="email_transportadora"]').val($objeto.email);
            $('#form-transportadora input[name="telefone_transportadora"]').val($objeto.telefone);
            $('#form-transportadora input[name="inscricao_estadual"]').val($objeto.inscricao_estadual);
            $('#form-transportadora input[name="cep"]').val($objeto.cep);
            $('#form-transportadora input[name="logradouro"]').val($objeto.endereco);
            $('#form-transportadora input[name="numero"]').val($objeto.numero);
            $('#form-transportadora input[name="complemento"]').val($objeto.complemento);
            $('#form-transportadora input[name="bairro"]').val($objeto.bairro);
            $('#form-transportadora input[name="cidade"]').val($objeto.cidade);
            $('#form-transportadora select[name="estado"]').val($objeto.estado);
            $('#form-transportadora textarea[name="observacao"]').val($objeto.observacao);
            $('#form-transportadora input[name="transportadora"]').val($objeto.id);
        });
    });

    $(document).on('click', '#btnInserirPedido', function () {
        var $url = $(this).attr('data-url');
        window.location.href = $url;
    });

    $(document).on('submit', '#form-importar-pedido-excel', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $bt = $('.btn-enviar-excel');

        $bt.ladda();
        $bt.ladda('start');

        var formData = new FormData(this);
        var $url = $(this).attr('action');

        $.ajax({
            url: $url,
            type: 'POST',
            data: formData,
            success: function (data) {
                if (data.status) {
                    var $text = "O Pedido foi importado com sucesso!";
                    $.each(data.mensagem, function ($key, $message) {
                        if ($key == 0) {
                            $text = "Porém os itens do pedido foi importado parcialmente!<br>Itens não importados:<br><br>";
                        }

                        $text += ('-' + $message + ((($key + 1) == data.mensagem.length) ? '' : '<br>'));
                    });

                    swal({
                        html: true,
                        title: "Transaçao realizada com sucesso!",
                        text: $text,
                        type: "success"
                    }, function () {
                        window.location.href = data.url;
                    });
                } else {
                    swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema na importação do pedido!", type: "error"});

                    $.each(data.mensagem, function ($key, $message) {
                        toastr.error($message, 'Transação não pode ser realizada!');
                    });
                }

                $bt.ladda('stop');
            },
            error: function (error) {
                console.log(error);
                $bt.ladda('stop');
                toastr.error('Ocorreu uma falha ao tentar finalizar a Ordem de Serviço!');
            },
            cache: false,
            contentType: false,
            processData: false,
            xhr: function () {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                    myXhr.upload.addEventListener('progress', function () {
                        /!* faz alguma coisa durante o progresso do upload *!/
                    }, false);
                }
                return myXhr;
            }
        });
    });

    $(document).on('click', '.btn-remessa-programacao', function () {
        var $id = $('input[name="id"]').val();
        $('input[name="data_remessa"]').prop('readonly', false);

        $.post('/distribuidor/pedido/remessa', {pedido: $id}, function (data) {
            if (data.status) {
                $('#formPedido input[name="data_remessa"]').data("DateTimePicker").destroy();

                $('#formPedido input[name="data_remessa"]').datetimepicker({
                    icons: {
                        time: 'fa fa-clock-o',
                        date: 'fa fa-calendar',
                        up: 'fa fa-chevron-up',
                        down: 'fa fa-chevron-down',
                        previous: 'fa fa-chevron-left',
                        next: 'fa fa-chevron-right',
                        today: 'fa fa-crosshairs',
                        clear: 'fa fa-trash'
                    },
                    locale: 'pt-BR',
                    sideBySide: false,
                    format: 'DD/MM/YYYY',
                    timeZone: 'America/Sao_Paulo',
                    minDate: data.dataRemessaFinal
                });

                $('#formPedido input[name="data_remessa"]').data("DateTimePicker").show();
            }
        }).fail(function (error) {
            toastr.error("Houve um problema ao calcular a data de remessa!<br>Error:" + error.statusText, "Transação não pode ser realizada!");
        });
    });

    $(document).on('blur', '#formPedido input[name="data_remessa"]', function (){
        $('#formPedido').submit();
    });

    $(document).on('submit', '#form-importar-pedido-sap', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $bt = $('.btn-enviar-sap');

        $bt.ladda();
        $bt.ladda('start');

        var formData = new FormData(this);
        var $url = $(this).attr('action');

        $.ajax({
            url: $url,
            type: 'POST',
            data: formData,
            success: function (data) {
                if (data.status) {

                    swal({
                        title: "Transaçao realizada com sucesso!",
                        html: true,
                        text: data.mensagem,
                        type: "success"
                    }, function () {
                        var repost = data.repost;

                        $("[name='data_start']").val(repost.dataInicio);
                        $("[name='data_end']").val(repost.dataFinal);
                        $('#andamento-' + repost.status).val(repost.status);
                        $('#andamento-' + repost.status).prop('checked', true);
                        $('#form-pesquisa').submit();
                    });
                } else {
                    swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema na importação do pedido!", type: "error"});

                    $.each(data.mensagem, function ($key, $message) {
                        toastr.error($message, 'Transação não pode ser realizada!');
                    });
                }

                $bt.ladda('stop');
            },
            error: function (error) {
                console.log(error);
                $bt.ladda('stop');
                toastr.error('Ocorreu uma falha ao tentar finalizar a Ordem de Serviço!');
            },
            cache: false,
            contentType: false,
            processData: false
        });
    });

    $(document).on('click', '.btn-pecas-remessas', function () {
        $('#divEstruturaPecasRemessa').fadeToggle();
        $('#divTablePecas').fadeToggle();

        if ($(this).html().indexOf('fa fa-list-ul') != -1) {
            $(this).html('').html('<i class="fa fa-list-ul"></i><span class="hidden-xs">Estrutura</span>');
        } else {
            var totals = 0;
            var $dataRows = $("#tBodyPecasRemessa tr");

            $dataRows.each(function () {
                $(this).find('.t-quantidade').each(function (i) {
                    totals += parseFloat(($(this).html().replace('.', '').replace(',', '.')));
                });
            });
            $(this).html('').html('<i class="fa fa-list-ul"></i><span class="hidden-xs">' + totals + ' Peças</span>');
        }
    });

    $(document).on('click', '.btn-servicos-remessas', function () {
        $('#divEstruturaServicosRemessa').fadeToggle();
        $('#divTableServicos').fadeToggle();

        if ($(this).html().indexOf('fa fa-cogs') != -1) {
            $(this).html('').html('<i class="fa fa-cogs"></i><span class="hidden-xs">Serviços</span>');
        } else {
            var totals = 0;
            var $dataRows = $("#tBodyPecasRemessa tr");

            $dataRows.each(function () {
                $(this).find('.t-quantidade').each(function (i) {
                    totals += parseFloat(($(this).html().replace('.', '').replace(',', '.')));
                });
            });
            $(this).html('').html('<i class="fa fa-list-ul"></i><span class="hidden-xs">' + totals + ' Peças</span>');
        }
    });

    $(document).on("click", ".showhide", function (evt) {
        evt.preventDefault();
        var hpanel = $(this).closest('div.hpanel');
        var icon = $(this).find('i:first');
        var body = hpanel.find('div.panel-body');
        var footer = hpanel.find('div.panel-footer');
        body.slideToggle(300);
        footer.slideToggle(200);

        // Toggle icon from up to down
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        hpanel.toggleClass('').toggleClass('panel-collapse');
        setTimeout(function () {
            hpanel.resize();
            hpanel.find('[id^=map-]').resize();
        }, 50);
    });

    $(document).on('click', '#btn-pedido-envia-email', function () {
        var id_pedido = $(this).data('id');
        var url = '/distribuidor/pedido/sendemailpedido/' + id_pedido;

        $('.splash').css('display', 'block');
        $.get(url, function (data) {
            if (data['status']) {
                toastr.success('Sucesso', data['message']);
                $('.splash').css('display', 'none');
            } else {
                toastr.error('Falha', data['message']);
                $('.splash').css('display', 'none');
            }
        }, "JSON");
    });

    $(document).on('click', '.btn-aprovar-bonus', function () {
        var $data = $(this).attr('object');
        var $params = $(this).attr('filters');

        $('input[name="bonus"]').val($data);
        $('input[name="params"]').val($params);
        $('input[name="tipo"]').val('A');
        $('#modalAprovarBonus').modal('show').on('shown.bs.modal', function () {
            $('#modalAprovarBonus .modal-title').html('').html('Aprovação do Bônus');
            $('#modalAprovarBonus > .modal-header > .font-bold').html('').html('Tela de aprovação do bônus');
            $('#modalAprovarBonus .control-label').html('').html('Justificativa da Aprovação');
        });
    });

    $(document).on('click', '.btn-reprovar-bonus', function () {
        var $data = $(this).attr('object');
        var $params = $(this).attr('filters');

        $('input[name="bonus"]').val($data);
        $('input[name="params"]').val($params);
        $('input[name="tipo"]').val('R');
        $('#modalAprovarBonus').modal('show').on('shown.bs.modal', function () {
            $('#modalAprovarBonus .modal-title').html('').html('Reprovação do Bônus');
            $('#modalAprovarBonus > .modal-header > .font-bold').html('').html('Tela de reprovação do bônus');
            $('#modalAprovarBonus .control-label').html('').html('Justificativa da Reprova');
        });
    });

    $(document).on('submit', '#form-aprovacao-bonus', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $url = $(this).attr('action');
        var $form = $(this).serializeObject();

        $('.panel-load').addClass('whirl standard');
        $.post($url, {data: $form}, function (data) {
            $('.panel-load').removeClass('whirl standard');

            if (!(data instanceof Object)) {
                toastr.error('Não foi possível gerar o crédito de bônus!', 'Transação não pode ser realizada!');
                return false;
            }

            if (!data.status) {
                $.each(data.mensagem, function (key, item) {
                    toastr.error(item, 'Transação não pode ser realizada!');
                });

                return false;
            }

            window.location.reload();
            toastr.success('Bônus gerado com sucesso!', 'Trasação realizada com sucesso!');
        }).fail(function (error) {
            console.log(error);
            $('.panel-load').removeClass('whirl standard');
            toastr.error('Erro ao tentar gerar o crédito de bônus!', 'Transação não pode ser realizada!');
        });
    });

    $(document).on('click', '.btn-change-categoria', function () {
        var $dados = $(this).attr('object');
        var $params = $(this).attr('filters');

        $('input[name="objeto"]').val($dados);
        $('input[name="params"]').val($params);
        $('#modalCategoria').modal('show');
    });

    $(document).on('click', '.btn-salvar-categoria', function (e) {
        e.preventDefault();
        e.stopPropagation();

        swal({
                title: "Deseja mudar a categoria do grupo de cliente?",
                text: "Essa ação irá alterar a categoria dos clientes que fazem parte desse grupo!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    var $form = $('#form-change-categoria').serializeObject();
                    $.post('/bonus/regra/newcategoria', {dados: $form}, function (data) {
                        if (!(data instanceof Object)) {
                            swal({
                                title: "Transaçao não pode ser realizada!",
                                text: "Houve um problema ao tentar mudar a categoria do grupo de cliente!",
                                type: "error"
                            }, function () {
                                return false;
                            });
                        }

                        if (!data.status) {
                            var $text = '';
                            $.each(data.mensagem, function ($key, $message) {
                                $text += $message + "<br>";
                            });

                            swal({
                                title: "Transaçao não pode ser realizada!",
                                text: "Houve um problema ao tentar mudar a categoria do grupo de cliente!<br><br>" + $text,
                                type: "error"
                            }, function () {
                                return false;
                            });
                        } else {
                            swal({
                                title: "Registro Salvo com Sucesso!",
                                text: "Categoria dos clientes alterada com sucesso!",
                                type: "success"
                            }, function () {
                                window.location.reload();
                            });
                        }
                    }).fail(function (error) {
                        console.log(error);
                        swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema ao alterar a categoria do grupo de cliente!", type: "error"});
                    })
                }
            });
    });

    $(document).on('click', '.btn-tabela-preco', function () {
        $('.splash').css('display', 'block');
        $.get('/distribuidor/pedido/gerarexcel', function (data) {
            if (data.status) {
                $('#items').html(data.items);

                salvarElemento('lista-titulo-menu-gerarxls');
                $('.splash').css('display', 'none');
            }
        }, "JSON");
    });

    $(document).on('touchspin.on.stopupspin touchspin.on.stopdownspin', '.quantidade-spin', function (e) {

        var $inputTipoManutencao = $('input[name="tipo_manutencao"]:checked').val();
        var $inputCobrarPecas = $('input[name="cobrar_pecas"]:checked').val();
        var $inputManutencao = $('input[name="valor_manutencao"]');
        if ($inputManutencao.length && $inputTipoManutencao == 0) {
            var $name = $(this).attr('name').match(/\d+/);
            var $id = $name[0];
            var $qtd = $(this).val();
            var $valorMaterial = $(this).attr('v1');
            var $valorOrcamento = ($inputManutencao.val() == '' ? 0 : parseFloat($inputManutencao.val().replace('.', '').replace(',', '.')));
            var $aValor = JSON.parse($('input[name="objeto_valor"]').val());

            for (var $i = 0; $i < $aValor.length; $i++) {
                if ($id == $aValor[$i].id) {
                    if ($valorOrcamento > 0 && $valorOrcamento >= $valorMaterial) {
                        $valorOrcamento = (parseFloat($valorOrcamento) - (parseFloat($aValor[$i].quantidade) * parseFloat($aValor[$i].valor)));
                    }

                    $aValor.splice($i, 1);
                }
            }
            ;

            if ($valorMaterial != '' && $valorMaterial != 0 && $qtd != '' && $qtd != 0) {
                $valorOrcamento = (parseFloat($valorOrcamento) + (parseFloat($qtd) * parseFloat($valorMaterial)));

                $aValor.push({
                    id: $id,
                    quantidade: $qtd,
                    valor: $valorMaterial,
                    tipo: ($name['input'].indexOf('pecas') != -1 ? 'pecas' : 'servicos')
                });

                if ($inputCobrarPecas == '0' && $name['input'].indexOf('pecas') != -1) {
                    $valorOrcamento = (parseFloat($valorOrcamento) - (parseFloat($qtd) * parseFloat($valorMaterial)));
                }
            }

            $inputManutencao.val(numberToReal($valorOrcamento));
            $('input[name="objeto_valor"]').val(JSON.stringify($aValor));
        }
    });

    $(document).on('change', 'input[name="cobrar_pecas"]', function (e) {
        var $inputManutencao = $('input[name="valor_manutencao"]');
        var $valorOrcamento = ($inputManutencao.val() == '' ? 0 : $inputManutencao.val().replace('.', '').replace(',', '.'));
        var $aValor = JSON.parse($('input[name="objeto_valor"]').val());

        for (var $i = 0; $i < $aValor.length; $i++) {
            if ($aValor[$i].tipo == 'pecas') {
                if (e.currentTarget.value == '1') {
                    $valorOrcamento = (parseFloat($valorOrcamento) + (parseFloat($aValor[$i].quantidade) * parseFloat($aValor[$i].valor)));
                } else {
                    $valorOrcamento = (parseFloat($valorOrcamento) - (parseFloat($aValor[$i].quantidade) * parseFloat($aValor[$i].valor)));
                }
            }
        }

        $inputManutencao.val(numberToReal($valorOrcamento));
        $('input[name="objeto_valor"]').val(JSON.stringify($aValor));
    });

    $(document).on('change', '.btn-selecao-material', function (e) {

        var $action = $('#frmOrdemServico').attr('action');

        if ($action == "/distribuidor/assistencia-reposicao/editar") {
            var validator = $("#frmOrdemServico").validate();
            validator.destroy();

            $('#frmOrdemServico').submit();
        }
    });

    $(document).on('change', '.contato-tipo-forca-anexo', function (e) {
        if (window.location.pathname.indexOf('contato/gerenciador/inserir') == 1 || window.location.pathname.indexOf('contato/gerenciador/editar') == 1) {
            return false;
        }

        var $optgroup = new String($(this.options[this.selectedIndex]).closest('optgroup').prop('label'));
        var $label = new String($(this.options[this.selectedIndex]).text());
        $(this.options[this.selectedIndex]).text($optgroup + '/' + $label);

        $("#mensagem-anexo-tipo").addClass('hidden');
        if ($optgroup == "Problema") {
            $("#mensagem-anexo-tipo").removeClass('hidden');
        }

        switch ($(this).val()) {
            case '5':
            case '4':
            case '15':
            case '16':
                $("#onde_comprou").rules('remove', 'required');
                $("#onde_comprou").removeAttr('required');
                $("#cnpj_comprou").rules('remove', 'required');
                $("#cnpj_comprou").removeAttr('required');
                break;
            default:
                $("#onde_comprou").rules('add', {
                    required: true,
                    messages: {required: "Informe Onde Comprou para o chamado."}
                });
                $("#cnpj_comprou").rules('add', {
                    required: true,
                    messages: {required: "Informe o CNPJ da Onde Comprou para o chamado."}
                });

                $("#onde_comprou").prop('required', true);
                $("#cnpj_comprou").prop('required', true);
                break;
        }
    });

    $(document).on('ifChanged', 'input[name^="separado"]', function (e) {
        var $dados = $(this).val();
        $.post('/ordemservico/gerenciador/separacaopecas', {data: $dados, checked: e.target.checked}, function (data) {
            if (!(data instanceof Object)) {
                toastr.error('Houve algum problema ao tentar separar a peça!', 'Não foi possível realizar a transação!');
                return false;
            }

            if (!data.status) {
                $.each(data.messages, function ($key, $valor) {
                    toastr.warning($valor, 'ATENÇÃO!');
                });
            }
        }).fail(function (error) {
            toastr.error('Não foi possível marcar a peça como separada!', 'Não foi possível realizar a transação!');

            console.log(error);
            $(this).iCheck('uncheck');
            $(this).iCheck('update');
        });
    });

    $(document).on('click', '.getListaSeparacao', function () {
        $('.splash').css('display', 'block');
        var $url = $(this).attr('data-url');

        $('.mostra-lista-de-peca-separacao').attr('src', $url).attr('onload', '$(".splash").css("display", "none");');
    });

    $(document).on('click', '.btn-adicionar-expansao', function () {
        var $data = JSON.parse($('input[name="expansao"]').val());
        var $organizacao = $('select[name="organizacao_venda"]');
        var $setorAtividade = $('select[name="setor_atividade"]');
        var $html = '';

        $data.push({
            'descricao_organizacao': $('select[name="organizacao_venda"] option:selected').text(),
            'organizacao_venda': $organizacao.val(),
            'descricao_setor': $('select[name="setor_atividade"] option:selected').text(),
            'setor_atividade': $setorAtividade.val()
        });

        $.each($data, function (key, item) {
            $html += "<tr>";
            $html += "<td>" + item.descricao_organizacao + "</td>";
            $html += "<td>" + item.descricao_setor + "</td>";
            $html += "<td class='text-right'><button type='button' class='btn btn-primary btn-excluir-expansao-documento' organizacao='" + item.organizacao_venda + "' setor='" + item.setor_atividade + "'><i class='fa fa-trash'></i></button></td>";
            $html += "</tr>";
        });

        $organizacao.val('');
        $setorAtividade.val('');

        $('#tBodyExpasaoDocumento').html('').html($html);
        $('input[name="expansao"]').val(JSON.stringify($data));

        toastr.success('Dados adicionado ao documento com sucesso!', 'Resgistro salvo com sucesso!');
    });

    $(document).on('click', '.btn-excluir-expansao-documento', function () {
        var $data = JSON.parse($('input[name="expansao"]').val());
        var $organizacao = $(this).attr('organizacao');
        var $setor = $(this).attr('setor');
        var $html = '';

        for (var $i = 0; $data.length >= $i; $i++) {
            if ($organizacao == $data[$i].organizacao_venda && $setor == $data[$i].setor_atividade) {
                $data.splice($i, 1);
            }
        }

        if ($data.length > 0) {
            $.each($data, function (key, item) {
                $html += "<tr>";
                $html += "<td>" + item.descricao_organizacao + "</td>";
                $html += "<td>" + item.descricao_setor + "</td>";
                $html += "<td class='text-right'><button type='button' class='btn btn-primary btn-excluir-expansao-documento' organizacao='" + item.organizacao_venda + "' setor='" + item.setor_atividade + "'><i class='fa fa-trash'></i></button></td>";
                $html += "</tr>";
            });
        } else {
            $html += "<tr>";
            $html += "<td colspan='10' class='m-l text-center'>";
            $html += "<h4 class='p-xl'>Nenhum registro encontrado!</h4>";
            $html += "</td>";
            $html += "</tr>";
        }

        $('#tBodyExpasaoDocumento').html('').html($html);

        $('input[name="expansao"]').val(JSON.stringify($data));
        toastr.success('Item removido com sucesso!', 'Remoção realizada com sucesso!');
    });

    $(document).on('submit', '#form-lock', function ($e) {
        $e.preventDefault();
        var $bt = '.btn-lock';
        var $form = $(this);
        $($bt).ladda();
        $($bt).ladda('start');

        $.ajax({type: $form.attr('method'), url: $form.attr('action'), data: $form.serialize(), datatype: 'json'})
            .done(function (data) {
                if (data['status']) {

                    $('.lock').css('display', 'none');
                } else {
                    toastr.info(data['message']);
                }
            })
            .complete(function () {
                $($bt).ladda('stop');
            });
    });

    $(document).on('click', '.btn-lock-header', function () {
        $('.lock').css('display', 'block');
        $.get("/acesso/locksignout", function (data) {
        });
    });

    $(document).on('click', ".btn-excluir-imagem-modelo", function ($e) {
        $e.preventDefault();
        var $bt = $(this),
            $id = $(this).attr('itemid');

        $($bt).ladda();
        $($bt).ladda('start');

        if (confirm("Deseja realmente excluir?") === false) {
            return false;
        } else {
            $.get({url: '/cadastro/modelo/excluirimagem/' + $id, datatype: 'json'})
                .done(function (data) {
                    if (data['status']) {
                        toastr.success(data['message']);
                        $('#linha-' + $id).remove();
                    } else {
                        toastr.error(data['message']);
                    }
                })
                .complete(function () {
                    $($bt).ladda('stop');
                });
        }
    });

    $(document).on('change', '.linha-itens', function () {
        var $text = $('.linha-itens option:selected').text();
        $('input[name="linha_descricao"]').val($text);
    });

    $(document).on('change', '.modelo-itens', function () {
        var $text = $('.modelo-itens option:selected').text();
        $('input[name="modelo_descricao"]').val($text);
    });

    $(document).on('click', '.btn-grupo-empresarial', function (e) {
        var $cliente = $(this).attr('data-id');
        var $grupo = $(this).attr('data-grupo');

        $('#modalGrupoEmpresarial').modal('show').on('shown.bs.modal', function () {
            $('input[name="cliente"]').val($cliente);

            $("select[name='grupo_empresarial'] option").each(function () {
                if ($(this).val() == $grupo) {
                    $(this).prop('selected', true);
                }
            });
        });
    });

    $(document).on('dp.change', '.data-inicio-limite', function () {
        if ($(this).val() == '') {
            return false;
        }

        var $splitDateInicio = $(this).val().split('/');
        var $daysAdd = daysInMonth($splitDateInicio[1], $splitDateInicio[2]);
        var $dataInicioText = $splitDateInicio[1] + '-' + $splitDateInicio[0] + '-' + $splitDateInicio[2];
        var $date = new Date($dataInicioText);
        var $dataFinal = '';
        $date.setDate($date.getDate() + ($daysAdd - 1));

        $dataFinal = ((($date.getMonth() + 1) < 10) ? ('0' + ($date.getMonth() + 1)) : ($date.getMonth() + 1)) + '-' + ((($date.getDate() + 1) < 10) ? ('0' + $date.getDate()) : $date.getDate()) + '-' + ($date.getFullYear());

        $('.data-final-limite').data("DateTimePicker").destroy();

        $('.data-final-limite').datetimepicker({
            icons: {
                time: 'fa fa-clock-o',
                date: 'fa fa-calendar',
                up: 'fa fa-chevron-up',
                down: 'fa fa-chevron-down',
                previous: 'fa fa-chevron-left',
                next: 'fa fa-chevron-right',
                today: 'fa fa-crosshairs',
                clear: 'fa fa-trash'
            },
            locale: 'pt-BR',
            sideBySide: false,
            format: 'DD/MM/YYYY',
            timeZone: 'America/Sao_Paulo',
            minDate: $dataInicioText,
            maxDate: $dataFinal
        });
    });

    $(document).on('dp.change', '.data-final-limite', function () {
        if ($('.data-inicio-limite').val() == '') {
            return false;
        }

        var $splitDateInicio = $('.data-inicio-limite').val().split('/');
        var $splitDateFinal = $('.data-final-limite').val().split('/');
        var $daysAdd = daysInMonth($splitDateInicio[1], $splitDateInicio[2]);
        var $dataInicioText = $splitDateInicio[1] + '-' + $splitDateInicio[0] + '-' + $splitDateInicio[2];
        var $dataFinalText = $splitDateFinal[1] + '-' + $splitDateFinal[0] + '-' + $splitDateFinal[2];
        var $date = new Date($dataInicioText);
        var $dataFinal = '';
        $date.setDate($date.getDate() + ($daysAdd - 1));

        var $dataFinalNewText = ((($date.getDate() + 1) < 10) ? ('0' + $date.getDate()) : $date.getDate()) + '/' + ((($date.getMonth() + 1) < 10) ? ('0' + ($date.getMonth() + 1)) : ($date.getMonth() + 1)) + '/' + ($date.getFullYear());
        if ((new Date($dataFinalText)).getTime() <= $date.getTime()) {
            return false;
        }

        if ((new Date($dataFinalText)).getTime() > $date.getTime()) {
            toastr.error("A data fim não pode ser maior que " + $dataFinalNewText + ", caso queria mudar a data fim altere a data de inicio!");
            $('.data-final-limite').val($dataFinalNewText);

            return false;
        }
    });

    $(document).on('shown.bs.modal', '#modalPesquisaContato, #modalPesquisa', function () {
        var $configConsumidor = {
            attrElement: 'name',
            nameElement: 'consumidor',
            elementDropDownParent: $('.dropdown-reclamante'),
            url: "/cadastro/consumidor/consumidorautocomplete"
        };

        configureSelect2WithAutocomplete($configConsumidor, false);

        var $configMaterial = {
            attrElement: 'name',
            nameElement: 'material',
            elementDropDownParent: $('.dropdown-material'),
            url: "/cadastro/material/materialautocomplete"
        };

        configureSelect2WithAutocomplete($configMaterial, false);

        var $configCliente = {
            attrElement: 'name',
            nameElement: 'cliente',
            elementDropDownParent: $('.dropdown-cliente'),
            url: "/cadastro/cliente/clienteautocomplete"
        };

        configureSelect2WithAutocomplete($configCliente, false);

        $('select[name="segmento"]').select2({lang: 'pt-BR', width: '100%', dropdownParent: $('.dropdown-segmento')});
    });

    $(document).on('click', '.btn-time-line-acesso', function () {
        var $url = $(this).attr('url'),
            $date = $(this).attr('date');
        $('.panel-load').addClass('whirl standard');
        if ($date != undefined) {
            $url += ('/' + b64EncodeUnicode($date));
        }

        $.get($url, function (data) {
            if (data.status) {
                $('.v-timeline').html('').html(data.html);
                $('#modalTimeline').modal('show');
            }

            $('.panel-load').removeClass('whirl standard');
        }).fail(function (error) {
            console.log(error);
            toastr.error(error.statusText, 'Houve uma falha na requisição!');

            $('.panel-load').removeClass('whirl standard');
        });
    });

    $(document).on('click', '.btn-save-faturamento-clientes', function () {
        var $cliente = $('#distribuidor').val(),
            $valorFaturado = $('#faturamento').val(),
            $data = $('#data_faturamento').val(),
            $id = $('input[name="id"]').val();

        $('.panel-load').addClass('whirl standard');
        $.post('/cadastro/setor-atividade/clientemensal', {cliente: $cliente, valor_faturado: $valorFaturado, data: $data, id: $id}, function (data) {
            $('.panel-load').removeClass('whirl standard');
            if (data.status) {
                toastr.success('Registro salvo com sucesso!', 'Transação realizada com sucesso!');

                window.location.href = '/cadastro/setor-atividade/editar/' + $id + '/2';
            } else {
                $.each(data.mensagem, function (key, message) {
                    toastr.error(message, 'Transação não pode ser realizada!');
                });
            }
        }).fail(function (error) {
            console.log(error);
            toastr.error('Falha tentar salvar as informações!', 'Não foi possível realizar a transação');
        })
    });

    $(document).on('click', '.btn-excluir-cliente-mensal', function (e) {
        e.preventDefault();

        var $url = $(this).attr('url');
        var $id = $('#id').val();

        swal({
                title: "Deseja excluir o registro permanentemente?",
                text: "Essa ação irá excluir o registro da base de dados sem possibilidade de recuperação!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.get($url, function (data) {
                        if (data.status) {
                            swal({
                                title: "Transação realizada com sucesso!",
                                text: "O registro foi excluído com sucesso!",
                                type: "success"
                            }, function () {
                                window.location.href = '/cadastro/setor-atividade/editar/' + $id + '/2'
                            });
                        }

                        if (!data.status) {
                            var $text = '';
                            $.each(data.mensagem, function ($key, $message) {
                                $text += $message + "<br>";
                            });

                            swal({
                                title: "Transação não pode ser realizada!",
                                text: "Houve um problema ao tentar excluir o registro!<br><br>" + $text,
                                type: "error"
                            }, function () {
                                return false;
                            });
                        }
                    }).fail(function (error) {
                        console.log(error);
                        swal({title: "Transação não pode ser realizada!", text: "Houve um problema ao alterar a categoria do grupo de cliente!", type: "error"});
                    });
                }
            }
        );
    });

    $(document).on('change', '#fileFaturamento', function () {
        var formData = new FormData();
        var $id = $('#id').val();
        formData.append('file', $(this).prop('files')[0]);

        swal({
                title: "Deseja enviar o arquivo de Faturamento Mensal?",
                text: "Essa ação irá criar os registros de faturamento mensal!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.ajax({
                        url: '/cadastro/setor-atividade/importarfaturamentomensal',
                        type: 'POST',
                        data: formData,
                        success: function (data) {
                            $('.panel-load').removeClass('whirl standard');

                            if (data.status) {
                                swal({
                                    title: "Transaçao realizada com sucesso!",
                                    text: "A importação do arquivo foi realizada com sucesso!",
                                    type: "success"
                                }, function () {
                                    window.location.href = '/cadastro/setor-atividade/editar/' + $id + '/2';
                                });
                            } else {
                                swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema na importação do arquivo excel!", type: "error"});

                                $.each(data.mensagem, function ($key, $message) {
                                    toastr.error($message, 'Transação não pode ser realizada!');
                                });
                            }
                        },
                        error: function (error) {
                            $('.panel-load').removeClass('whirl standard');
                            console.log(error);
                            toastr.error('Ocorreu uma falha ao tentar importar o arquivo excel!');
                        },
                        cache: false,
                        contentType: false,
                        processData: false,
                        xhr: function () {  // Custom XMLHttpRequest
                            var myXhr = $.ajaxSettings.xhr();
                            if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                                myXhr.upload.addEventListener('progress', function () {
                                    /!* faz alguma coisa durante o progresso do upload *!/
                                }, false);
                            }
                            return myXhr;
                        }
                    });
                }
            }
        );
    });

    $(document).on('click', '.btn-save-faturamento-diario', function () {
        var $valorTotalBruto = $('#faturamento_bruto').val(),
            $valorTotalPedidos = $('#total_pedidos').val(),
            $valorTotalCarteira = $('#total_carteira').val(),
            $data = $('#data_diario').val(),
            $id = $('input[name="id"]').val();

        $('.panel-load').addClass('whirl standard');
        $.post('/cadastro/setor-atividade/fatuamentodiario', {
            id: $id,
            valor_total_bruto: $valorTotalBruto,
            valor_total_pedidos: $valorTotalPedidos,
            valor_total_carteira: $valorTotalCarteira,
            data: $data
        }, function (data) {
            $('.panel-load').removeClass('whirl standard');

            if (data.status) {
                toastr.success('Registro salvo com sucesso!', 'Transação realizada com sucesso!');

                window.location.href = '/cadastro/setor-atividade/editar/' + $id + '/3';
            } else {
                $.each(data.mensagem, function (key, message) {
                    toastr.error(message, 'Transação não pode ser realizada!');
                });
            }
        }).fail(function (error) {
            console.log(error);
            toastr.error('Falha tentar salvar as informações!', 'Não foi possível realizar a transação');
        })
    });

    $(document).on('click', '.btn-excluir-diario', function (e) {
        e.preventDefault();

        var $url = $(this).attr('url');
        var $id = $('#id').val();

        swal({
                title: "Deseja excluir o registro permanentemente?",
                text: "Essa ação irá excluir o registro da base de dados sem possibilidade de recuperação!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.get($url, function (data) {
                        if (data.status) {
                            swal({
                                title: "Transação realizada com sucesso!",
                                text: "O registro foi excluído com sucesso!",
                                type: "success"
                            }, function () {
                                window.location.href = '/cadastro/setor-atividade/editar/' + $id + '/3'
                            });
                        }

                        if (!data.status) {
                            var $text = '';
                            $.each(data.mensagem, function ($key, $message) {
                                $text += $message + "<br>";
                            });

                            swal({
                                title: "Transação não pode ser realizada!",
                                text: "Houve um problema ao tentar excluir o registro!<br><br>" + $text,
                                type: "error"
                            }, function () {
                                return false;
                            });
                        }
                    }).fail(function (error) {
                        console.log(error);
                        swal({title: "Transação não pode ser realizada!", text: "Houve um problema ao alterar a categoria do grupo de cliente!", type: "error"});
                    });
                }
            }
        );
    });

    $(document).on('change', '#fileDiario', function () {
        var formData = new FormData();
        var $id = $('#id').val();
        formData.append('file', $(this).prop('files')[0]);

        swal({
                title: "Deseja enviar o arquivo de Faturamento Diário?",
                text: "Essa ação irá criar os registros de faturamento diário!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.ajax({
                        url: '/cadastro/setor-atividade/importarfaturamentodiario',
                        type: 'POST',
                        data: formData,
                        success: function (data) {
                            $('.panel-load').removeClass('whirl standard');

                            if (data.status) {
                                swal({
                                    title: "Transaçao realizada com sucesso!",
                                    text: "A importação do arquivo foi realizada com sucesso!",
                                    type: "success"
                                }, function () {
                                    window.location.href = '/cadastro/setor-atividade/editar/' + $id + '/3';
                                });
                            } else {
                                swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema na importação do arquivo excel!", type: "error"});

                                $.each(data.mensagem, function ($key, $message) {
                                    toastr.error($message, 'Transação não pode ser realizada!');
                                });
                            }
                        },
                        error: function (error) {
                            $('.panel-load').removeClass('whirl standard');
                            console.log(error);
                            toastr.error('Ocorreu uma falha ao tentar importar o arquivo excel!');
                        },
                        cache: false,
                        contentType: false,
                        processData: false,
                        xhr: function () {  // Custom XMLHttpRequest
                            var myXhr = $.ajaxSettings.xhr();
                            if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                                myXhr.upload.addEventListener('progress', function () {
                                    /!* faz alguma coisa durante o progresso do upload *!/
                                }, false);
                            }
                            return myXhr;
                        }
                    });
                }
            }
        );
    });

    $(document).on('click', '.btn-save-linha-produto', function () {
        var $linhaProduto = $('#linha_produto').val(),
            $quantidade = $('#quantidade').val(),
            $data = $('#data_linha').val(),
            $id = $('input[name="id"]').val();

        $('.panel-load').addClass('whirl standard');
        $.post('/cadastro/setor-atividade/fatuamentolinha', {id: $id, linha_produto: $linhaProduto, quantidade: $quantidade, data: $data}, function (data) {
            $('.panel-load').removeClass('whirl standard');

            if (data.status) {
                toastr.success('Registro salvo com sucesso!', 'Transação realizada com sucesso!');

                window.location.href = '/cadastro/setor-atividade/editar/' + $id + '/4';
            } else {
                $.each(data.mensagem, function (key, message) {
                    toastr.error(message, 'Transação não pode ser realizada!');
                });
            }
        }).fail(function (error) {
            console.log(error);
            toastr.error('Falha tentar salvar as informações!', 'Não foi possível realizar a transação');
        })
    });

    $(document).on('click', '.btn-excluir-linha-produto', function (e) {
        e.preventDefault();

        var $url = $(this).attr('url');
        var $id = $('#id').val();

        swal({
                title: "Deseja excluir o registro permanentemente?",
                text: "Essa ação irá excluir o registro da base de dados sem possibilidade de recuperação!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.get($url, function (data) {
                        if (data.status) {
                            swal({
                                title: "Transação realizada com sucesso!",
                                text: "O registro foi excluído com sucesso!",
                                type: "success"
                            }, function () {
                                window.location.href = '/cadastro/setor-atividade/editar/' + $id + '/4'
                            });
                        }

                        if (!data.status) {
                            var $text = '';
                            $.each(data.mensagem, function ($key, $message) {
                                $text += $message + "<br>";
                            });

                            swal({
                                title: "Transação não pode ser realizada!",
                                text: "Houve um problema ao tentar excluir o registro!<br><br>" + $text,
                                type: "error"
                            }, function () {
                                return false;
                            });
                        }
                    }).fail(function (error) {
                        console.log(error);
                        swal({title: "Transação não pode ser realizada!", text: "Houve um problema ao alterar a categoria do grupo de cliente!", type: "error"});
                    });
                }
            }
        );
    });

    $(document).on('change', '#fileLinha', function () {
        var formData = new FormData();
        var $id = $('#id').val();
        formData.append('file', $(this).prop('files')[0]);

        swal({
                title: "Deseja enviar o arquivo de Faturamento da Linha de Produto?",
                text: "Essa ação irá criar os registros de faturamento da linha de produto!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.ajax({
                        url: '/cadastro/setor-atividade/importarfaturamentolinha',
                        type: 'POST',
                        data: formData,
                        success: function (data) {
                            $('.panel-load').removeClass('whirl standard');

                            if (data.status) {
                                swal({
                                    title: "Transaçao realizada com sucesso!",
                                    text: "A importação do arquivo foi realizada com sucesso!",
                                    type: "success"
                                }, function () {
                                    window.location.href = '/cadastro/setor-atividade/editar/' + $id + '/4';
                                });
                            } else {
                                swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema na importação do arquivo excel!", type: "error"});

                                $.each(data.mensagem, function ($key, $message) {
                                    toastr.error($message, 'Transação não pode ser realizada!');
                                });
                            }
                        },
                        error: function (error) {
                            $('.panel-load').removeClass('whirl standard');
                            console.log(error);
                            toastr.error('Ocorreu uma falha ao tentar importar o arquivo excel!');
                        },
                        cache: false,
                        contentType: false,
                        processData: false,
                        xhr: function () {  // Custom XMLHttpRequest
                            var myXhr = $.ajaxSettings.xhr();
                            if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                                myXhr.upload.addEventListener('progress', function () {
                                    /!* faz alguma coisa durante o progresso do upload *!/
                                }, false);
                            }
                            return myXhr;
                        }
                    });
                }
            }
        );
    });

    $(document).on('click', '.btn-save-estado', function () {
        var $estado = $('#estado').val(),
            $valor_faturado = $('#faturado_estado').val(),
            $valor_pedido = $('#pedido_estado').val(),
            $data = $('#data_estado').val(),
            $id = $('input[name="id"]').val();

        $('.panel-load').addClass('whirl standard');
        $.post('/cadastro/setor-atividade/fatuamentoestado', {id: $id, estado: $estado, valor_total_faturado: $valor_faturado, valor_total_pedido: $valor_pedido, data: $data}, function (data) {
            $('.panel-load').removeClass('whirl standard');

            if (data.status) {
                toastr.success('Registro salvo com sucesso!', 'Transação realizada com sucesso!');

                window.location.href = '/cadastro/setor-atividade/editar/' + $id + '/5';
            } else {
                $.each(data.mensagem, function (key, message) {
                    toastr.error(message, 'Transação não pode ser realizada!');
                });
            }
        }).fail(function (error) {
            console.log(error);
            toastr.error('Falha tentar salvar as informações!', 'Não foi possível realizar a transação');
        })
    });

    $(document).on('click', '.btn-excluir-estado', function (e) {
        e.preventDefault();

        var $url = $(this).attr('url');
        var $id = $('#id').val();

        swal({
                title: "Deseja excluir o registro permanentemente?",
                text: "Essa ação irá excluir o registro da base de dados sem possibilidade de recuperação!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.get($url, function (data) {
                        if (data.status) {
                            swal({
                                title: "Transação realizada com sucesso!",
                                text: "O registro foi excluído com sucesso!",
                                type: "success"
                            }, function () {
                                window.location.href = '/cadastro/setor-atividade/editar/' + $id + '/5'
                            });
                        }

                        if (!data.status) {
                            var $text = '';
                            $.each(data.mensagem, function ($key, $message) {
                                $text += $message + "<br>";
                            });

                            swal({
                                title: "Transação não pode ser realizada!",
                                text: "Houve um problema ao tentar excluir o registro!<br><br>" + $text,
                                type: "error"
                            }, function () {
                                return false;
                            });
                        }
                    }).fail(function (error) {
                        console.log(error);
                        swal({title: "Transação não pode ser realizada!", text: "Houve um problema ao alterar a categoria do grupo de cliente!", type: "error"});
                    });
                }
            }
        );
    });

    $(document).on('change', '#fileEstado', function () {
        var formData = new FormData();
        var $id = $('#id').val();
        formData.append('file', $(this).prop('files')[0]);

        swal({
                title: "Deseja enviar o arquivo de Faturamento por Estado?",
                text: "Essa ação irá criar os registros de faturamento por estados!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.ajax({
                        url: '/cadastro/setor-atividade/importarfaturamentoestado',
                        type: 'POST',
                        data: formData,
                        success: function (data) {
                            $('.panel-load').removeClass('whirl standard');

                            if (data.status) {
                                swal({
                                    title: "Transaçao realizada com sucesso!",
                                    text: "A importação do arquivo foi realizada com sucesso!",
                                    type: "success"
                                }, function () {
                                    window.location.href = '/cadastro/setor-atividade/editar/' + $id + '/5';
                                });
                            } else {
                                swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema na importação do arquivo excel!", type: "error"});

                                $.each(data.mensagem, function ($key, $message) {
                                    toastr.error($message, 'Transação não pode ser realizada!');
                                });
                            }
                        },
                        error: function (error) {
                            $('.panel-load').removeClass('whirl standard');
                            console.log(error);
                            toastr.error('Ocorreu uma falha ao tentar importar o arquivo excel!');
                        },
                        cache: false,
                        contentType: false,
                        processData: false,
                        xhr: function () {  // Custom XMLHttpRequest
                            var myXhr = $.ajaxSettings.xhr();
                            if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                                myXhr.upload.addEventListener('progress', function () {
                                    /!* faz alguma coisa durante o progresso do upload *!/
                                }, false);
                            }
                            return myXhr;
                        }
                    });
                }
            }
        );
    });

    $(document).on('click', '#chartRegiao', function (evt) {
        var index = window.myChartRegiao.scales['y-axis-0'].getValueForPixel(evt.offsetY),
            form = $('form[name="frmPesquisaRegiao"]').serializeObject();

        $('.panel-load').addClass('whirl standard');

        form.sigla = window.myChartRegiao.scales['y-axis-0'].ticks[index];
        $.post('/dashboard/regioesexpande', {form: form}, function (data) {
            if (data.status) {
                $('.row-regioes').removeClass('hidden');
                $('#tBodyRegioes').html('').html(data.html);
            }

            $('.panel-load').removeClass('whirl standard');
        }).fail(function (error) {
            $('.panel-load').removeClass('whirl standard');
            console.log(error);
            toastr.error('Error: ' + error.statusText, 'Não foi possível buscar os pedidos das regiões!');
        });
    });

    $(document).on('change', '#frmContato select[name="cliente"]', function (e) {
        var $id = $(this).val();

        $.get('/cadastro/cliente/infocliente/' + $id, function (data) {
            if (data.status) {
                var cliente = data.data;
                $('#onde_comprou').val(cliente.razaoSocial);
                $('#cnpj_comprou').val(cliente.cnpj);
            }
        }).fail(function (error) {
            console.log(error);
            toastr.error('Error: ' + error.statusText, 'Não foi possível buscar os pedidos das regiões!');
        });
    });

    $(document).on('submit', '#formNotaFiscalFinalizar', function ($e) {
        $e.preventDefault();
        $e.stopPropagation();
        var formData = new FormData(this);
        var $id = $('input[name="id_ordem"]').val();

        swal({
                title: "Deseja anexar o arquivo de nota fiscal a ordem #" + $id + "?",
                text: "Essa ação irá salvar e deixar disponivel ao distribuidor a nota fiscal de finalização da OS!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, desejo!",
                cancelButtonText: "Não, cancele!",
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.ajax({
                        url: '/ordemservico/gerenciador/anexarnotafiscal',
                        type: 'POST',
                        data: formData,
                        success: function (data) {

                            if (data.status) {
                                swal({
                                    title: "Transaçao realizada com sucesso!",
                                    text: "O arquivo foi anexado a OS com sucesso!",
                                    type: "success"
                                }, function () {
                                    window.location.reload();
                                });
                            } else {
                                swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema ao anexar a nota fiscal de finalização!", type: "error"});

                                $.each(data.mensagem, function ($key, $message) {
                                    toastr.error($message, 'Transação não pode ser realizada!');
                                });
                            }
                        },
                        error: function (error) {
                            $('.panel-load').removeClass('whirl standard');
                            console.log(error);
                            toastr.error('Ocorreu uma falha ao tentar anexar a nota fiscal de finalização!');
                        },
                        cache: false,
                        contentType: false,
                        processData: false,
                        xhr: function () {  // Custom XMLHttpRequest
                            var myXhr = $.ajaxSettings.xhr();
                            if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                                myXhr.upload.addEventListener('progress', function () {
                                    /!* faz alguma coisa durante o progresso do upload *!/
                                }, false);
                            }
                            return myXhr;
                        }
                    });
                }
            }
        );
    });

    $(document).on('click', '.span-manutencao', function (e) {
        var $id = $(this).attr('data-id');
        var $descricao = $(this).attr('data-descricao');
        var $status = $(this).attr('data-status');

        $('#manutencaoItemPedido').modal('show').on('shown.bs.modal', function (m) {
            $('#manutencaoItemPedido #id').val($id);
            $('#manutencaoItemPedido #item-pedido-material').html('').html($descricao);
            $('#manutencaoItemPedido #status_item').val($status);
        })
    });

    $(document).on('click', '.btn-manutencao-item-pedido', function (e) {
        var $id = $('#manutencaoItemPedido #id').val();
        var $status = $('#manutencaoItemPedido #status_item').val();

        $.post('/pedido/gerenciador/manutencaostatusitem', {id: $id, status: $status}, function (data) {
            if (data.status) {
                toastr.success('Status do item alterado com sucesso!', 'Transação realizada com sucesso!');

                setTimeout(function () {
                    window.location.reload(true);
                }, 3000);
            } else {
                if (data.mensagem !== undefined) {
                    $.each(data.mensagem, function (key, value) {
                        toastr.error(value, 'Transação não pode ser realizada!');
                    });
                } else {
                    toastr.error('Não foi possível realizar a transação!', 'Transação não pode ser realizada!');
                }
            }
        }).fail(function (error) {
            console.log(error);

            toastr.error('Não foi possível realizar a transação! Erro: ' + error.statusText, 'Transação não pode ser realizada!');
        });
    });

    $(document).on('click', '.btn-manutencao-salvar-pedido', function (e) {
        var $status = $('#status').val();
        var $id = $('input[name="id"]').val();

        $.post('/pedido/gerenciador/manutencaostatus', {id: $id, status: $status}, function (data) {
            if (data.status) {
                toastr.success('Status do pedido alterado com sucesso!', 'Transação realizada com sucesso!');

                setTimeout(function () {
                    window.location.reload(true);
                }, 3000);
            } else {
                if (data.mensagem !== undefined) {
                    $.each(data.mensagem, function (key, value) {
                        toastr.error(value, 'Transação não pode ser realizada!');
                    });
                } else {
                    toastr.error('Não foi possível realizar a transação!', 'Transação não pode ser realizada!');
                }
            }
        }).fail(function (error) {
            console.log(error);

            toastr.error('Não foi possível realizar a transação! Erro: ' + error.statusText, 'Transação não pode ser realizada!');
        });
    });

    $(document).on('submit', '#form-manutencao-pedido', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.panel-load').addClass('whirl standard');
        var formData = new FormData(this);
        $.ajax({
            url: '/comunicacao/pedido/manutencao',
            type: 'POST',
            data: formData,
            success: function (data) {

                if (data.status) {
                    swal({
                        title: "Transaçao realizada com sucesso!",
                        text: "Pedidos atualizado com sucesso!",
                        type: "success"
                    }, function () {
                        window.location.reload();
                    });
                } else {
                    swal({title: "Transaçao não pode ser realizada!", text: "Houve um problema carregar o arquivo!", type: "error"});

                    $.each(data.mensagem, function ($key, $message) {
                        toastr.error($message, 'Transação não pode ser realizada!');
                    });
                }
            },
            error: function (error) {
                $('.panel-load').removeClass('whirl standard');
                console.log(error);
                toastr.error('Ocorreu uma falha ao tentar carregar o arquivo!');
            },
            cache: false,
            contentType: false,
            processData: false,
            xhr: function () {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                    myXhr.upload.addEventListener('progress', function () {
                        /!* faz alguma coisa durante o progresso do upload *!/
                    }, false);
                }
                return myXhr;
            }
        });
    });

    $(document).on('shown.bs.modal', '#modalPesquisaSolicitacaoBonus', function (e) {
        var $config = {
            attrElement: 'id',
            nameElement: 'cliente',
            elementDropDownParent: $('.form-cliente'),
            url: "/cadastro/cliente/clienteautocomplete"
        };
        configureSelect2WithAutocomplete($config, false);
    });

    $(document).on('submit', '#form-aprovacao-bonus-soliticacao', function (e) {
        var $bt = '.btn-aprovacao-solicitacao';
        $($bt).ladda();
        $($bt).ladda('start');
    });

    $(document).on('submit', '#FrmPesquisaReclamante', function (e) {
        e.preventDefault();
        var $bt = '.btnPesquisaReclamante';
        $($bt).ladda();
        $($bt).ladda('start');

        var $nome = new String($('input[name="pesquisa_por_nome"]').val());
        var $telefone = new String($('input[name="pesquisa_por_telefone"]').val());

        if ($nome.length <= 3) {
            if ($telefone.length <= 3) {
                toastr.error('Preencha os campos de pesquisa para processar!');
                $($bt).ladda('stop');
                return false;
            }
        }

        $.ajax({type: 'post', url: '/cadastro/consumidor/reclamante', data: {nome: $nome, telefone: $telefone}, datatype: 'json'})
            .done(function (data) {
                if (data.status) {
                    $(".resultado-pesquisa-reclamante").html('').html(data['dados']);
                }
            })
            .complete(function () {
                $($bt).ladda('stop');
            });
    });

    $(document).on('click', '.btnSelecionaReclamante', function (e) {
        var $cpf = $(this).attr('itemid');
        $('.busca-consumidor').val($cpf).trigger('focusout');
        $('.modal-pesquisa-reclamante').modal('hide').data('bs.modal', null);
    });

    $(document).on('click', '.btnReabrirGrupoOrdem', function (e) {
        e.preventDefault();
        var $bt = $(this);
        var $id = $bt.attr('itemid');
        $($bt).ladda();
        $($bt).ladda('start');

        $.ajax({type: 'get', url: '/distribuidor/assistencia-remessa/reabrir/'+$id, datatype: 'json'})
            .done(function (data) {
                if (data.status) {
                   window.location.reload(true);
                } else {
                    toastr.error(data.mensagem);
                }
            })
            .complete(function () {
                $($bt).ladda('stop');
            });
    });

    $(document).on('click', '.btnReabrirOrdem', function (e) {
        e.preventDefault();
        var $bt = $(this);
        var $id = $bt.attr('itemid');
        $($bt).ladda();
        $($bt).ladda('start');

        $.ajax({type: 'get', url: '/distribuidor/assistencia-reposicao/reabrir/'+$id, datatype: 'json'})
            .done(function (data) {
                if (data.status) {
                   window.location.reload(true);
                } else {
                    toastr.error(data.mensagem);
                }
            })
            .complete(function () {
                $($bt).ladda('stop');
            });
    });

    $(document).on('click', '.btn-pesquisa-servico', function(e){
       var $cliente = $('input[name="cliente"]').val();
       var $search = $('#pesquisa_servico').val();
       $('#modalTecnico .modal-content').addClass('whirl standard');

       $.get('/ordemservico/gerenciador/pesquisaservico/' + $cliente + '/' + $search, function(data){
            if (!data.status){
                $.each(data.mensagem, function(key, message){
                    toastr.error(message, 'Ops! Houve um problema!');
                });
            }
            else{
                $('#divEstruturaServicosRemessa .dd').html('').html(data.html).find(".quantidade-spin")
                    .each(function (index) {
                        if (_.isInteger(_.toNumber($(this).attr('p1')))) {
                            $(this).TouchSpin({
                                min: 0,
                                max: _.toNumber($(this).attr('max')),
                                step: _.toNumber($(this).attr('p1')),
                                forcestepdivisibility: 'none'
                            });
                        } else {
                            $(this).TouchSpin({step: $(this).attr('p1'), decimals: 2});
                        }
                    });
            }

            $('#modalTecnico .modal-content').removeClass('whirl standard');
       }).fail(function(error){
           console.log(error);
           toastr.error('Houve uma falha na pesquisa do serviço!', 'Tente novamente mais tarde!');

           $('#modalTecnico .modal-content').removeClass('whirl standard');
       })
    });

    $(document).on('keypress', 'input[name="pesquisa_servico"]', function(e){
        if (e.which == 13){
            $('.btn-pesquisa-servico').trigger('click');
        }
    });

    $(document).on('shown.bs.modal', '#modalEscolhaClienteFinal', function(){
        $('#form-consumidor-final select[id="cliente"]').select2({
            lang: 'pt-BR',
            width: '100%',
            dropdownParent: $('.form-group-consumidor')
        });
    });

    $(document).on('click', '.btn-email-remessa', function(e){
        var $url = $(this).attr('url');

        $('#frm-envio-email').attr('action', $url);
        $('#modalEnviaEmail').modal('show');
    });

    $(document).on('submit', '#frm-envio-email', function(e){
        e.preventDefault();
        var $url = $(this).attr('action');
        $('#modalEnviaEmail .modal-content').addClass('whirl standard');

        var $form = $(this).serializeObject();
        $.ajax({type: 'post', url: $url, data: $form, datatype: 'json'})
            .done(function (data) {
                if (!data.status){
                    $.each(data.mensagem, function(key, message){
                        toastr.error(message, 'Ops! Houve um problema!');
                    });
                }
                else{
                    toastr.success('Email enviado para o responsável com sucesso!', 'Email enviado com sucesso!');
                }
            })
            .complete(function () {
                $('#modalEnviaEmail .modal-content').removeClass('whirl standard');
                $('#modalEnviaEmail').modal('hide');
                $('#modalEnviaEmail').on('hidden.bs.modal', function(){
                    $('#modalEnviaEmail #email').val('');
                });
            });
    });

    $(document).on('submit', "#busca-xml-sap", function (e) {
        e.preventDefault();
        var $url = '/cron/atualizaxmlporpedido';
        $('.load-busca-xml-sap').addClass('whirl standard');
        var $form = $(this).serializeObject();
        $.ajax({type: 'post', url: $url, data: $form, datatype: 'json'})
        .done(function (data) {

            //if (!data.status){
                $.each(data, function(key, resposta){
                    toastr.options.timeOut = 30000;
                    if(resposta['status']){
                        toastr.success(resposta['message'], 'Processado com sucesso!');
                    }else{
                        toastr.error(resposta['message'], 'Ops! Houve um problema!');
                    }
                });
        })
        .complete(function () {
            $('.load-busca-xml-sap').removeClass('whirl standard');
        });
    });

    $(document).on('click', '.btn-laudo-edit-tecnico-material', function(e){
        e.preventDefault();
        var $id = $(this).attr('os-id');
        $('input[name="ordem_servico"]').val($id);

        $('.panel-load').addClass('whirl standard');
        $.get('/ordemservico/gerenciador/editarmanutencao/' + $id, function (data) {
            if (data.status) {
                window.sessionStorage.setItem('pecas_assistencia', JSON.stringify(data.pecas));
                window.sessionStorage.setItem('servicos_assistencia', JSON.stringify(data.servicos));

                $('#divEstruturaMaterial').html('').html(data.estrutura.replace('style="margin-top: 13%;"', '')).find(".quantidade-spin")
                    .each(function (index, value) {
                        var $initValue = '',
                            $material = value.name.match(/(\d+)/)[0];

                        if (data.pecas !== undefined && data.pecas.length > 0){
                            for (var $p = 0; $p < data.pecas.length; $p++){
                                if (data.pecas[$p].material === $material){
                                    $initValue = data.pecas[$p].quantidade;
                                    break;
                                }
                            }
                        }

                        if (data.servicos !== undefined && data.servicos.length > 0){
                            for(var $s = 0; $s < data.servicos.length; $s++){
                                if (data.servicos[$s].material === $material){
                                    $initValue = data.servicos[$s].quantidade;
                                    break;
                                }
                            }
                        }

                        if (_.isInteger(_.toNumber($(this).attr('p1')))) {
                            $(this).TouchSpin({
                                initval: $initValue,
                                min: 0,
                                max: _.toNumber($(this).attr('max')),
                                step: _.toNumber($(this).attr('p1')),
                                forcestepdivisibility: 'none'
                            });
                        } else {
                            $(this).TouchSpin({step: $(this).attr('p1'), decimals: 2});
                        }
                    });

                if (data.consumidor === 1){
                    $('#divEmailConsumidor').removeClass('hidden');
                    $('#divEmailConsumidor').html('').html('<small class="font-bold">E-mail Consumidor</small> <div class="form-group"><input type="email" class="form-control" name="email_consumidor"></div>');
                }

                if (data.options_defeito) {
                    $('select[name="defeito_origem"]').html('').html(data.options_defeito);
                }

                if (data.options_defeito_tecnico) {
                    $('select[name="defeito_tecnico"]').html('').html(data.options_defeito_tecnico);
                    if (data.options_defeito_tecnico.indexOf('selected') != -1) {
                        $('select[name="defeito_tecnico"]').prop('disabled', true);
                    }
                }

                if (data.laudo !== undefined) {
                    $('textarea[name="laudo"]').val(data.laudo.descricao);

                    if (!data.laudo.garantia) {
                        var $valManutencao = $('#valor_manutencao');
                        $('#tipoManutencaoForaGarantia').prop('checked', true);

                        $valManutencao.prop('readonly', true);
                        $valManutencao.val(data.laudo.valor_manutencao);
                        $('.valor-orcamento').fadeIn();

                        $('.btn-aprovacao-tecnico[status="finalizar"]').fadeIn();
                    }
                }

                if (data.cobrar_pecas || !data.laudo.garantia) {
                    $('#cobrarPecasSim').iCheck('check');
                    $('#cobrarPecasNao').iCheck('uncheck');
                    $('#cobrarPecasNao').iCheck('update');
                    $('.valor-pecas').removeClass('hidden');

                    $('#divCobrancaPecas').removeClass('hidden');
                }

                if (data.pecas.length > 0 || data.servicos.length > 0){
                    if (!$('#tipoManutencaoForaGarantia').is(':checked')) {
                        $('#tipoManutencao').iCheck('check');
                    }

                    $('.material-troca').addClass('hidden');
                    $('#divEstruturaMaterial').removeClass('hidden');
                }

                $('#modalTecnico').modal({
                    show: true,
                    backdrop: 'static'
                }).on('shown.bs.modal', function () {
                    $("#divAnexoTecnico").html();

                    var $foraGarantia = ($('input[name="tipo_manutencao"]:checked').val() == '0');
                    if (!$foraGarantia) {
                        $('.valor-pecas').addClass('hidden');
                    } else {
                        $('.material-troca').addClass('hidden');
                        $('#divManutencaoTroca').addClass('hidden');
                    }

                    $('.select-tecnico').select2({dropdownParent: $('.form-group-tecnico'), lang: 'pt-BR', width: '100%'});
                    $('#observacao_distribuidor').html('').html(data.observacao_distribuidor);
                    $('#lote_fabricacao_os').html('').html(data.lote_fabricacao);

                    var $configMaterial = {
                        attrElement: 'name',
                        nameElement: 'material_troca',
                        elementDropDownParent: $('.form-group-materia-troca'),
                        url: "/cadastro/material/componenteautocomplete"
                    };

                    configureSelect2WithAutocomplete($configMaterial, false);

                    if (data.material_troca instanceof Object) {
                        var $options = new Option(data.material_troca.text, data.material_troca.id, true, true);

                        $('select[name="material_troca"]').append($options).trigger('change');
                        $('select[name="material_troca"]').prop('disabled', true);
                    }

                    $('.panel-load').removeClass('whirl standard');
                });
            }
        }).fail(function (error) {
            toastr.error('Ocorreu um problema ao tentar obter o registro.<br>Error: ' + error.statusText);
            $('.panel-load').removeClass('whirl standard');
        });
    });
});

function getPainel(dataIni, dataFim, paramsSetor, paramsTipo, $paramsCliente) {
    $.ajax({
        type: 'post',
        url: '/distribuidor/painel/pesquisapainel',
        data: {tipo_pesquisa: paramsTipo, clientes: $paramsCliente, setor: paramsSetor, dataInicio: dataIni, dataFim: dataFim},
        dataType: 'json'
    }).done(function (data) {
        if (data.status) {
            $('#metaCliente').html('R$ ' + data.response.meta);
            $('#pedidosCliente').html('R$ ' + data.response.totalPedidos);
            $('#pedidosMeta').html('R$ ' + data.response.totalMeta);
            $('#pedidosFaturados').html('R$ ' + data.response.totalFaturado);
            $('#pedidosCarteira').html('R$ ' + data.response.totalCarteira);
            $('#pedidosDevolucao').html('R$ ' + data.response.totalDevolucao);
            $('#metaFaturamento').html('R$ ' + data.response.totalConfirmado);
            $('#pedidosPotencialFat').html('R$ ' + data.response.totalPotencialFaturamento);

            $('#progressBarPedidos').css('width', ((data.response.percentualPedidos > 100) ? '100%' : data.response.percentualPedidos + '%'));
            $('#progressBarPedidos').html(data.response.percentualPedidos + '%');

            $('.panel-hora-atualizada').html(data.response.dataRequisicao);

            $('.text-color-meta').addClass('text-danger');
            if (data.response.totalMeta.indexOf('-') != -1) {
                $('.text-color-meta').removeClass('text-danger');
                $('#pedidosMeta').html('R$ 0,00');
            }

            $('.text-color-realizados').addClass('text-success');
            $('.text-color-realizados').removeClass('text-warning');
            if (data.response.totalPedidos.indexOf('-') != -1) {
                $('.text-color-realizados').removeClass('text-success');
                $('.text-color-realizados').addClass('text-warning');
            }

            try {
                new Chart(document.getElementById('graficoPedidosFaturados'), {
                    type: 'bar',
                    data: {
                        labels: JSON.parse(data.response.grafico_trimestre.labels),
                        datasets: JSON.parse(data.response.grafico_trimestre.dataSet)
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true,
                                    stepSize: 10,
                                    stepValue: 5,
                                    max: 100
                                }
                            }]
                        },
                        tooltips: {
                            mode: 'label',
                            callbacks: {
                                label: function (tooltipItem, dataCallFaturado) {
                                    var label = dataCallFaturado.datasets[tooltipItem.datasetIndex].label || '';

                                    if (label) {
                                        label += ': ';
                                    }
                                    label += tooltipItem.yLabel + '%';
                                    return label;
                                }
                            }
                        }
                    }
                });

                new Chart(document.getElementById("graficoPedidosMeta"), {
                    type: 'bar',
                    data: {
                        datasets: JSON.parse(data.response.grafico_metas)
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: {
                            display: true
                        },
                        scales: {
                            xAxes: [{
                                ticks: {
                                    beginAtZero: true
                                },
                                stacked: true
                            }],
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                },
                                stacked: true
                            }]
                        },
                        tooltips: {
                            callbacks: {
                                label: function (tooltipItem, data) {
                                    var dataset = data.datasets[tooltipItem.datasetIndex];
                                    var currentValue = dataset.data[tooltipItem.index];

                                    return dataset.label + ": " + parseFloat(currentValue).toLocaleString('pt-br', {style: 'currency', currency: 'BRL'});
                                }
                            }
                        }
                    }
                });
            } catch (error) {
                console.log(error);
                toastr.warning('Ocorreu um problema ao carregar as informações do gráfico!', 'Não foi possível carregar todas informações!');
            }
        }
    }).complete(function () {

    }).fail(function (error) {
        toastr.error('Falha ao tentar buscar os dados do pedido!', 'Transação não pode ser realizada!')
        console.log(error);
    });
}

function getMetaCliente($grupo, $ano, $pais) {
    $.ajax({type: 'get', url: '/cadastro/grupo-empresarial-cliente/viewmeta/' + $grupo + '/' + $ano + '/' + $pais, data: {}, datatype: 'json'})
        .done(function (data) {
            if (data['status']) {
                $('form[name="formMetaCliente"]').prop('action', data['action']);
                $('#bodyTableMeta').html('').html(data['htmlMeta']);
                $('#bodyTableMetaTotal').html('').html(data['htmlTotal']);
                
                $('#bodyTableMetaOmegasat').html('').html(data['htmlMetaOmegasat']);
                $('#bodyTableMetaTotalOmegasat').html('').html(data['htmlTotalOmegasat']);

                $(".moeda").maskMoney({thousands: '.', decimal: ',', allowZero: true});
                $(".moeda_decimal_none").maskMoney({thousands: '.', decimal: ',', allowZero: true, precision: 0});

                $('#formMetaCliente').keypress(function (e) {
                    var code = null;
                    code = (e.keyCode ? e.keyCode : e.which);                
                    return (code == 13) ? false : true;
                });
            } else {
                toastr.error(data);
            }
        })
        .complete(function () {

        });
}

function recalcularPedido($pedido, $participaCampanha, $pedidoProgramado) {
    $('.splash').css('display', 'block');
    return $.post('/distribuidor/pedido/recalcular', {pedido: $pedido, hasCampanha: $participaCampanha, pedido_programado: $pedidoProgramado}, function (data) {
        $('.splash').css('display', 'none');

        try {
            if (!(data instanceof Object)) {
                swal({
                    html: true,
                    type: "error",
                    title: "Ops, houve um problema ao tentar recalcular o pedido!",
                    text: data
                });
            }

            if (data.status) {
                var $textMessage = "";
                var $titulo = "";
                var $tipo = "";

                if (data.mensagem != undefined && data.mensagem.length > 0) {
                    $titulo += "Processo de recalculo concluido!";
                    $tipo = "success";

                    var $count = data.mensagem.length;
                    $.each(data.mensagem, function (key, item) {
                        $textMessage += ('-' + item) + (((key + 1) == $count) ? '' : '<br>');
                    });
                }

                window.sessionStorage.setItem('pedido_recalculado', JSON.stringify({
                    pedido: $pedido,
                    calculado: true
                }));

                swal({
                    html: true,
                    type: $tipo,
                    title: $titulo,
                    text: $textMessage
                }, function () {
                    window.location.href = '/distribuidor/pedido/editar/' + $pedido;
                });
            } else {
                var $textMessage = "<b>Log de erros:<br>";
                var $count = data['mensagem'].length;
                $.each(data['mensagem'], function (key, item) {
                    $textMessage += ('- ' + item) + (((key + 1) == $count) ? '' : '<br>');
                });
                $textMessage += '</b>';

                window.sessionStorage.setItem('pedido_recalculado', JSON.stringify({
                    pedido: $pedido,
                    calculado: false
                }));

                swal({
                    html: true,
                    type: "error",
                    title: "Ops, houve um problema ao tentar recalcular o pedido!",
                    text: '<div class="text-left">' + $textMessage + '</div>'
                }, function () {
                    window.location.href = '/distribuidor/pedido/editar/' + $pedido;
                });
            }
        } catch (error) {
            swal({
                html: true,
                type: "error",
                title: "Ops, houve um problema ao tentar recalcular o pedido!",
                text: error.message
            });
        }
    }).fail(function (error) {
        $('.splash').css('display', 'none');
        toastr.error(error.statusText, 'Transação não pode ser realizada!');
    });
}

function getMetaMacro($ano, $pais) {
    window.location.href = '/cadastro/meta-macro/meta/' + $ano + '/' + $pais;
}

function verificaFinalizacaoOs() {
    var $session = window.sessionStorage;
    var $listOs = ($session.getItem('listaOs') != null ? JSON.parse($session.getItem('listaOs')) : []);

    $.each($listOs, function ($key, $item) {
        $('.choice-os-' + $item.id).html('').html('<i class="text-success fa fa-check fa-5x"></i>');
        $('.choice-os-' + $item.id).addClass('selected');

        $('.btn-finalizar-os').removeClass('hidden');
    });
}

function readURL(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
            $('.img-resumo').attr('src', e.target.result);
        }

        reader.readAsDataURL(input.files[0]);
    }
}

function replaceAll(string, token, newtoken) {
    while (string.indexOf(token) != -1) {
        string = string.replace(token, newtoken);
    }
    return string;
}

function formatRepo(repo) {
    if (repo.loading) return repo.text;

    var markup = "<div class='select2-result-repository clearfix'>" +
        "<div class='select2-result-repository__meta'>" +
        "<div class='select2-result-repository__title'>" + repo.text + "</div>";

    markup += "<div class='select2-result-repository__statistics'>" +
        "</div>" +
        "</div>" +
        "</div>";

    return markup;
}

function formatRepoSelection(repo) {
    return repo.text || repo.id;
}

function configuraSelect2Contato() {
    var $configCliente = {
        attrElement: 'name',
        nameElement: 'cliente',
        elementDropDownParent: $('#modalPesquisa, .cliente-busca'),
        url: "/cadastro/cliente/clienteautocomplete"
    }
    configureSelect2WithAutocomplete($configCliente, true, 'getClienteUsuarios', 'removeSelectionClienteUsuarios');

    var $configMaterial = {
        attrElement: 'name',
        nameElement: 'material',
        elementDropDownParent: '',
        url: "/cadastro/material/materialautocomplete"
    }
    configureSelect2WithAutocomplete($configMaterial, false);
}

function configuraSelect2Os() {
    var $configs = [
        {
            attrElement: 'name',
            nameElement: 'usuario',
            elementDropDownParent: '',
            url: "/acesso/usuario/usuarioautocomplete"
        },
        {
            attrElement: 'name',
            nameElement: 'aprovacao_usuario',
            elementDropDownParent: '',
            url: "/acesso/usuario/usuarioautocomplete"
        },
        {
            attrElement: 'name',
            nameElement: 'cliente',
            elementDropDownParent: '',
            url: "/cadastro/cliente/clienteautocomplete"
        },
        {
            attrElement: 'name',
            nameElement: 'consumidor',
            elementDropDownParent: '',
            url: "/cadastro/consumidor/consumidorautocomplete"
        },
        {
            attrElement: 'name',
            nameElement: 'material',
            elementDropDownParent: '',
            url: "/cadastro/material/materialautocompleteposvendasdistribuidor"
        },
        {
            attrElement: 'name',
            nameElement: 'material_item',
            elementDropDownParent: '',
            url: "/cadastro/material/materialautocomplete"
        }
    ];

    for (var $i = 0; $i < $configs.length; $i++) {
        configureSelect2WithAutocomplete($configs[$i], false);
    }
}

function modalEditMaterialRemessa(data) {
    $('#addMaterial').modal({show: true, backdrop: 'static'}).on('shown.bs.modal', function () {
        if (data != undefined) {
            $('.modal-remessa').html('').html(data);
        }

        $("#distribuidor-assistencia-remessa").validate({
            rules: {
                material: {
                    required: true
                },
                'defeito[]': {
                    required: true
                },
                material_identificacao: {
                    required: true
                },
                material_compra_nota: {
                    required: true
                },
                material_compra_data: {
                    required: false
                },
                material_compra_local: {
                    required: true
                }
            },
            messages: {
                material: {
                    required: "Informe um material para a OS."
                },
                'defeito[]': {
                    required: "Informe qual o defeito do material."
                },
                material_identificacao: {
                    required: "Informe o numero de lote de compra do material."
                },
                material_compra_nota: {
                    required: "Informe qual a numero da nota fiscal de compra do material."
                },
                material_compra_data: {
                    required: "Informe qual a data de compra do material."
                },
                material_compra_local: {
                    required: "Informe qual a data de compra do material."
                }
            }
        });

        setTimeout(function () {
            var $config = {
                attrElement: 'name',
                nameElement: 'material',
                elementDropDownParent: $('#addMaterial .form-group-material'),
                url: "/cadastro/material/materialautocompleteposvendasdistribuidor"
            }
            configureSelect2WithAutocomplete($config, false);

            $('.select-defeito').select2({
                dropdownParent: $('#addMaterial .form-group-defeito'),
                lang: 'pt-BR',
                width: '100%'
            });
        }, 500);
    });
}

function modalDuplica(data) {
    $('#duplicar_item').modal({show: true, backdrop: 'static'}).on('shown.bs.modal', function () {});
}

function makeVertenteProblema() {
    var $text = $('#frmContato select[name="tipo"] option:selected, #formEditarContato select[name="tipo"] option:selected, #form-relatorio select[name="tipo"] option:selected').text();
    var $label = $('#frmContato select[name="tipo"] option:selected, #formEditarContato select[name="tipo"] option:selected, #form-relatorio select[name="tipo"] option:selected').closest('optgroup').prop('label');

    if ($text !== undefined && $text !== '' && $label !== undefined && $label !== '') {
        $('#sTipoInformacao').html($label + '/' + $text);
    }
}

function numberToReal(numero, casas) {
    casas = ((casas != undefined && casas >= 0) ? casas : 2);

    var numero = numero.toFixed(casas).split('.');
    numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.');
    return numero.join(',');
}

function loadDatePickerRegra($apuracao) {
    $('.form-group-periodo').removeClass('hidden');
    $('#date-avaliacao-inicio').datepicker('destroy');
    $('#date-avaliacao-fim').datepicker('destroy');
    $('#datepickerTable').remove();
    switch ($apuracao) {
        case 'ME':
            $.fn.datepicker.dates['qtrs'] = {
                days: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
                daysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
                daysMin: ["Do", "Se", "Te", "Qa", "Qi", "Sx", "Sa"],
                months: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
                monthsShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
                today: "Today",
                clear: "Clear",
                format: "dd/mm/yyyy",
                titleFormat: "MM yyyy",
                /* Leverages same syntax as 'format' */
                weekStart: 0
            };

            $('#date-avaliacao-inicio').datepicker({
                format: "MM/yyyy",
                minViewMode: 1,
                autoclose: true,
                language: "qtrs",
                forceParse: false,
                container: '.container-datepicker-inicio',
                orientation: 'left'
            }).on("show", function (event) {

                $(".month").each(function (index, element) {
                    if (index > 11) $(element).hide();
                });
            });

            $('#date-avaliacao-fim').datepicker({
                format: "MM/yyyy",
                minViewMode: 1,
                autoclose: true,
                language: "qtrs",
                forceParse: false,
                container: '.container-datepicker-fim',
                orientation: 'left'
            }).on("show", function (event) {

                $(".month").each(function (index, element) {
                    if (index > 11) $(element).hide();
                });
            });
            break;
        case 'BI':
            $.fn.datepicker.dates['qtrs'] = {
                days: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
                daysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
                daysMin: ["Do", "Se", "Te", "Qa", "Qi", "Sx", "Sa"],
                months: ["1º Bi", "2º Bi", "3º Bi", "4º Bi", "5º Bi", "6º Bi", "", "", "", "", "", ""],
                monthsShort: ["Jan&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fev", "Mar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Abr", "Mai&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Jun", "Jul&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ago", "Set&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Out", "Nov&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dez", "", "", "", "", "", ""],
                today: "Today",
                clear: "Clear",
                format: "dd/mm/yyyy",
                titleFormat: "MM yyyy",
                /* Leverages same syntax as 'format' */
                weekStart: 0
            };

            $('#date-avaliacao-inicio').datepicker({
                format: "MM/yyyy",
                minViewMode: 1,
                autoclose: true,
                language: "qtrs",
                forceParse: false,
                container: '.container-datepicker-inicio',
                orientation: 'left'
            }).on("show", function (event) {

                $(".month").each(function (index, element) {
                    $(element).show();
                    if (index > 5) {
                        $(element).hide();
                    }
                });

            });

            $('#date-avaliacao-fim').datepicker({
                format: "MM/yyyy",
                minViewMode: 1,
                autoclose: true,
                language: "qtrs",
                forceParse: false,
                container: '.container-datepicker-fim',
                orientation: 'left'
            }).on("show", function (event) {

                $(".month").each(function (index, element) {
                    $(element).show();
                    if (index > 5) {
                        $(element).hide();
                    }
                });

            });

            $('head').append('<style id="datepickerTable">.datepicker table tr td span { width: 100%; }</style>');
            break;
        case 'TR':
            $.fn.datepicker.dates['qtrs'] = {
                days: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
                daysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
                daysMin: ["Do", "Se", "Te", "Qa", "Qi", "Sx", "Sa"],
                months: ["1º Tri", "2º Tri", "3º Tri", "4º Tri", "", "", "", "", "", "", "", ""],
                monthsShort: ["Jan&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fev&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mar", "Abr&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mai&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Jun", "Jul&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ago&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Set", "Out&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Nov&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dez", "", "", "", "", "", "", "", ""],
                today: "Today",
                clear: "Clear",
                format: "dd/mm/yyyy",
                titleFormat: "MM yyyy",
                orientation: "auto",
                /* Leverages same syntax as 'format' */
                weekStart: 0
            };

            $('#date-avaliacao-inicio').datepicker({
                format: "MM/yyyy",
                minViewMode: 1,
                autoclose: true,
                language: "qtrs",
                forceParse: false,
                container: '.container-datepicker-inicio',
                orientation: 'left'
            }).on("show", function (event) {

                $(".month").each(function (index, element) {
                    $(element).show();
                    if (index > 3) {
                        $(element).hide();
                    }
                });

            });

            $('#date-avaliacao-fim').datepicker({
                format: "MM/yyyy",
                minViewMode: 1,
                autoclose: true,
                language: "qtrs",
                forceParse: false,
                container: '.container-datepicker-fim',
                orientation: 'left'
            }).on("show", function (event) {

                $(".month").each(function (index, element) {
                    $(element).show();
                    if (index > 3) {
                        $(element).hide();
                    }
                });

            });

            $('head').append('<style id="datepickerTable">.datepicker table tr td span { width: 100%; }</style>');
            break;
        case 'SE':
            $.fn.datepicker.dates['qtrs'] = {
                days: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
                daysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
                daysMin: ["Do", "Se", "Te", "Qa", "Qi", "Sx", "Sa"],
                months: ["1º Sem", "2º Sem", "", "", "", "", "", "", "", "", "", ""],
                monthsShort: ["Jan&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fev&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Abr&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mai&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Jun", "Jul&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ago&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Set&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Out&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Nov&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dez", "", "", "", "", "", "", "", "", "", ""],
                today: "Today",
                clear: "Clear",
                format: "dd/mm/yyyy",
                titleFormat: "MM yyyy",
                /* Leverages same syntax as 'format' */
                weekStart: 0
            };

            $('#date-avaliacao-inicio').datepicker({
                format: "MM/yyyy",
                minViewMode: 1,
                autoclose: true,
                language: "qtrs",
                forceParse: false,
                container: '.container-datepicker-inicio',
                orientation: 'left'
            }).on("show", function (event) {

                $(".month").each(function (index, element) {
                    $(element).show();
                    if (index > 1) {
                        $(element).hide();
                    }
                });

            });

            $('#date-avaliacao-fim').datepicker({
                format: "MM/yyyy",
                minViewMode: 1,
                autoclose: true,
                language: "qtrs",
                forceParse: false,
                container: '.container-datepicker-fim',
                orientation: 'left'
            }).on("show", function (event) {

                $(".month").each(function (index, element) {
                    $(element).show();
                    if (index > 1) {
                        $(element).hide();
                    }
                });

            });

            $('head').append('<style id="datepickerTable">.datepicker table tr td span { width: 100%; }</style>');
            break;
    }
}

function showAlertCampanhaPedido($i, $keys, $campanhas) {
    if ($i >= 0) {
        var $item = $campanhas[$keys[$i]];

        if ($item.visualizacao <= 2) {
            var $html = '<small>' + b64DecodeUnicode($item.descricao) + '</small><br><img src="/img/campanhas/' + $item.imagem + '" width="200" height="200">';
            swal({
                    html: true,
                    title: $item.titulo,
                    text: $html
                },
                function () {
                    swal.close();
                    setTimeout(function () {
                        showAlertCampanhaPedido($i - 1, $keys, $campanhas);
                    }, 1500);
                }
            );
        } else {
            showAlertCampanhaPedido($i - 1, $keys, $campanhas);
        }
    }
}

function b64EncodeUnicode(str) {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
            return String.fromCharCode('0x' + p1);
        }));
}

function b64DecodeUnicode(str) {
    try {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(atob(str).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    } catch (error) {
        return atob(str);
    }
}

function sendemailpedido(pedido, eVendedor) {
    var url = '/distribuidor/pedido/sendemailpedido/' + pedido + '/' + eVendedor;

    return $.get(url, function (data) {
        if (data['status']) {
            return true;
        } else {
            return false;
        }
    }, "JSON");
}

function isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if (charCode == 47){
        return true;
    }

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
}

function daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
}

(function ($) {
    $.fn.serializeObject = function () {

        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (this.name.indexOf('[') !== -1 && this.value !== '') {
                var name = this.name.replace('[', '').replace(']', '');

                if (o[name] === undefined) {
                    o[name] = [];
                }

                o[name].push(this.value);
            } else {
                if (o[this.name]) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || '');
                } else {
                    o[this.name] = this.value || '';
                }
            }
        });
        return o;
    };
})(jQuery);
